/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Any: any;
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: string;
  /** The `LocalDate` scalar type represents a ISO date string, represented as UTF-8 character sequences YYYY-MM-DD. The scalar follows the specification defined in RFC3339 */
  LocalDate: any;
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: any;
  UUID: string;
};

/** What deleting the current account would do to an organisation it owns. */
export type AccountDeletionOrganisationSummary = {
  __typename?: 'AccountDeletionOrganisationSummary';
  id: Scalars['UUID'];
  isAutocreated: Scalars['Boolean'];
  /** Members other than the current user. */
  memberCount: Scalars['Int'];
  name: Scalars['String'];
  outcome: OrganisationOwnerDepartureOutcome;
  testCount: Scalars['Int'];
};

/** What deleting the current account would involve. Informational; never used to block. */
export type AccountDeletionPreview = {
  __typename?: 'AccountDeletionPreview';
  ownedOrganisations: Array<AccountDeletionOrganisationSummary>;
  /** Whether a current password must be supplied to confirm. */
  requiresPassword: Scalars['Boolean'];
  /** Soil tests recorded by this user; retained by their organisations. */
  testCount: Scalars['Int'];
};

export enum AccountDeletionStatus {
  Completed = 'COMPLETED',
  PurgePending = 'PURGE_PENDING'
}

export type ActiveFirmware = {
  __typename?: 'ActiveFirmware';
  byteLength: Scalars['Long'];
  downloadUrl: Scalars['String'];
  downloadUrlExpiresAt: Scalars['DateTime'];
  fileName: Scalars['String'];
  id: Scalars['UUID'];
  sha256: Scalars['String'];
  version: Scalars['String'];
};

/** Input for adding a cassette entitlement adjustment. */
export type AddCassetteEntitlementAdjustmentInput = {
  cassetteId: Scalars['UUID'];
  customerTestDelta: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
  reasonCode: Scalars['String'];
};

/** Input for enabling a target locale system wide and returning the requested file summary. */
export type AddLocalisationTargetLocaleInput = {
  fileName: Scalars['String'];
  locale: Scalars['String'];
};

export type AdminSetUserPasswordInput = {
  password: Scalars['String'];
  userId: Scalars['UUID'];
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

/** A persisted audit log entry. */
export type AuditLog = {
  __typename?: 'AuditLog';
  actingUser?: Maybe<User>;
  /** Audit action type. */
  actionType: Scalars['String'];
  /** Additional structured context as JSON. */
  additionalContext: Scalars['String'];
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Optional notes. */
  notes?: Maybe<Scalars['String']>;
  /** Optional reason. */
  reason?: Maybe<Scalars['String']>;
  /** Optional target entity ID. */
  targetEntityId?: Maybe<Scalars['UUID']>;
  /** Optional target entity type. */
  targetEntityType?: Maybe<Scalars['String']>;
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** A persisted audit log entry. */
export type AuditLogFilterInput = {
  /** Audit action type. */
  actionType?: InputMaybe<StringOperationFilterInput>;
  /** Additional structured context as JSON. */
  additionalContext?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AuditLogFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Optional notes. */
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AuditLogFilterInput>>;
  /** Optional reason. */
  reason?: InputMaybe<StringOperationFilterInput>;
  /** Optional target entity ID. */
  targetEntityId?: InputMaybe<UuidOperationFilterInput>;
  /** Optional target entity type. */
  targetEntityType?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A persisted audit log entry. */
export type AuditLogSortInput = {
  /** Audit action type. */
  actionType?: InputMaybe<SortEnumType>;
  /** Additional structured context as JSON. */
  additionalContext?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Optional notes. */
  notes?: InputMaybe<SortEnumType>;
  /** Optional reason. */
  reason?: InputMaybe<SortEnumType>;
  /** Optional target entity ID. */
  targetEntityId?: InputMaybe<SortEnumType>;
  /** Optional target entity type. */
  targetEntityType?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AuditLogsConnection = {
  __typename?: 'AuditLogsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AuditLogsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AuditLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AuditLogsEdge = {
  __typename?: 'AuditLogsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AuditLog;
};

export type BackgroundJobStatus = {
  __typename?: 'BackgroundJobStatus';
  predictionBacklog: PredictionBacklogStatus;
  processingCount: Scalars['Int'];
  processingJobs: Array<ProcessingBackgroundJob>;
  queuedByType: Array<QueuedBackgroundJobType>;
  queuedCount: Scalars['Int'];
  scheduledCount: Scalars['Int'];
};

/** A batch (unique by name and batch number). */
export type Batch = {
  __typename?: 'Batch';
  /** Unique batch number. */
  batchNumber: Scalars['String'];
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String'];
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Batch description. */
  description?: Maybe<Scalars['String']>;
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** A batch (unique by name and batch number). */
export type BatchFilterInput = {
  and?: InputMaybe<Array<BatchFilterInput>>;
  /** Unique batch number. */
  batchNumber?: InputMaybe<StringOperationFilterInput>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Batch description. */
  description?: InputMaybe<StringOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BatchFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A batch (unique by name and batch number). */
export type BatchSortInput = {
  /** Unique batch number. */
  batchNumber?: InputMaybe<SortEnumType>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Batch description. */
  description?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BatchesConnection = {
  __typename?: 'BatchesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BatchesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Batch>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BatchesEdge = {
  __typename?: 'BatchesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Batch;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  neq?: InputMaybe<Scalars['Boolean']>;
};

/** A cassette. */
export type Cassette = {
  __typename?: 'Cassette';
  allocatedCustomerTests: Scalars['Int'];
  /** Number of failing sensor checks (non-debug). */
  badSensorCount: Scalars['Int'];
  baseCustomerTests: Scalars['Int'];
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  currentCassetteExtraAllocatableTests: Scalars['Int'];
  entitlementAdjustments?: Maybe<EntitlementAdjustmentsConnection>;
  /** Expiry date. */
  expiryDate: Scalars['DateTime'];
  /** Extra JSON metadata. */
  extraMetadata: Scalars['String'];
  /** Number of passing sensor checks (non-debug). */
  goodSensorCount: Scalars['Int'];
  hasOpenOverflowWarning: Scalars['Boolean'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  lastUsedBy?: Maybe<CassetteLastUsedInfo>;
  manualCustomerTestAdjustments: Scalars['Int'];
  /** Manufacture date. */
  manufactureDate: Scalars['DateTime'];
  /** Maximum index time in seconds. */
  maxIndexTimeSeconds: Scalars['Float'];
  /** Number of sensors. */
  numSensors: Scalars['Int'];
  openOverflowRequestedTests: Scalars['Int'];
  overflowRequests?: Maybe<OverflowRequestsConnection>;
  physicalSensorsUsed: Scalars['Int'];
  remainingCustomerTests: Scalars['Int'];
  remainingPhysicalSensors: Scalars['Int'];
  /** Sensor check UUID. */
  sensorCheckUuid: Scalars['UUID'];
  serialNumber?: Maybe<SerialNumber>;
  /** Soil test UUID. */
  soilTestUuid: Scalars['UUID'];
  /** TRH type. */
  trhType: TrhType;
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
  usedCustomerTests: Scalars['Int'];
};


/** A cassette. */
export type CassetteEntitlementAdjustmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CassetteEntitlementAdjustmentSortInput>>;
  where?: InputMaybe<CassetteEntitlementAdjustmentFilterInput>;
};


/** A cassette. */
export type CassetteOverflowRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CassetteOverflowRequestSortInput>>;
  where?: InputMaybe<CassetteOverflowRequestFilterInput>;
};

/** A cassette-local customer entitlement adjustment. */
export type CassetteEntitlementAdjustment = {
  __typename?: 'CassetteEntitlementAdjustment';
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Signed change in customer test entitlement. */
  customerTestDelta: Scalars['Int'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Optional notes. */
  notes?: Maybe<Scalars['String']>;
  /** Adjustment reason code. */
  reasonCode: Scalars['String'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** A cassette-local customer entitlement adjustment. */
export type CassetteEntitlementAdjustmentFilterInput = {
  and?: InputMaybe<Array<CassetteEntitlementAdjustmentFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Signed change in customer test entitlement. */
  customerTestDelta?: InputMaybe<IntOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Optional notes. */
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CassetteEntitlementAdjustmentFilterInput>>;
  /** Adjustment reason code. */
  reasonCode?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A cassette-local customer entitlement adjustment. */
export type CassetteEntitlementAdjustmentSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Signed change in customer test entitlement. */
  customerTestDelta?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Optional notes. */
  notes?: InputMaybe<SortEnumType>;
  /** Adjustment reason code. */
  reasonCode?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A cassette. */
export type CassetteFilterInput = {
  and?: InputMaybe<Array<CassetteFilterInput>>;
  /** Number of failing sensor checks (non-debug). */
  badSensorCount?: InputMaybe<IntOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Expiry date. */
  expiryDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Extra JSON metadata. */
  extraMetadata?: InputMaybe<StringOperationFilterInput>;
  /** Number of passing sensor checks (non-debug). */
  goodSensorCount?: InputMaybe<IntOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Manufacture date. */
  manufactureDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Maximum index time in seconds. */
  maxIndexTimeSeconds?: InputMaybe<FloatOperationFilterInput>;
  /** Number of sensors. */
  numSensors?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CassetteFilterInput>>;
  /** Sensor check UUID. */
  sensorCheckUuid?: InputMaybe<UuidOperationFilterInput>;
  /** Soil test UUID. */
  soilTestUuid?: InputMaybe<UuidOperationFilterInput>;
  /** TRH type. */
  trhType?: InputMaybe<TrhTypeOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type CassetteLastUsedInfo = {
  __typename?: 'CassetteLastUsedInfo';
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  usedAt: Scalars['DateTime'];
};

export type CassetteListSummary = {
  __typename?: 'CassetteListSummary';
  allocatedCustomerTests: Scalars['Int'];
  openOverflowWarningCount: Scalars['Int'];
  provisionedCount: Scalars['Int'];
  remainingCustomerTests: Scalars['Int'];
};

/** A request to carry owed tests forward from an exhausted cassette. */
export type CassetteOverflowRequest = {
  __typename?: 'CassetteOverflowRequest';
  cassette?: Maybe<Cassette>;
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Optional notes. */
  notes?: Maybe<Scalars['String']>;
  /** Outstanding tests still to be fulfilled. */
  outstandingTests: Scalars['Int'];
  /** Reason code. */
  reasonCode: Scalars['String'];
  /** Requested tests to carry forward. */
  requestedTests: Scalars['Int'];
  /** When the request was resolved. */
  resolvedAt?: Maybe<Scalars['DateTime']>;
  /** Current request status. */
  status: Scalars['String'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** A request to carry owed tests forward from an exhausted cassette. */
export type CassetteOverflowRequestFilterInput = {
  and?: InputMaybe<Array<CassetteOverflowRequestFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Optional notes. */
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CassetteOverflowRequestFilterInput>>;
  /** Outstanding tests still to be fulfilled. */
  outstandingTests?: InputMaybe<IntOperationFilterInput>;
  /** Reason code. */
  reasonCode?: InputMaybe<StringOperationFilterInput>;
  /** Requested tests to carry forward. */
  requestedTests?: InputMaybe<IntOperationFilterInput>;
  /** When the request was resolved. */
  resolvedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Current request status. */
  status?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A request to carry owed tests forward from an exhausted cassette. */
export type CassetteOverflowRequestSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Optional notes. */
  notes?: InputMaybe<SortEnumType>;
  /** Outstanding tests still to be fulfilled. */
  outstandingTests?: InputMaybe<SortEnumType>;
  /** Reason code. */
  reasonCode?: InputMaybe<SortEnumType>;
  /** Requested tests to carry forward. */
  requestedTests?: InputMaybe<SortEnumType>;
  /** When the request was resolved. */
  resolvedAt?: InputMaybe<SortEnumType>;
  /** Current request status. */
  status?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A cassette. */
export type CassetteSortInput = {
  /** Number of failing sensor checks (non-debug). */
  badSensorCount?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Expiry date. */
  expiryDate?: InputMaybe<SortEnumType>;
  /** Extra JSON metadata. */
  extraMetadata?: InputMaybe<SortEnumType>;
  /** Number of passing sensor checks (non-debug). */
  goodSensorCount?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Manufacture date. */
  manufactureDate?: InputMaybe<SortEnumType>;
  /** Maximum index time in seconds. */
  maxIndexTimeSeconds?: InputMaybe<SortEnumType>;
  /** Number of sensors. */
  numSensors?: InputMaybe<SortEnumType>;
  /** Sensor check UUID. */
  sensorCheckUuid?: InputMaybe<SortEnumType>;
  /** Soil test UUID. */
  soilTestUuid?: InputMaybe<SortEnumType>;
  /** TRH type. */
  trhType?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CassettesConnection = {
  __typename?: 'CassettesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CassettesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Cassette>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CassettesEdge = {
  __typename?: 'CassettesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Cassette;
};

export type ChangeOwnPasswordInput = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
};

/** A connection to a list of items. */
export type ChunksConnection = {
  __typename?: 'ChunksConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ChunksEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UploadChunk>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ChunksEdge = {
  __typename?: 'ChunksEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UploadChunk;
};

/** Input for copying a trained indicator to another model. */
export type CopyTrainedIndicatorInput = {
  /** Target MLModel ID. */
  targetModelId: Scalars['UUID'];
  /** Source trained indicator ID. */
  trainedIndicatorId: Scalars['UUID'];
};

/** A cover crop option (unique by normalized name). */
export type CoverCrop = {
  __typename?: 'CoverCrop';
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String'];
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** A cover crop option (unique by normalized name). */
export type CoverCropFilterInput = {
  and?: InputMaybe<Array<CoverCropFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CoverCropFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A cover crop option (unique by normalized name). */
export type CoverCropSortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CoverCropsConnection = {
  __typename?: 'CoverCropsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CoverCropsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CoverCrop>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CoverCropsEdge = {
  __typename?: 'CoverCropsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CoverCrop;
};

export type CreateAccountWithPasswordInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

/** Input for creating a Batch. */
export type CreateBatchInput = {
  batchNumber: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Input for creating a Cassette. */
export type CreateCassetteInput = {
  expiryDate: Scalars['DateTime'];
  extraMetadata?: InputMaybe<Scalars['String']>;
  manufactureDate: Scalars['DateTime'];
  maxIndexTimeSeconds: Scalars['Float'];
  numSensors: Scalars['Int'];
  sensorCheckUuid: Scalars['UUID'];
  serialNumberId?: InputMaybe<Scalars['UUID']>;
  soilTestUuid: Scalars['UUID'];
  trhType?: InputMaybe<TrhType>;
};

/** Input for creating an overflow request on an exhausted cassette. */
export type CreateCassetteOverflowRequestInput = {
  cassetteId: Scalars['UUID'];
  notes?: InputMaybe<Scalars['String']>;
  reasonCode: Scalars['String'];
  requestedTests: Scalars['Int'];
};

export type CreateCoverCropInput = {
  /** Display name. */
  name: Scalars['String'];
};

export type CreateCropInput = {
  /** Display name. */
  name: Scalars['String'];
};

export type CreateCropTypeInput = {
  /** Display name. */
  name: Scalars['String'];
};

export type CreateCultivationInput = {
  /** Display name. */
  name: Scalars['String'];
};

export type CreateCustomerInput = {
  /** Lab indicator definition IDs the customer's users may see (required when limitIndicators is true). */
  allowedIndicatorDefinitionIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Cassette IDs to attach (optional). */
  cassetteIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Primary contact email address. */
  contactEmail?: InputMaybe<Scalars['String']>;
  /** Primary contact name. */
  contactName?: InputMaybe<Scalars['String']>;
  /** Primary contact phone number. */
  contactPhone?: InputMaybe<Scalars['String']>;
  /** When the customer relationship began (defaults to now). */
  customerSince?: InputMaybe<Scalars['DateTime']>;
  /** Description. */
  description?: InputMaybe<Scalars['String']>;
  /** ERU IDs to attach (optional). */
  eruIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Whether to limit visible results to the allowed indicator definitions (defaults to false). */
  limitIndicators?: InputMaybe<Scalars['Boolean']>;
  /** Display name. */
  name: Scalars['String'];
  /** Internal notes. */
  notes?: InputMaybe<Scalars['String']>;
  /** Organisation IDs to attach (optional). */
  organisationIds?: InputMaybe<Array<Scalars['UUID']>>;
};

export type CreateEruInput = {
  /** BLE identifier (unique when present). */
  bleId?: InputMaybe<Scalars['String']>;
  /** BLE MAC address (unique when present). */
  bleMac?: InputMaybe<Scalars['String']>;
  /** Internal UUID for the ERU. */
  internalId: Scalars['UUID'];
  /** Display name. */
  name?: InputMaybe<Scalars['String']>;
};

/** Input for creating an Example. */
export type CreateExampleInput = {
  name: Scalars['String'];
};

export type CreateFarmInput = {
  /** Display name. */
  name: Scalars['String'];
  /** Organisation ID. */
  organisationId: Scalars['UUID'];
  /** Owner name. */
  ownerName?: InputMaybe<Scalars['String']>;
  /** Postcode. */
  postcode?: InputMaybe<Scalars['String']>;
};

export type CreateFieldInput = {
  /** Farm ID. */
  farmId: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
};

export type CreateFirmwareInstallLogInput = {
  dfuProductId?: InputMaybe<Scalars['String']>;
  dfuSerialNumber?: InputMaybe<Scalars['String']>;
  eruId?: InputMaybe<Scalars['UUID']>;
  eruName?: InputMaybe<Scalars['String']>;
  firmwareVersionId: Scalars['UUID'];
  fromVersion?: InputMaybe<Scalars['String']>;
  runtimePortName?: InputMaybe<Scalars['String']>;
  runtimeProductId?: InputMaybe<Scalars['String']>;
  runtimeSerialNumber?: InputMaybe<Scalars['String']>;
  technicalLog?: InputMaybe<Scalars['String']>;
  toVersion: Scalars['String'];
};

export type CreateFirmwareInstallLogPayload = {
  __typename?: 'CreateFirmwareInstallLogPayload';
  log: FirmwareInstallLog;
  updateToken: Scalars['String'];
};

/** Input for creating a GPS location. */
export type CreateGpsLocationInput = {
  /** Accuracy in meters. */
  accuracy?: InputMaybe<Scalars['Float']>;
  /** Latitude. */
  latitude: Scalars['Float'];
  /** Longitude. */
  longitude: Scalars['Float'];
};

export type CreateLabIndicatorDefinitionInput = {
  /** Whether to always show this indicator. */
  alwaysShow?: Scalars['Boolean'];
  /** Indicator description. */
  description?: InputMaybe<Scalars['String']>;
  /** Number of decimal places to display. */
  displayDecimalPlaces?: Scalars['Int'];
  /** Optional display name override. */
  displayName?: InputMaybe<Scalars['String']>;
  /** Display name. */
  name: Scalars['String'];
  /** Unit label. */
  unit?: Scalars['String'];
  /** Value type. */
  valueType: LabIndicatorValueType;
};

export type CreateLabResultInput = {
  /** Indicator definition ID. */
  indicatorId: Scalars['UUID'];
  /** Laboratory ID. */
  laboratoryId: Scalars['UUID'];
  /** SoilSample ID. */
  soilSampleId: Scalars['UUID'];
  /** Lab result value. */
  value: Scalars['String'];
};

export type CreateLaboratoryInput = {
  /** Display name. */
  name: Scalars['String'];
};

/** Input for creating a localisation file from a base JSON upload. */
export type CreateLocalisationFileInput = {
  jsonContent: Scalars['String'];
  name: Scalars['String'];
  translationContext?: InputMaybe<Scalars['String']>;
};

export type CreateMlModelInput = {
  /** Display name. */
  name: Scalars['String'];
};

export type CreateOrganisationInput = {
  contactEmail: Scalars['String'];
  contactNumber?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  isAutocreated?: Scalars['Boolean'];
  logoUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  public?: Scalars['Boolean'];
};

export type CreatePesTestInput = {
  /** Cassette ID. */
  cassetteId: Scalars['UUID'];
  /** CropType ID. */
  cropTypeId: Scalars['UUID'];
  /** ERU ID. */
  eruId: Scalars['UUID'];
  /** Whether to exclude from ML. */
  excludeFromMl?: Scalars['Boolean'];
  /** Extra JSON metadata. */
  extraMetadata?: InputMaybe<Scalars['String']>;
  /** Failure reasons. */
  failureReasons?: InputMaybe<Array<Scalars['String']>>;
  /** Field ID (used to derive farm and organisation). */
  fieldId: Scalars['UUID'];
  /** Firmware version. */
  firmwareVersion: Scalars['String'];
  /** GPS accuracy in meters. */
  gpsAccuracy?: InputMaybe<Scalars['Float']>;
  /** GPS latitude. */
  gpsLatitude: Scalars['Float'];
  /** GPS longitude. */
  gpsLongitude: Scalars['Float'];
  /** Whether this test was run in debug mode. */
  isDebug?: Scalars['Boolean'];
  /** Whether this test failed. */
  isFailure?: Scalars['Boolean'];
  /** Whether this test is from a reference zone. */
  isReferenceZone?: Scalars['Boolean'];
  /** Moisture level. */
  moisture: MoistureLevel;
  /** Display name. */
  name: Scalars['String'];
  /** Original model name. */
  originalModelName: Scalars['String'];
  /** Logical run UUID. */
  runId: Scalars['UUID'];
  /** Season. */
  season: Season;
  /** Optional SoilSample ID. */
  soilSampleId?: InputMaybe<Scalars['UUID']>;
  /** Soil texture. */
  soilTexture: SimpleSoilTexture;
  /** SRF UUID. */
  srfUuid: Scalars['UUID'];
  /** Test type. */
  testType: PesTestType;
  /** TRO UUID. */
  troUuid: Scalars['UUID'];
  /** UTC test time. */
  utcTestTime: Scalars['DateTime'];
};

/** Input for creating a ProductType. */
export type CreateProductTypeInput = {
  location: Scalars['String'];
  model: Scalars['String'];
  name: Scalars['String'];
  subType: Scalars['String'];
};

/** Input for creating a report. */
export type CreateReportInput = {
  format?: InputMaybe<ReportFormat>;
  pesTestIds: Array<Scalars['UUID']>;
  recipientEmail?: InputMaybe<Scalars['String']>;
};

/** Input for creating a result. */
export type CreateResultInput = {
  /** Trained indicator ID. */
  indicatorId: Scalars['UUID'];
  /** PESTest ID. */
  pesTestId: Scalars['UUID'];
  /** Result value. */
  value: Scalars['Float'];
};

export type CreateSerialNumberInput = {
  /** Batch ID. */
  batchId: Scalars['UUID'];
  /** Serial number (0-9999999). */
  serialNumber: Scalars['Int'];
  /** Serial range ID. */
  serialRangeId: Scalars['UUID'];
};

export type CreateSerialRangeInput = {
  /** Build description. */
  buildDescription: Scalars['String'];
  /** Build end date. */
  buildEndDate?: InputMaybe<Scalars['DateTime']>;
  /** Build start date. */
  buildStartDate: Scalars['DateTime'];
  /** Inclusive end of the range. */
  endNumber: Scalars['Int'];
  /** Firmware version. */
  firmwareVersion?: InputMaybe<Scalars['String']>;
  /** Notes. */
  notes?: InputMaybe<Scalars['String']>;
  /** Product type ID. */
  productTypeId: Scalars['UUID'];
  /** Inclusive start of the range. */
  startNumber: Scalars['Int'];
};

export type CreateSoilSampleInput = {
  /** CoverCrop ID. */
  coverCropId?: InputMaybe<Scalars['UUID']>;
  /** CropType ID. */
  cropTypeId?: InputMaybe<Scalars['UUID']>;
  /** Cultivation ID. */
  cultivationId?: InputMaybe<Scalars['UUID']>;
  /** Farm ID. */
  farmId?: InputMaybe<Scalars['UUID']>;
  /** Field ID. */
  fieldId?: InputMaybe<Scalars['UUID']>;
  /** Whether farmyard manure (FYM) was applied. */
  fym: Scalars['Boolean'];
  /** GPS latitude. Provide both latitude and longitude to set a location. */
  gpsLatitude?: InputMaybe<Scalars['Float']>;
  /** GPS longitude. Provide both latitude and longitude to set a location. */
  gpsLongitude?: InputMaybe<Scalars['Float']>;
  /** Whether this sample is from a reference zone. */
  isReferenceZone: Scalars['Boolean'];
  /** Last year's crop ID. */
  lastYearCropId?: InputMaybe<Scalars['UUID']>;
  /** Moisture level. */
  moisture?: InputMaybe<MoistureLevel>;
  /** Display name. */
  name: Scalars['String'];
  /** Date the sample was collected. */
  sampleDate?: InputMaybe<Scalars['LocalDate']>;
  /** Season. */
  season?: InputMaybe<Season>;
  /** SoilType ID. */
  soilTypeId?: InputMaybe<Scalars['UUID']>;
  /** Whether straw was removed. */
  strawRemoved: Scalars['Boolean'];
  /** Year before last crop ID. */
  yearBeforeLastCropId?: InputMaybe<Scalars['UUID']>;
};

export type CreateSoilTypeInput = {
  /** Display name. */
  name: Scalars['String'];
};

export type CreateTroFromUnknownInput = {
  /** Display name for the TRO. */
  name: Scalars['String'];
  /** Unknown TRO UUID currently referenced by at least one PES test. */
  uuid: Scalars['UUID'];
};

/** Input for creating a trained indicator. */
export type CreateTrainedIndicatorInput = {
  /** Lab indicator definition ID. */
  indicatorDefinitionId: Scalars['UUID'];
  /** Optional sparse attention inference API model name for this indicator. */
  inferenceModelName?: InputMaybe<Scalars['String']>;
  /** Maximum value. */
  maxValue: Scalars['Float'];
  /** Minimum value. */
  minValue: Scalars['Float'];
  /** MLModel ID. */
  modelId: Scalars['UUID'];
};

/** Input for creating or updating an upload chunk. */
export type CreateUploadChunkInput = {
  chunkIndex: Scalars['Int'];
  data: Scalars['String'];
  uploadRequestId: Scalars['UUID'];
};

/** Input for creating an upload request. */
export type CreateUploadRequestInput = {
  pesTestId: Scalars['UUID'];
  totalChunks: Scalars['Int'];
};

/** Input for creating a What3Words location. */
export type CreateWhat3WordsLocationInput = {
  gpsLatitudeCenter: Scalars['Float'];
  gpsLatitudeNe: Scalars['Float'];
  gpsLatitudeSw: Scalars['Float'];
  gpsLongitudeCenter: Scalars['Float'];
  gpsLongitudeNe: Scalars['Float'];
  gpsLongitudeSw: Scalars['Float'];
  words: Scalars['String'];
};

/** A crop (unique by normalized name). */
export type Crop = {
  __typename?: 'Crop';
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String'];
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** A crop (unique by normalized name). */
export type CropFilterInput = {
  and?: InputMaybe<Array<CropFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CropFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A crop (unique by normalized name). */
export type CropSortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A type of crop/cultivation area (unique by normalized name). */
export type CropType = {
  __typename?: 'CropType';
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String'];
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** A type of crop/cultivation area (unique by normalized name). */
export type CropTypeFilterInput = {
  and?: InputMaybe<Array<CropTypeFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CropTypeFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A type of crop/cultivation area (unique by normalized name). */
export type CropTypeSortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CropTypesConnection = {
  __typename?: 'CropTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CropTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CropType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CropTypesEdge = {
  __typename?: 'CropTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CropType;
};

/** A connection to a list of items. */
export type CropsConnection = {
  __typename?: 'CropsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CropsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Crop>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CropsEdge = {
  __typename?: 'CropsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Crop;
};

/** A cultivation method (unique by normalized name). */
export type Cultivation = {
  __typename?: 'Cultivation';
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String'];
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** A cultivation method (unique by normalized name). */
export type CultivationFilterInput = {
  and?: InputMaybe<Array<CultivationFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CultivationFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A cultivation method (unique by normalized name). */
export type CultivationSortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CultivationsConnection = {
  __typename?: 'CultivationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CultivationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Cultivation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CultivationsEdge = {
  __typename?: 'CultivationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Cultivation;
};

/** A customer. */
export type Customer = {
  __typename?: 'Customer';
  /** Lab indicator definitions this customer's users may see when limitIndicators is enabled. */
  allowedIndicatorDefinitions: Array<LabIndicatorDefinition>;
  cassettes?: Maybe<CassettesConnection>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String'];
  /** Primary contact email address. */
  contactEmail?: Maybe<Scalars['String']>;
  /** Primary contact name. */
  contactName?: Maybe<Scalars['String']>;
  /** Primary contact phone number. */
  contactPhone?: Maybe<Scalars['String']>;
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** When the customer relationship began. */
  customerSince: Scalars['DateTime'];
  /** Description. */
  description?: Maybe<Scalars['String']>;
  erus?: Maybe<ErusConnection>;
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Whether results visible to this customer's (non-staff) users are limited to the allowed indicator definitions. */
  limitIndicators: Scalars['Boolean'];
  /** Display name. */
  name: Scalars['String'];
  /** Internal notes. */
  notes?: Maybe<Scalars['String']>;
  organisations?: Maybe<OrganisationsConnection>;
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};


/** A customer. */
export type CustomerCassettesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CassetteSortInput>>;
  where?: InputMaybe<CassetteFilterInput>;
};


/** A customer. */
export type CustomerErusArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<EruSortInput>>;
  where?: InputMaybe<EruFilterInput>;
};


/** A customer. */
export type CustomerOrganisationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<OrganisationSortInput>>;
  where?: InputMaybe<OrganisationFilterInput>;
};

/** A customer. */
export type CustomerFilterInput = {
  and?: InputMaybe<Array<CustomerFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** Primary contact email address. */
  contactEmail?: InputMaybe<StringOperationFilterInput>;
  /** Primary contact name. */
  contactName?: InputMaybe<StringOperationFilterInput>;
  /** Primary contact phone number. */
  contactPhone?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** When the customer relationship began. */
  customerSince?: InputMaybe<DateTimeOperationFilterInput>;
  /** Description. */
  description?: InputMaybe<StringOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Whether results visible to this customer's (non-staff) users are limited to the allowed indicator definitions. */
  limitIndicators?: InputMaybe<BooleanOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  /** Internal notes. */
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A customer. */
export type CustomerSortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** Primary contact email address. */
  contactEmail?: InputMaybe<SortEnumType>;
  /** Primary contact name. */
  contactName?: InputMaybe<SortEnumType>;
  /** Primary contact phone number. */
  contactPhone?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** When the customer relationship began. */
  customerSince?: InputMaybe<SortEnumType>;
  /** Description. */
  description?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Whether results visible to this customer's (non-staff) users are limited to the allowed indicator definitions. */
  limitIndicators?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** Internal notes. */
  notes?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CustomersConnection = {
  __typename?: 'CustomersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Customer>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CustomersEdge = {
  __typename?: 'CustomersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Customer;
};

export type DailyTestMetrics = {
  __typename?: 'DailyTestMetrics';
  date: Scalars['DateTime'];
  failedSensorChecks: Scalars['Int'];
  soilTests: Scalars['Int'];
  successfulSensorChecks: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type DashboardStats = {
  __typename?: 'DashboardStats';
  currentPeriod: Array<DailyTestMetrics>;
  mapPoints: Array<MapPoint>;
  organisationStats: Array<OrganisationTestStats>;
  previousPeriod: Array<DailyTestMetrics>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
};

export type DeleteOwnAccountInput = {
  /** The account's email address, typed by the user to confirm. */
  confirmationEmail: Scalars['String'];
  /** Required only when the account has a password. */
  currentPassword?: InputMaybe<Scalars['String']>;
};

export type DeleteOwnAccountPayload = {
  __typename?: 'DeleteOwnAccountPayload';
  /** Deletion request id. Safe to quote to support; contains no personal data. */
  reference: Scalars['UUID'];
  status: AccountDeletionStatus;
};

export type DeletePesTestInput = {
  /** Reason for deleting the test. */
  reason: Scalars['String'];
  /** PESTest ID. */
  testId: Scalars['UUID'];
};

/** An ERU device. */
export type Eru = {
  __typename?: 'ERU';
  /** BLE identifier (unique when present). */
  bleId?: Maybe<Scalars['String']>;
  /** BLE MAC address (unique when present). */
  bleMac?: Maybe<Scalars['String']>;
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Internal UUID for the ERU. */
  internalId: Scalars['UUID'];
  /** Display name. */
  name?: Maybe<Scalars['String']>;
  tests?: Maybe<TestsConnection>;
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};


/** An ERU device. */
export type EruTestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<PesTestSortInput>>;
  where?: InputMaybe<PesTestFilterInput>;
};

/** An ERU device. */
export type EruFilterInput = {
  and?: InputMaybe<Array<EruFilterInput>>;
  /** BLE identifier (unique when present). */
  bleId?: InputMaybe<StringOperationFilterInput>;
  /** BLE MAC address (unique when present). */
  bleMac?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Internal UUID for the ERU. */
  internalId?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EruFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** An ERU device. */
export type EruSortInput = {
  /** BLE identifier (unique when present). */
  bleId?: InputMaybe<SortEnumType>;
  /** BLE MAC address (unique when present). */
  bleMac?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Internal UUID for the ERU. */
  internalId?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type EntitlementAdjustmentsConnection = {
  __typename?: 'EntitlementAdjustmentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EntitlementAdjustmentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CassetteEntitlementAdjustment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EntitlementAdjustmentsEdge = {
  __typename?: 'EntitlementAdjustmentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CassetteEntitlementAdjustment;
};

/** A connection to a list of items. */
export type ErusConnection = {
  __typename?: 'ErusConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ErusEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Eru>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ErusEdge = {
  __typename?: 'ErusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Eru;
};

/** A simple example entity from the Example module. */
export type Example = {
  __typename?: 'Example';
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  items?: Maybe<ItemsConnection>;
  /** Display name. */
  name: Scalars['String'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};


/** A simple example entity from the Example module. */
export type ExampleItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<ExampleItemSortInput>>;
  where?: InputMaybe<ExampleItemFilterInput>;
};

/** A simple example entity from the Example module. */
export type ExampleFilterInput = {
  and?: InputMaybe<Array<ExampleFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ExampleFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** An item belonging to an Example. */
export type ExampleItem = {
  __typename?: 'ExampleItem';
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** An item belonging to an Example. */
export type ExampleItemFilterInput = {
  and?: InputMaybe<Array<ExampleItemFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ExampleItemFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** An item belonging to an Example. */
export type ExampleItemSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A simple example entity from the Example module. */
export type ExampleSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ExamplesConnection = {
  __typename?: 'ExamplesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ExamplesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Example>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ExamplesEdge = {
  __typename?: 'ExamplesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Example;
};

/** A connection to a list of items. */
export type FailedItemsConnection = {
  __typename?: 'FailedItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FailedItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FeatureExtractionExportItem>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FailedItemsEdge = {
  __typename?: 'FailedItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FeatureExtractionExportItem;
};

/** A farm. */
export type Farm = {
  __typename?: 'Farm';
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  fields?: Maybe<FieldsConnection>;
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
  organisation?: Maybe<Organisation>;
  /** Owner name. */
  ownerName?: Maybe<Scalars['String']>;
  /** Postcode. */
  postcode?: Maybe<Scalars['String']>;
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};


/** A farm. */
export type FarmFieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<FieldSortInput>>;
  where?: InputMaybe<FieldFilterInput>;
};

/** A farm. */
export type FarmFilterInput = {
  and?: InputMaybe<Array<FarmFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FarmFilterInput>>;
  /** Owner name. */
  ownerName?: InputMaybe<StringOperationFilterInput>;
  /** Postcode. */
  postcode?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A farm. */
export type FarmSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** Owner name. */
  ownerName?: InputMaybe<SortEnumType>;
  /** Postcode. */
  postcode?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type FarmsConnection = {
  __typename?: 'FarmsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FarmsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Farm>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FarmsEdge = {
  __typename?: 'FarmsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Farm;
};

export type FeatureExtractionExportDownload = {
  __typename?: 'FeatureExtractionExportDownload';
  expiresAt: Scalars['DateTime'];
  fileName: Scalars['String'];
  url: Scalars['String'];
};

export enum FeatureExtractionExportDownloadState {
  Available = 'AVAILABLE',
  Expired = 'EXPIRED',
  Unavailable = 'UNAVAILABLE'
}

export type FeatureExtractionExportDownloadStateOperationFilterInput = {
  eq?: InputMaybe<FeatureExtractionExportDownloadState>;
  in?: InputMaybe<Array<FeatureExtractionExportDownloadState>>;
  neq?: InputMaybe<FeatureExtractionExportDownloadState>;
  nin?: InputMaybe<Array<FeatureExtractionExportDownloadState>>;
};

/** The snapshotted state and extraction outcome for one PES test in an export run. */
export type FeatureExtractionExportItem = {
  __typename?: 'FeatureExtractionExportItem';
  attemptCount: Scalars['Int'];
  cacheSourceUri?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  error?: Maybe<Scalars['String']>;
  farmName: Scalars['String'];
  fieldName: Scalars['String'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  sampleDate: Scalars['String'];
  sampleUrl: Scalars['String'];
  startedAt?: Maybe<Scalars['DateTime']>;
  status: FeatureExtractionExportItemStatus;
  /** PES test UUID represented by this row. */
  testId: Scalars['UUID'];
  testName: Scalars['String'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** The snapshotted state and extraction outcome for one PES test in an export run. */
export type FeatureExtractionExportItemFilterInput = {
  and?: InputMaybe<Array<FeatureExtractionExportItemFilterInput>>;
  attemptCount?: InputMaybe<IntOperationFilterInput>;
  cacheSourceUri?: InputMaybe<StringOperationFilterInput>;
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  error?: InputMaybe<StringOperationFilterInput>;
  farmName?: InputMaybe<StringOperationFilterInput>;
  fieldName?: InputMaybe<StringOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<FeatureExtractionExportItemFilterInput>>;
  sampleDate?: InputMaybe<StringOperationFilterInput>;
  sampleUrl?: InputMaybe<StringOperationFilterInput>;
  startedAt?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<FeatureExtractionExportItemStatusOperationFilterInput>;
  /** PES test UUID represented by this row. */
  testId?: InputMaybe<UuidOperationFilterInput>;
  testName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** The snapshotted state and extraction outcome for one PES test in an export run. */
export type FeatureExtractionExportItemSortInput = {
  attemptCount?: InputMaybe<SortEnumType>;
  cacheSourceUri?: InputMaybe<SortEnumType>;
  completedAt?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  error?: InputMaybe<SortEnumType>;
  farmName?: InputMaybe<SortEnumType>;
  fieldName?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  sampleDate?: InputMaybe<SortEnumType>;
  sampleUrl?: InputMaybe<SortEnumType>;
  startedAt?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  /** PES test UUID represented by this row. */
  testId?: InputMaybe<SortEnumType>;
  testName?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

export enum FeatureExtractionExportItemStatus {
  Extracting = 'EXTRACTING',
  Failed = 'FAILED',
  Pending = 'PENDING',
  ReusedCache = 'REUSED_CACHE',
  Succeeded = 'SUCCEEDED'
}

export type FeatureExtractionExportItemStatusOperationFilterInput = {
  eq?: InputMaybe<FeatureExtractionExportItemStatus>;
  in?: InputMaybe<Array<FeatureExtractionExportItemStatus>>;
  neq?: InputMaybe<FeatureExtractionExportItemStatus>;
  nin?: InputMaybe<Array<FeatureExtractionExportItemStatus>>;
};

export enum FeatureExtractionExportMode {
  FromScratch = 'FROM_SCRATCH',
  MissingCurrentVersion = 'MISSING_CURRENT_VERSION'
}

export type FeatureExtractionExportModeOperationFilterInput = {
  eq?: InputMaybe<FeatureExtractionExportMode>;
  in?: InputMaybe<Array<FeatureExtractionExportMode>>;
  neq?: InputMaybe<FeatureExtractionExportMode>;
  nin?: InputMaybe<Array<FeatureExtractionExportMode>>;
};

/** A durable feature-extraction and CSV-export run for one TRO. */
export type FeatureExtractionExportRun = {
  __typename?: 'FeatureExtractionExportRun';
  completedAt?: Maybe<Scalars['DateTime']>;
  completedExtractionCount: Scalars['Int'];
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  csvBucket?: Maybe<Scalars['String']>;
  csvColumnCount?: Maybe<Scalars['Int']>;
  csvFileName?: Maybe<Scalars['String']>;
  csvObjectGeneration?: Maybe<Scalars['String']>;
  csvObjectName?: Maybe<Scalars['String']>;
  csvRowCount?: Maybe<Scalars['Int']>;
  csvSha256?: Maybe<Scalars['String']>;
  csvSizeBytes?: Maybe<Scalars['Long']>;
  csvSourceUri?: Maybe<Scalars['String']>;
  downloadState: FeatureExtractionExportDownloadState;
  errorSummary?: Maybe<Scalars['String']>;
  excludedTestCount: Scalars['Int'];
  failedExtractionCount: Scalars['Int'];
  failedItems?: Maybe<FailedItemsConnection>;
  /** Feature-set version snapshotted when the run started. */
  featureSetVersion: Scalars['String'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  labResultWarningCount: Scalars['Int'];
  mode: FeatureExtractionExportMode;
  queuedExtractionCount: Scalars['Int'];
  /** Email of the superadmin who requested the run. */
  requestedByEmail?: Maybe<Scalars['String']>;
  reusedCacheCount: Scalars['Int'];
  startedAt?: Maybe<Scalars['DateTime']>;
  status: FeatureExtractionExportStatus;
  /** Optional maximum number of valid PES tests selected for this run. */
  testLimit?: Maybe<Scalars['Int']>;
  totalTestCount: Scalars['Int'];
  /** TRO UUID selected for this run. */
  troUuid: Scalars['UUID'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};


/** A durable feature-extraction and CSV-export run for one TRO. */
export type FeatureExtractionExportRunFailedItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<FeatureExtractionExportItemSortInput>>;
  where?: InputMaybe<FeatureExtractionExportItemFilterInput>;
};

/** A durable feature-extraction and CSV-export run for one TRO. */
export type FeatureExtractionExportRunFilterInput = {
  and?: InputMaybe<Array<FeatureExtractionExportRunFilterInput>>;
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  completedExtractionCount?: InputMaybe<IntOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  csvBucket?: InputMaybe<StringOperationFilterInput>;
  csvColumnCount?: InputMaybe<IntOperationFilterInput>;
  csvFileName?: InputMaybe<StringOperationFilterInput>;
  csvObjectGeneration?: InputMaybe<StringOperationFilterInput>;
  csvObjectName?: InputMaybe<StringOperationFilterInput>;
  csvRowCount?: InputMaybe<IntOperationFilterInput>;
  csvSha256?: InputMaybe<StringOperationFilterInput>;
  csvSizeBytes?: InputMaybe<LongOperationFilterInput>;
  csvSourceUri?: InputMaybe<StringOperationFilterInput>;
  downloadState?: InputMaybe<FeatureExtractionExportDownloadStateOperationFilterInput>;
  errorSummary?: InputMaybe<StringOperationFilterInput>;
  excludedTestCount?: InputMaybe<IntOperationFilterInput>;
  failedExtractionCount?: InputMaybe<IntOperationFilterInput>;
  /** Feature-set version snapshotted when the run started. */
  featureSetVersion?: InputMaybe<StringOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  labResultWarningCount?: InputMaybe<IntOperationFilterInput>;
  mode?: InputMaybe<FeatureExtractionExportModeOperationFilterInput>;
  or?: InputMaybe<Array<FeatureExtractionExportRunFilterInput>>;
  queuedExtractionCount?: InputMaybe<IntOperationFilterInput>;
  /** Email of the superadmin who requested the run. */
  requestedByEmail?: InputMaybe<StringOperationFilterInput>;
  reusedCacheCount?: InputMaybe<IntOperationFilterInput>;
  startedAt?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<FeatureExtractionExportStatusOperationFilterInput>;
  /** Optional maximum number of valid PES tests selected for this run. */
  testLimit?: InputMaybe<IntOperationFilterInput>;
  totalTestCount?: InputMaybe<IntOperationFilterInput>;
  /** TRO UUID selected for this run. */
  troUuid?: InputMaybe<UuidOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A durable feature-extraction and CSV-export run for one TRO. */
export type FeatureExtractionExportRunSortInput = {
  completedAt?: InputMaybe<SortEnumType>;
  completedExtractionCount?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  csvBucket?: InputMaybe<SortEnumType>;
  csvColumnCount?: InputMaybe<SortEnumType>;
  csvFileName?: InputMaybe<SortEnumType>;
  csvObjectGeneration?: InputMaybe<SortEnumType>;
  csvObjectName?: InputMaybe<SortEnumType>;
  csvRowCount?: InputMaybe<SortEnumType>;
  csvSha256?: InputMaybe<SortEnumType>;
  csvSizeBytes?: InputMaybe<SortEnumType>;
  csvSourceUri?: InputMaybe<SortEnumType>;
  downloadState?: InputMaybe<SortEnumType>;
  errorSummary?: InputMaybe<SortEnumType>;
  excludedTestCount?: InputMaybe<SortEnumType>;
  failedExtractionCount?: InputMaybe<SortEnumType>;
  /** Feature-set version snapshotted when the run started. */
  featureSetVersion?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  labResultWarningCount?: InputMaybe<SortEnumType>;
  mode?: InputMaybe<SortEnumType>;
  queuedExtractionCount?: InputMaybe<SortEnumType>;
  /** Email of the superadmin who requested the run. */
  requestedByEmail?: InputMaybe<SortEnumType>;
  reusedCacheCount?: InputMaybe<SortEnumType>;
  startedAt?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  /** Optional maximum number of valid PES tests selected for this run. */
  testLimit?: InputMaybe<SortEnumType>;
  totalTestCount?: InputMaybe<SortEnumType>;
  /** TRO UUID selected for this run. */
  troUuid?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type FeatureExtractionExportRunsConnection = {
  __typename?: 'FeatureExtractionExportRunsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FeatureExtractionExportRunsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FeatureExtractionExportRun>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FeatureExtractionExportRunsEdge = {
  __typename?: 'FeatureExtractionExportRunsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FeatureExtractionExportRun;
};

export enum FeatureExtractionExportStatus {
  Completed = 'COMPLETED',
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  Extracting = 'EXTRACTING',
  Failed = 'FAILED',
  GeneratingCsv = 'GENERATING_CSV',
  Preparing = 'PREPARING'
}

export type FeatureExtractionExportStatusOperationFilterInput = {
  eq?: InputMaybe<FeatureExtractionExportStatus>;
  in?: InputMaybe<Array<FeatureExtractionExportStatus>>;
  neq?: InputMaybe<FeatureExtractionExportStatus>;
  nin?: InputMaybe<Array<FeatureExtractionExportStatus>>;
};

/** A field. */
export type Field = {
  __typename?: 'Field';
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  farm?: Maybe<Farm>;
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** A field. */
export type FieldFilterInput = {
  and?: InputMaybe<Array<FieldFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FieldFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A field. */
export type FieldSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type FieldsConnection = {
  __typename?: 'FieldsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FieldsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Field>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FieldsEdge = {
  __typename?: 'FieldsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Field;
};

export type FirmwareInstallLog = {
  __typename?: 'FirmwareInstallLog';
  completedAt?: Maybe<Scalars['DateTime']>;
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  dfuProductId?: Maybe<Scalars['String']>;
  dfuSerialNumber?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  eru?: Maybe<Eru>;
  eruName?: Maybe<Scalars['String']>;
  firmwareVersion?: Maybe<FirmwareVersion>;
  fromVersion?: Maybe<Scalars['String']>;
  /** Unique identifier. */
  id: Scalars['UUID'];
  runtimePortName?: Maybe<Scalars['String']>;
  runtimeProductId?: Maybe<Scalars['String']>;
  runtimeSerialNumber?: Maybe<Scalars['String']>;
  status: FirmwareInstallLogStatus;
  technicalLog?: Maybe<Scalars['String']>;
  toVersion: Scalars['String'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};

export type FirmwareInstallLogFilterInput = {
  and?: InputMaybe<Array<FirmwareInstallLogFilterInput>>;
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  dfuProductId?: InputMaybe<StringOperationFilterInput>;
  dfuSerialNumber?: InputMaybe<StringOperationFilterInput>;
  errorMessage?: InputMaybe<StringOperationFilterInput>;
  eruName?: InputMaybe<StringOperationFilterInput>;
  fromVersion?: InputMaybe<StringOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<FirmwareInstallLogFilterInput>>;
  runtimePortName?: InputMaybe<StringOperationFilterInput>;
  runtimeProductId?: InputMaybe<StringOperationFilterInput>;
  runtimeSerialNumber?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<FirmwareInstallLogStatusOperationFilterInput>;
  technicalLog?: InputMaybe<StringOperationFilterInput>;
  toVersion?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type FirmwareInstallLogSortInput = {
  completedAt?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  dfuProductId?: InputMaybe<SortEnumType>;
  dfuSerialNumber?: InputMaybe<SortEnumType>;
  errorMessage?: InputMaybe<SortEnumType>;
  eruName?: InputMaybe<SortEnumType>;
  fromVersion?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  runtimePortName?: InputMaybe<SortEnumType>;
  runtimeProductId?: InputMaybe<SortEnumType>;
  runtimeSerialNumber?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  technicalLog?: InputMaybe<SortEnumType>;
  toVersion?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

export enum FirmwareInstallLogStatus {
  Downloading = 'DOWNLOADING',
  Failed = 'FAILED',
  Flashing = 'FLASHING',
  Requested = 'REQUESTED',
  Succeeded = 'SUCCEEDED'
}

export type FirmwareInstallLogStatusOperationFilterInput = {
  eq?: InputMaybe<FirmwareInstallLogStatus>;
  in?: InputMaybe<Array<FirmwareInstallLogStatus>>;
  neq?: InputMaybe<FirmwareInstallLogStatus>;
  nin?: InputMaybe<Array<FirmwareInstallLogStatus>>;
};

/** A connection to a list of items. */
export type FirmwareInstallLogsConnection = {
  __typename?: 'FirmwareInstallLogsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FirmwareInstallLogsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FirmwareInstallLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FirmwareInstallLogsEdge = {
  __typename?: 'FirmwareInstallLogsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FirmwareInstallLog;
};

export type FirmwareVersion = {
  __typename?: 'FirmwareVersion';
  blobContainer: Scalars['String'];
  blobName: Scalars['String'];
  blobUrl: Scalars['String'];
  byteLength: Scalars['Long'];
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  fileName: Scalars['String'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  installCount: Scalars['Int'];
  isActive: Scalars['Boolean'];
  sha256: Scalars['String'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
  uploadedByUser?: Maybe<User>;
  version: Scalars['String'];
};

export type FirmwareVersionFilterInput = {
  and?: InputMaybe<Array<FirmwareVersionFilterInput>>;
  blobContainer?: InputMaybe<StringOperationFilterInput>;
  blobName?: InputMaybe<StringOperationFilterInput>;
  blobUrl?: InputMaybe<StringOperationFilterInput>;
  byteLength?: InputMaybe<LongOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<FirmwareVersionFilterInput>>;
  sha256?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  version?: InputMaybe<StringOperationFilterInput>;
};

export type FirmwareVersionSortInput = {
  blobContainer?: InputMaybe<SortEnumType>;
  blobName?: InputMaybe<SortEnumType>;
  blobUrl?: InputMaybe<SortEnumType>;
  byteLength?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  fileName?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  sha256?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type FirmwareVersionsConnection = {
  __typename?: 'FirmwareVersionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FirmwareVersionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FirmwareVersion>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FirmwareVersionsEdge = {
  __typename?: 'FirmwareVersionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FirmwareVersion;
};

export type FloatOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  neq?: InputMaybe<Scalars['Float']>;
  ngt?: InputMaybe<Scalars['Float']>;
  ngte?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  nlt?: InputMaybe<Scalars['Float']>;
  nlte?: InputMaybe<Scalars['Float']>;
};

/** Input for fulfilling an overflow request from a future cassette. */
export type FulfilCassetteOverflowRequestInput = {
  fulfilledByCassetteId: Scalars['UUID'];
  fulfilledTests: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
  overflowRequestId: Scalars['UUID'];
};

/** A GPS location. */
export type GpsLocation = {
  __typename?: 'GPSLocation';
  /** Accuracy in meters. */
  accuracy?: Maybe<Scalars['Float']>;
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Latitude. */
  latitude: Scalars['Float'];
  /** Longitude. */
  longitude: Scalars['Float'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
  what3Words?: Maybe<What3WordsLocation>;
};

/** A GPS location. */
export type GpsLocationFilterInput = {
  /** Accuracy in meters. */
  accuracy?: InputMaybe<FloatOperationFilterInput>;
  and?: InputMaybe<Array<GpsLocationFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Latitude. */
  latitude?: InputMaybe<FloatOperationFilterInput>;
  /** Longitude. */
  longitude?: InputMaybe<FloatOperationFilterInput>;
  or?: InputMaybe<Array<GpsLocationFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A GPS location. */
export type GpsLocationSortInput = {
  /** Accuracy in meters. */
  accuracy?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Latitude. */
  latitude?: InputMaybe<SortEnumType>;
  /** Longitude. */
  longitude?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type GpsLocationsConnection = {
  __typename?: 'GpsLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<GpsLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<GpsLocation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type GpsLocationsEdge = {
  __typename?: 'GpsLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: GpsLocation;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  ngt?: InputMaybe<Scalars['Int']>;
  ngte?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  nlt?: InputMaybe<Scalars['Int']>;
  nlte?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of items. */
export type InviteRequestsConnection = {
  __typename?: 'InviteRequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<InviteRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OrganisationInviteRequest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type InviteRequestsEdge = {
  __typename?: 'InviteRequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: OrganisationInviteRequest;
};

export type InviteUserToOrganisationInput = {
  email: Scalars['String'];
  organisationId: Scalars['UUID'];
};

/** A connection to a list of items. */
export type ItemsConnection = {
  __typename?: 'ItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ExampleItem>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ItemsEdge = {
  __typename?: 'ItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExampleItem;
};

/** A lab indicator definition. */
export type LabIndicatorDefinition = {
  __typename?: 'LabIndicatorDefinition';
  /** Whether to always show this indicator. */
  alwaysShow: Scalars['Boolean'];
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String'];
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Indicator description. */
  description?: Maybe<Scalars['String']>;
  /** Number of decimal places to display. */
  displayDecimalPlaces: Scalars['Int'];
  /** Optional display name override. */
  displayName?: Maybe<Scalars['String']>;
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
  /** Unit label. */
  unit: Scalars['String'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
  /** Value type. */
  valueType: LabIndicatorValueType;
};

/** A lab indicator definition. */
export type LabIndicatorDefinitionFilterInput = {
  /** Whether to always show this indicator. */
  alwaysShow?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<LabIndicatorDefinitionFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Indicator description. */
  description?: InputMaybe<StringOperationFilterInput>;
  /** Number of decimal places to display. */
  displayDecimalPlaces?: InputMaybe<IntOperationFilterInput>;
  /** Optional display name override. */
  displayName?: InputMaybe<StringOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LabIndicatorDefinitionFilterInput>>;
  /** Unit label. */
  unit?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Value type. */
  valueType?: InputMaybe<LabIndicatorValueTypeOperationFilterInput>;
};

/** A lab indicator definition. */
export type LabIndicatorDefinitionSortInput = {
  /** Whether to always show this indicator. */
  alwaysShow?: InputMaybe<SortEnumType>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Indicator description. */
  description?: InputMaybe<SortEnumType>;
  /** Number of decimal places to display. */
  displayDecimalPlaces?: InputMaybe<SortEnumType>;
  /** Optional display name override. */
  displayName?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** Unit label. */
  unit?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
  /** Value type. */
  valueType?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type LabIndicatorDefinitionsConnection = {
  __typename?: 'LabIndicatorDefinitionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LabIndicatorDefinitionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LabIndicatorDefinition>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LabIndicatorDefinitionsEdge = {
  __typename?: 'LabIndicatorDefinitionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: LabIndicatorDefinition;
};

export enum LabIndicatorValueType {
  Categorical = 'CATEGORICAL',
  Continuous = 'CONTINUOUS'
}

export type LabIndicatorValueTypeOperationFilterInput = {
  eq?: InputMaybe<LabIndicatorValueType>;
  in?: InputMaybe<Array<LabIndicatorValueType>>;
  neq?: InputMaybe<LabIndicatorValueType>;
  nin?: InputMaybe<Array<LabIndicatorValueType>>;
};

/** A laboratory result for a soil sample. */
export type LabResult = {
  __typename?: 'LabResult';
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  indicator?: Maybe<LabIndicatorDefinition>;
  laboratory?: Maybe<Laboratory>;
  /** Indicator display name. */
  name: Scalars['String'];
  /** Parsed numeric value when possible. */
  numericValue?: Maybe<Scalars['Float']>;
  soilSample?: Maybe<SoilSample>;
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
  /** Lab result value. */
  value: Scalars['String'];
};

/** A laboratory result for a soil sample. */
export type LabResultFilterInput = {
  and?: InputMaybe<Array<LabResultFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Indicator display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  /** Parsed numeric value when possible. */
  numericValue?: InputMaybe<FloatOperationFilterInput>;
  or?: InputMaybe<Array<LabResultFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Lab result value. */
  value?: InputMaybe<StringOperationFilterInput>;
};

/** A laboratory result for a soil sample. */
export type LabResultSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Indicator display name. */
  name?: InputMaybe<SortEnumType>;
  /** Parsed numeric value when possible. */
  numericValue?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
  /** Lab result value. */
  value?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type LabResultsConnection = {
  __typename?: 'LabResultsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LabResultsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LabResult>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LabResultsEdge = {
  __typename?: 'LabResultsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: LabResult;
};

/** A connection to a list of items. */
export type LaboratoriesConnection = {
  __typename?: 'LaboratoriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LaboratoriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Laboratory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LaboratoriesEdge = {
  __typename?: 'LaboratoriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Laboratory;
};

/** A laboratory (unique by normalized name). */
export type Laboratory = {
  __typename?: 'Laboratory';
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String'];
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** A laboratory (unique by normalized name). */
export type LaboratoryFilterInput = {
  and?: InputMaybe<Array<LaboratoryFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LaboratoryFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A laboratory (unique by normalized name). */
export type LaboratorySortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export type LocalDateOperationFilterInput = {
  eq?: InputMaybe<Scalars['LocalDate']>;
  gt?: InputMaybe<Scalars['LocalDate']>;
  gte?: InputMaybe<Scalars['LocalDate']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']>>>;
  lt?: InputMaybe<Scalars['LocalDate']>;
  lte?: InputMaybe<Scalars['LocalDate']>;
  neq?: InputMaybe<Scalars['LocalDate']>;
  ngt?: InputMaybe<Scalars['LocalDate']>;
  ngte?: InputMaybe<Scalars['LocalDate']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']>>>;
  nlt?: InputMaybe<Scalars['LocalDate']>;
  nlte?: InputMaybe<Scalars['LocalDate']>;
};

/** Admin overview of configured localisation files. */
export type LocalisationAdminOverview = {
  __typename?: 'LocalisationAdminOverview';
  enabledLocaleSummaries: Array<LocalisationEnabledLocaleSummary>;
  enabledLocales: Array<Scalars['String']>;
  files: Array<LocalisationFileSummary>;
};

/** One editable localisation row for a selected file and locale. */
export type LocalisationEditorRow = {
  __typename?: 'LocalisationEditorRow';
  baseValue: Scalars['String'];
  effectiveValue: Scalars['String'];
  isApproved: Scalars['Boolean'];
  isFallback: Scalars['Boolean'];
  isTranslating: Scalars['Boolean'];
  key: Scalars['String'];
  targetValue?: Maybe<Scalars['String']>;
};

/** Editor data for a selected localisation file and locale. */
export type LocalisationEditorView = {
  __typename?: 'LocalisationEditorView';
  fileName: Scalars['String'];
  locale: Scalars['String'];
  rows: Array<LocalisationEditorRow>;
};

/** Summary information about one enabled target locale. */
export type LocalisationEnabledLocaleSummary = {
  __typename?: 'LocalisationEnabledLocaleSummary';
  locale: Scalars['String'];
  setupFailureMessage?: Maybe<Scalars['String']>;
  setupStatus?: Maybe<Scalars['String']>;
  setupUpdatedAt?: Maybe<Scalars['DateTime']>;
};

/** Summary information about a localisation file. */
export type LocalisationFileSummary = {
  __typename?: 'LocalisationFileSummary';
  baseEntryCount: Scalars['Int'];
  name: Scalars['String'];
  setupFailureMessage?: Maybe<Scalars['String']>;
  setupStatus?: Maybe<Scalars['String']>;
  setupUpdatedAt?: Maybe<Scalars['DateTime']>;
  targetLocaleCount: Scalars['Int'];
  targetLocales: Array<Scalars['String']>;
  translationContext?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type LoginWithPasswordInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']>;
  gt?: InputMaybe<Scalars['Long']>;
  gte?: InputMaybe<Scalars['Long']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  lt?: InputMaybe<Scalars['Long']>;
  lte?: InputMaybe<Scalars['Long']>;
  neq?: InputMaybe<Scalars['Long']>;
  ngt?: InputMaybe<Scalars['Long']>;
  ngte?: InputMaybe<Scalars['Long']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  nlt?: InputMaybe<Scalars['Long']>;
  nlte?: InputMaybe<Scalars['Long']>;
};

/** A machine learning model (unique by normalized name). */
export type MlModel = {
  __typename?: 'MLModel';
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String'];
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
  trainedIndicators?: Maybe<TrainedIndicatorsConnection>;
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};


/** A machine learning model (unique by normalized name). */
export type MlModelTrainedIndicatorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<TrainedIndicatorSortInput>>;
  where?: InputMaybe<TrainedIndicatorFilterInput>;
};

/** A machine learning model (unique by normalized name). */
export type MlModelFilterInput = {
  and?: InputMaybe<Array<MlModelFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MlModelFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A machine learning model (unique by normalized name). */
export type MlModelSortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

export type MapPoint = {
  __typename?: 'MapPoint';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  organisationName?: Maybe<Scalars['String']>;
  testId: Scalars['UUID'];
  testName?: Maybe<Scalars['String']>;
  what3Words?: Maybe<Scalars['String']>;
};

export type MarkTestFailedInput = {
  /** Failure reasons. An empty array clears the failure status. */
  failureReasons: Array<Scalars['String']>;
  /** PESTest ID. */
  testId: Scalars['UUID'];
};

/** A connection to a list of items. */
export type MembersConnection = {
  __typename?: 'MembersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MembersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MembersEdge = {
  __typename?: 'MembersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: User;
};

/** A connection to a list of items. */
export type MlModelsConnection = {
  __typename?: 'MlModelsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MlModelsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MlModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MlModelsEdge = {
  __typename?: 'MlModelsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MlModel;
};

export enum MoistureLevel {
  Dry = 'DRY',
  Moist = 'MOIST',
  Wet = 'WET'
}

export type MoistureLevelOperationFilterInput = {
  eq?: InputMaybe<MoistureLevel>;
  in?: InputMaybe<Array<MoistureLevel>>;
  neq?: InputMaybe<MoistureLevel>;
  nin?: InputMaybe<Array<MoistureLevel>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptOrganisationAccessRequest?: Maybe<OrganisationInviteRequest>;
  acceptOrganisationInviteRequest?: Maybe<OrganisationInviteRequest>;
  addCassetteEntitlementAdjustment: CassetteEntitlementAdjustment;
  addLocalisationTargetLocale: LocalisationFileSummary;
  adminSetUserPassword: Scalars['Boolean'];
  changeOwnPassword: Scalars['Boolean'];
  copyTrainedIndicator?: Maybe<TrainedIndicator>;
  createAccountWithPassword?: Maybe<Scalars['String']>;
  createBatch: Batch;
  createCassette: Cassette;
  createCassetteOverflowRequest: CassetteOverflowRequest;
  createCoverCrop: CoverCrop;
  createCrop: Crop;
  createCropType: CropType;
  createCultivation: Cultivation;
  createCustomer: Customer;
  createERU: Eru;
  createExample: Example;
  createFarm: Farm;
  createField: Field;
  createFirmwareInstallLog: CreateFirmwareInstallLogPayload;
  createGPSLocation: GpsLocation;
  createLabIndicatorDefinition: LabIndicatorDefinition;
  createLabResult: LabResult;
  createLaboratory: Laboratory;
  createLocalisationFile: LocalisationFileSummary;
  createMLModel: MlModel;
  createOrganisation: Organisation;
  createPESTest: PesTest;
  createProductType: ProductType;
  createReport: Report;
  createResult: Result;
  createSerialNumber: SerialNumber;
  createSerialRange: SerialRange;
  createSoilSample: SoilSample;
  createSoilType: SoilType;
  createTROFromUnknown: Tro;
  createTrainedIndicator: TrainedIndicator;
  createUploadChunk: UploadChunk;
  createUploadRequest: UploadRequest;
  createWhat3WordsLocation: What3WordsLocation;
  dedupeLabResults: Scalars['Int'];
  deleteBatch: Scalars['Boolean'];
  deleteCassette: Scalars['Boolean'];
  deleteCoverCrop: Scalars['Boolean'];
  deleteCrop: Scalars['Boolean'];
  deleteCropType: Scalars['Boolean'];
  deleteCultivation: Scalars['Boolean'];
  deleteCustomer: Scalars['Boolean'];
  deleteERU: Scalars['Boolean'];
  deleteExample: Scalars['Boolean'];
  deleteFarm: Scalars['Boolean'];
  deleteField: Scalars['Boolean'];
  deleteGPSLocation: Scalars['Boolean'];
  deleteLabIndicatorDefinition: Scalars['Boolean'];
  deleteLabResult: Scalars['Boolean'];
  deleteLaboratory: Scalars['Boolean'];
  deleteMLModel: Scalars['Boolean'];
  deleteOrganisation: Scalars['Boolean'];
  deleteOwnAccount?: Maybe<DeleteOwnAccountPayload>;
  deletePESTest: Scalars['Boolean'];
  deleteProductType: Scalars['Boolean'];
  deleteResult: Scalars['Boolean'];
  deleteSerialNumber: Scalars['Boolean'];
  deleteSerialRange: Scalars['Boolean'];
  deleteSoilSample: Scalars['Boolean'];
  deleteSoilType: Scalars['Boolean'];
  deleteTrainedIndicator: Scalars['Boolean'];
  deleteWhat3WordsLocation: Scalars['Boolean'];
  denyOrganisationAccessRequest?: Maybe<OrganisationInviteRequest>;
  denyOrganisationInviteRequest?: Maybe<OrganisationInviteRequest>;
  featureExtractionExportDownloadUrl?: Maybe<FeatureExtractionExportDownload>;
  fulfilCassetteOverflowRequest: CassetteOverflowRequest;
  inviteUserToOrganisation: OrganisationInviteRequest;
  loginWithPassword?: Maybe<Scalars['String']>;
  markTestFailed?: Maybe<PesTest>;
  purgePesTestFeatureCache: PesTestFeatureCachePurgeResult;
  purgePesTestFeatureCaches: PesTestFeatureCachePurgeResult;
  queueBackgroundJobDelayTest: Scalars['String'];
  queueBackgroundJobPredictionDelayTest: Scalars['String'];
  queueLocalisationTranslation: Scalars['String'];
  queuePesTestPrediction?: Maybe<PesTest>;
  queuePesTestTargetPredictions: Array<PesTest>;
  queueSemanticKernelDemo: Scalars['String'];
  recordPesTestFeatureCache?: Maybe<PesTestFeatureCache>;
  recoverPesTestFeatureCache?: Maybe<PesTestFeatureCache>;
  redeemMagicLink?: Maybe<Scalars['String']>;
  removeOrganisationMember: Scalars['Boolean'];
  renamePesTest?: Maybe<PesTest>;
  requestMagicLink: Scalars['Boolean'];
  requestOrganisationAccess: OrganisationInviteRequest;
  requestPasswordReset: Scalars['Boolean'];
  resetPasswordWithCode?: Maybe<Scalars['String']>;
  resolveLegacyCachedRunId: Scalars['UUID'];
  sendReport: Scalars['Boolean'];
  setActiveFirmwareVersion?: Maybe<FirmwareVersion>;
  setLocalisationLocaleEnabled: SetLocalisationLocaleEnabledResult;
  setOwnPassword: Scalars['Boolean'];
  setUserRole?: Maybe<User>;
  startFeatureExtractionExport: FeatureExtractionExportRun;
  transferPesTest: PesTest;
  updateBatch?: Maybe<Batch>;
  updateCassette?: Maybe<Cassette>;
  updateCoverCrop?: Maybe<CoverCrop>;
  updateCrop?: Maybe<Crop>;
  updateCropType?: Maybe<CropType>;
  updateCultivation?: Maybe<Cultivation>;
  updateCustomer?: Maybe<Customer>;
  updateERU?: Maybe<Eru>;
  updateExample?: Maybe<Example>;
  updateExcludeFromMl?: Maybe<PesTest>;
  updateFarm?: Maybe<Farm>;
  updateField?: Maybe<Field>;
  updateFirmwareInstallLog: FirmwareInstallLog;
  updateLabIndicatorDefinition?: Maybe<LabIndicatorDefinition>;
  updateLabResult?: Maybe<LabResult>;
  updateLaboratory?: Maybe<Laboratory>;
  updateLocalisationFile: LocalisationFileSummary;
  updateLocalisationTranslation: Scalars['Boolean'];
  updateMLModel?: Maybe<MlModel>;
  updateOrganisation?: Maybe<Organisation>;
  updateOrganisationLogo: Organisation;
  updatePESTest?: Maybe<PesTest>;
  updatePesTestCharacteristics?: Maybe<PesTest>;
  updatePesTestLocation?: Maybe<PesTest>;
  updateProductType?: Maybe<ProductType>;
  updateResult?: Maybe<Result>;
  updateSerialNumber?: Maybe<SerialNumber>;
  updateSerialRange?: Maybe<SerialRange>;
  updateSoilSample?: Maybe<SoilSample>;
  updateSoilType?: Maybe<SoilType>;
  updateTRO?: Maybe<Tro>;
  updateTrainedIndicator?: Maybe<TrainedIndicator>;
  updateUserName: User;
  updateUserProfilePicture: User;
  updateWhat3WordsLocation?: Maybe<What3WordsLocation>;
  uploadFirmware: FirmwareVersion;
};


export type MutationAcceptOrganisationAccessRequestArgs = {
  input: RespondToOrganisationInviteRequestInput;
};


export type MutationAcceptOrganisationInviteRequestArgs = {
  input: RespondToOrganisationInviteRequestInput;
};


export type MutationAddCassetteEntitlementAdjustmentArgs = {
  input: AddCassetteEntitlementAdjustmentInput;
};


export type MutationAddLocalisationTargetLocaleArgs = {
  input: AddLocalisationTargetLocaleInput;
};


export type MutationAdminSetUserPasswordArgs = {
  input: AdminSetUserPasswordInput;
};


export type MutationChangeOwnPasswordArgs = {
  input: ChangeOwnPasswordInput;
};


export type MutationCopyTrainedIndicatorArgs = {
  input: CopyTrainedIndicatorInput;
};


export type MutationCreateAccountWithPasswordArgs = {
  input: CreateAccountWithPasswordInput;
};


export type MutationCreateBatchArgs = {
  input: CreateBatchInput;
};


export type MutationCreateCassetteArgs = {
  input: CreateCassetteInput;
};


export type MutationCreateCassetteOverflowRequestArgs = {
  input: CreateCassetteOverflowRequestInput;
};


export type MutationCreateCoverCropArgs = {
  input: CreateCoverCropInput;
};


export type MutationCreateCropArgs = {
  input: CreateCropInput;
};


export type MutationCreateCropTypeArgs = {
  input: CreateCropTypeInput;
};


export type MutationCreateCultivationArgs = {
  input: CreateCultivationInput;
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
};


export type MutationCreateEruArgs = {
  input: CreateEruInput;
};


export type MutationCreateExampleArgs = {
  input: CreateExampleInput;
};


export type MutationCreateFarmArgs = {
  input: CreateFarmInput;
};


export type MutationCreateFieldArgs = {
  input: CreateFieldInput;
};


export type MutationCreateFirmwareInstallLogArgs = {
  input: CreateFirmwareInstallLogInput;
};


export type MutationCreateGpsLocationArgs = {
  input: CreateGpsLocationInput;
};


export type MutationCreateLabIndicatorDefinitionArgs = {
  input: CreateLabIndicatorDefinitionInput;
};


export type MutationCreateLabResultArgs = {
  input: CreateLabResultInput;
};


export type MutationCreateLaboratoryArgs = {
  input: CreateLaboratoryInput;
};


export type MutationCreateLocalisationFileArgs = {
  input: CreateLocalisationFileInput;
};


export type MutationCreateMlModelArgs = {
  input: CreateMlModelInput;
};


export type MutationCreateOrganisationArgs = {
  input: CreateOrganisationInput;
};


export type MutationCreatePesTestArgs = {
  input: CreatePesTestInput;
};


export type MutationCreateProductTypeArgs = {
  input: CreateProductTypeInput;
};


export type MutationCreateReportArgs = {
  input: CreateReportInput;
};


export type MutationCreateResultArgs = {
  input: CreateResultInput;
};


export type MutationCreateSerialNumberArgs = {
  input: CreateSerialNumberInput;
};


export type MutationCreateSerialRangeArgs = {
  input: CreateSerialRangeInput;
};


export type MutationCreateSoilSampleArgs = {
  input: CreateSoilSampleInput;
};


export type MutationCreateSoilTypeArgs = {
  input: CreateSoilTypeInput;
};


export type MutationCreateTroFromUnknownArgs = {
  input: CreateTroFromUnknownInput;
};


export type MutationCreateTrainedIndicatorArgs = {
  input: CreateTrainedIndicatorInput;
};


export type MutationCreateUploadChunkArgs = {
  input: CreateUploadChunkInput;
};


export type MutationCreateUploadRequestArgs = {
  input: CreateUploadRequestInput;
};


export type MutationCreateWhat3WordsLocationArgs = {
  input: CreateWhat3WordsLocationInput;
};


export type MutationDeleteBatchArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteCassetteArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteCoverCropArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteCropArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteCropTypeArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteCultivationArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteCustomerArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteEruArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteExampleArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteFarmArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteFieldArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteGpsLocationArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteLabIndicatorDefinitionArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteLabResultArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteLaboratoryArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteMlModelArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteOrganisationArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteOwnAccountArgs = {
  input: DeleteOwnAccountInput;
};


export type MutationDeletePesTestArgs = {
  input: DeletePesTestInput;
};


export type MutationDeleteProductTypeArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteResultArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteSerialNumberArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteSerialRangeArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteSoilSampleArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteSoilTypeArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteTrainedIndicatorArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteWhat3WordsLocationArgs = {
  id: Scalars['UUID'];
};


export type MutationDenyOrganisationAccessRequestArgs = {
  input: RespondToOrganisationInviteRequestInput;
};


export type MutationDenyOrganisationInviteRequestArgs = {
  input: RespondToOrganisationInviteRequestInput;
};


export type MutationFeatureExtractionExportDownloadUrlArgs = {
  id: Scalars['UUID'];
};


export type MutationFulfilCassetteOverflowRequestArgs = {
  input: FulfilCassetteOverflowRequestInput;
};


export type MutationInviteUserToOrganisationArgs = {
  input: InviteUserToOrganisationInput;
};


export type MutationLoginWithPasswordArgs = {
  input: LoginWithPasswordInput;
};


export type MutationMarkTestFailedArgs = {
  input: MarkTestFailedInput;
};


export type MutationPurgePesTestFeatureCacheArgs = {
  input: PurgePesTestFeatureCacheInput;
};


export type MutationPurgePesTestFeatureCachesArgs = {
  input: PurgePesTestFeatureCachesInput;
};


export type MutationQueueLocalisationTranslationArgs = {
  input: QueueLocalisationTranslationInput;
};


export type MutationQueuePesTestPredictionArgs = {
  input: QueuePesTestPredictionInput;
};


export type MutationQueuePesTestTargetPredictionsArgs = {
  input: QueuePesTestTargetPredictionsInput;
};


export type MutationRecordPesTestFeatureCacheArgs = {
  input: RecordPesTestFeatureCacheInput;
};


export type MutationRecoverPesTestFeatureCacheArgs = {
  testId: Scalars['UUID'];
};


export type MutationRedeemMagicLinkArgs = {
  input: RedeemMagicLinkInput;
};


export type MutationRemoveOrganisationMemberArgs = {
  input: RemoveOrganisationMemberInput;
};


export type MutationRenamePesTestArgs = {
  input: UpdatePesTestNameInput;
};


export type MutationRequestMagicLinkArgs = {
  input: RequestMagicLinkInput;
};


export type MutationRequestOrganisationAccessArgs = {
  input: RequestOrganisationAccessInput;
};


export type MutationRequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};


export type MutationResetPasswordWithCodeArgs = {
  input: ResetPasswordWithCodeInput;
};


export type MutationResolveLegacyCachedRunIdArgs = {
  input: ResolveLegacyCachedRunIdInput;
};


export type MutationSendReportArgs = {
  input: SendReportInput;
};


export type MutationSetActiveFirmwareVersionArgs = {
  id: Scalars['UUID'];
};


export type MutationSetLocalisationLocaleEnabledArgs = {
  input: SetLocalisationLocaleEnabledInput;
};


export type MutationSetOwnPasswordArgs = {
  input: SetOwnPasswordInput;
};


export type MutationSetUserRoleArgs = {
  input: SetUserRoleInput;
};


export type MutationStartFeatureExtractionExportArgs = {
  input: StartFeatureExtractionExportInput;
};


export type MutationTransferPesTestArgs = {
  input: TransferPesTestInput;
};


export type MutationUpdateBatchArgs = {
  input: UpdateBatchInput;
};


export type MutationUpdateCassetteArgs = {
  input: UpdateCassetteInput;
};


export type MutationUpdateCoverCropArgs = {
  input: UpdateCoverCropInput;
};


export type MutationUpdateCropArgs = {
  input: UpdateCropInput;
};


export type MutationUpdateCropTypeArgs = {
  input: UpdateCropTypeInput;
};


export type MutationUpdateCultivationArgs = {
  input: UpdateCultivationInput;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};


export type MutationUpdateEruArgs = {
  input: UpdateEruInput;
};


export type MutationUpdateExampleArgs = {
  input: UpdateExampleInput;
};


export type MutationUpdateExcludeFromMlArgs = {
  exclude: Scalars['Boolean'];
  testId: Scalars['UUID'];
};


export type MutationUpdateFarmArgs = {
  input: UpdateFarmInput;
};


export type MutationUpdateFieldArgs = {
  input: UpdateFieldInput;
};


export type MutationUpdateFirmwareInstallLogArgs = {
  input: UpdateFirmwareInstallLogInput;
};


export type MutationUpdateLabIndicatorDefinitionArgs = {
  input: UpdateLabIndicatorDefinitionInput;
};


export type MutationUpdateLabResultArgs = {
  input: UpdateLabResultInput;
};


export type MutationUpdateLaboratoryArgs = {
  input: UpdateLaboratoryInput;
};


export type MutationUpdateLocalisationFileArgs = {
  input: UpdateLocalisationFileInput;
};


export type MutationUpdateLocalisationTranslationArgs = {
  input: UpdateLocalisationTranslationInput;
};


export type MutationUpdateMlModelArgs = {
  input: UpdateMlModelInput;
};


export type MutationUpdateOrganisationArgs = {
  input: UpdateOrganisationInput;
};


export type MutationUpdateOrganisationLogoArgs = {
  dataUrl: Scalars['String'];
  organisationId: Scalars['UUID'];
};


export type MutationUpdatePesTestArgs = {
  input: UpdatePesTestInput;
};


export type MutationUpdatePesTestCharacteristicsArgs = {
  input: UpdatePesTestCharacteristicsInput;
};


export type MutationUpdatePesTestLocationArgs = {
  input: UpdatePesTestLocationInput;
};


export type MutationUpdateProductTypeArgs = {
  input: UpdateProductTypeInput;
};


export type MutationUpdateResultArgs = {
  input: UpdateResultInput;
};


export type MutationUpdateSerialNumberArgs = {
  input: UpdateSerialNumberInput;
};


export type MutationUpdateSerialRangeArgs = {
  input: UpdateSerialRangeInput;
};


export type MutationUpdateSoilSampleArgs = {
  input: UpdateSoilSampleInput;
};


export type MutationUpdateSoilTypeArgs = {
  input: UpdateSoilTypeInput;
};


export type MutationUpdateTroArgs = {
  input: UpdateTroInput;
};


export type MutationUpdateTrainedIndicatorArgs = {
  input: UpdateTrainedIndicatorInput;
};


export type MutationUpdateUserNameArgs = {
  name: Scalars['String'];
};


export type MutationUpdateUserProfilePictureArgs = {
  dataUrl: Scalars['String'];
};


export type MutationUpdateWhat3WordsLocationArgs = {
  input: UpdateWhat3WordsLocationInput;
};


export type MutationUploadFirmwareArgs = {
  input: UploadFirmwareInput;
};

export type NullableOfMoistureLevelOperationFilterInput = {
  eq?: InputMaybe<MoistureLevel>;
  in?: InputMaybe<Array<InputMaybe<MoistureLevel>>>;
  neq?: InputMaybe<MoistureLevel>;
  nin?: InputMaybe<Array<InputMaybe<MoistureLevel>>>;
};

export type NullableOfSeasonOperationFilterInput = {
  eq?: InputMaybe<Season>;
  in?: InputMaybe<Array<InputMaybe<Season>>>;
  neq?: InputMaybe<Season>;
  nin?: InputMaybe<Array<InputMaybe<Season>>>;
};

/** A connection to a list of items. */
export type OpenCassetteOverflowRequestsConnection = {
  __typename?: 'OpenCassetteOverflowRequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OpenCassetteOverflowRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CassetteOverflowRequest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OpenCassetteOverflowRequestsEdge = {
  __typename?: 'OpenCassetteOverflowRequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CassetteOverflowRequest;
};

/** An organisation. */
export type Organisation = {
  __typename?: 'Organisation';
  /** Name trimmed and lowercased; includes id suffix when autocreated. */
  cleanName: Scalars['String'];
  /** Contact email address. */
  contactEmail: Scalars['String'];
  /** Contact phone number. */
  contactNumber?: Maybe<Scalars['String']>;
  /** Country. */
  country?: Maybe<Scalars['String']>;
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  farms?: Maybe<FarmsConnection>;
  /** Unique identifier. */
  id: Scalars['UUID'];
  inviteRequests?: Maybe<InviteRequestsConnection>;
  /** Whether the organisation was automatically created by the system. */
  isAutocreated: Scalars['Boolean'];
  /** Logo URL. */
  logoUrl?: Maybe<Scalars['String']>;
  members?: Maybe<MembersConnection>;
  /** Display name. */
  name: Scalars['String'];
  /** Owner user id. */
  ownerId: Scalars['UUID'];
  /** Whether the organisation is publicly visible. */
  public: Scalars['Boolean'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};


/** An organisation. */
export type OrganisationFarmsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<FarmSortInput>>;
  where?: InputMaybe<FarmFilterInput>;
};


/** An organisation. */
export type OrganisationInviteRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<OrganisationInviteRequestSortInput>>;
  where?: InputMaybe<OrganisationInviteRequestFilterInput>;
};


/** An organisation. */
export type OrganisationMembersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<UserSortInput>>;
  where?: InputMaybe<UserFilterInput>;
};

/** An organisation. */
export type OrganisationFilterInput = {
  and?: InputMaybe<Array<OrganisationFilterInput>>;
  /** Name trimmed and lowercased; includes id suffix when autocreated. */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** Contact email address. */
  contactEmail?: InputMaybe<StringOperationFilterInput>;
  /** Contact phone number. */
  contactNumber?: InputMaybe<StringOperationFilterInput>;
  /** Country. */
  country?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Whether the organisation was automatically created by the system. */
  isAutocreated?: InputMaybe<BooleanOperationFilterInput>;
  /** Logo URL. */
  logoUrl?: InputMaybe<StringOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrganisationFilterInput>>;
  /** Owner user id. */
  ownerId?: InputMaybe<UuidOperationFilterInput>;
  /** Whether the organisation is publicly visible. */
  public?: InputMaybe<BooleanOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A request to join an organisation or an invitation to join an organisation. */
export type OrganisationInviteRequest = {
  __typename?: 'OrganisationInviteRequest';
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  initiatingUser?: Maybe<User>;
  /** The user who created this request/invitation. */
  initiatingUserId: Scalars['UUID'];
  /** Whether this record is an access request or an invitation. */
  kind: OrganisationInviteRequestKind;
  organisation?: Maybe<Organisation>;
  /** Organisation id. */
  organisationId: Scalars['UUID'];
  /** When the invitation was responded to (accept/deny). */
  respondedAt?: Maybe<Scalars['DateTime']>;
  /** Current status of the request/invitation. */
  status: OrganisationInviteRequestStatus;
  /** The email address this request targets (normalized to lowercase). */
  targetEmail: Scalars['String'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** A request to join an organisation or an invitation to join an organisation. */
export type OrganisationInviteRequestFilterInput = {
  and?: InputMaybe<Array<OrganisationInviteRequestFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** The user who created this request/invitation. */
  initiatingUserId?: InputMaybe<UuidOperationFilterInput>;
  /** Whether this record is an access request or an invitation. */
  kind?: InputMaybe<OrganisationInviteRequestKindOperationFilterInput>;
  or?: InputMaybe<Array<OrganisationInviteRequestFilterInput>>;
  /** Organisation id. */
  organisationId?: InputMaybe<UuidOperationFilterInput>;
  /** When the invitation was responded to (accept/deny). */
  respondedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Current status of the request/invitation. */
  status?: InputMaybe<OrganisationInviteRequestStatusOperationFilterInput>;
  /** The email address this request targets (normalized to lowercase). */
  targetEmail?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export enum OrganisationInviteRequestKind {
  AccessRequest = 'ACCESS_REQUEST',
  Invite = 'INVITE'
}

export type OrganisationInviteRequestKindOperationFilterInput = {
  eq?: InputMaybe<OrganisationInviteRequestKind>;
  in?: InputMaybe<Array<OrganisationInviteRequestKind>>;
  neq?: InputMaybe<OrganisationInviteRequestKind>;
  nin?: InputMaybe<Array<OrganisationInviteRequestKind>>;
};

/** A request to join an organisation or an invitation to join an organisation. */
export type OrganisationInviteRequestSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** The user who created this request/invitation. */
  initiatingUserId?: InputMaybe<SortEnumType>;
  /** Whether this record is an access request or an invitation. */
  kind?: InputMaybe<SortEnumType>;
  /** Organisation id. */
  organisationId?: InputMaybe<SortEnumType>;
  /** When the invitation was responded to (accept/deny). */
  respondedAt?: InputMaybe<SortEnumType>;
  /** Current status of the request/invitation. */
  status?: InputMaybe<SortEnumType>;
  /** The email address this request targets (normalized to lowercase). */
  targetEmail?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

export enum OrganisationInviteRequestStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Denied = 'DENIED',
  Pending = 'PENDING'
}

export type OrganisationInviteRequestStatusOperationFilterInput = {
  eq?: InputMaybe<OrganisationInviteRequestStatus>;
  in?: InputMaybe<Array<OrganisationInviteRequestStatus>>;
  neq?: InputMaybe<OrganisationInviteRequestStatus>;
  nin?: InputMaybe<Array<OrganisationInviteRequestStatus>>;
};

/** A connection to a list of items. */
export type OrganisationInviteRequestsConnection = {
  __typename?: 'OrganisationInviteRequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OrganisationInviteRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OrganisationInviteRequest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OrganisationInviteRequestsEdge = {
  __typename?: 'OrganisationInviteRequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: OrganisationInviteRequest;
};

export enum OrganisationOwnerDepartureOutcome {
  Deleted = 'DELETED',
  Orphaned = 'ORPHANED',
  OwnershipTransferred = 'OWNERSHIP_TRANSFERRED'
}

/** An organisation. */
export type OrganisationSortInput = {
  /** Name trimmed and lowercased; includes id suffix when autocreated. */
  cleanName?: InputMaybe<SortEnumType>;
  /** Contact email address. */
  contactEmail?: InputMaybe<SortEnumType>;
  /** Contact phone number. */
  contactNumber?: InputMaybe<SortEnumType>;
  /** Country. */
  country?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Whether the organisation was automatically created by the system. */
  isAutocreated?: InputMaybe<SortEnumType>;
  /** Logo URL. */
  logoUrl?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** Owner user id. */
  ownerId?: InputMaybe<SortEnumType>;
  /** Whether the organisation is publicly visible. */
  public?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

export type OrganisationTestStats = {
  __typename?: 'OrganisationTestStats';
  failedSensorChecks: Scalars['Int'];
  organisationId: Scalars['UUID'];
  organisationName: Scalars['String'];
  soilTests: Scalars['Int'];
  successfulSensorChecks: Scalars['Int'];
};

/** A connection to a list of items. */
export type OrganisationsConnection = {
  __typename?: 'OrganisationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OrganisationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Organisation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OrganisationsEdge = {
  __typename?: 'OrganisationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Organisation;
};

/** A connection to a list of items. */
export type OverflowRequestsConnection = {
  __typename?: 'OverflowRequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OverflowRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CassetteOverflowRequest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OverflowRequestsEdge = {
  __typename?: 'OverflowRequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CassetteOverflowRequest;
};

/** A PES test. */
export type PesTest = {
  __typename?: 'PESTest';
  /** Indicator definitions that non-staff users may see for this test, derived from the customer(s) owning its ERU, cassette or organisation. Null when no customer limit applies. */
  allowedIndicatorDefinitions?: Maybe<Array<LabIndicatorDefinition>>;
  cassette?: Maybe<Cassette>;
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  cropType?: Maybe<CropType>;
  displayCropTypeName?: Maybe<Scalars['String']>;
  eru?: Maybe<Eru>;
  /** Whether to exclude this test from ML. */
  excludeFromMl: Scalars['Boolean'];
  /** Extra JSON metadata. */
  extraMetadata: Scalars['String'];
  /** Failure reasons. */
  failureReasons: Array<Scalars['String']>;
  farm?: Maybe<Farm>;
  featureCaches: Array<PesTestFeatureCache>;
  field?: Maybe<Field>;
  /** Firmware version. */
  firmwareVersion: Scalars['String'];
  /** Whether any results exist for this test, regardless of the viewer's customer indicator limit. Use this (not an empty `results` connection) to decide whether a test is still being processed. */
  hasResults: Scalars['Boolean'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Whether this test was run in debug mode. */
  isDebug: Scalars['Boolean'];
  /** Whether this test failed. */
  isFailure: Scalars['Boolean'];
  /** Whether this test is from a reference zone. */
  isReferenceZone: Scalars['Boolean'];
  location?: Maybe<GpsLocation>;
  /** Moisture level. */
  moisture: MoistureLevel;
  /** Display name. */
  name: Scalars['String'];
  organisation?: Maybe<Organisation>;
  /** Original model name. */
  originalModelName: Scalars['String'];
  results?: Maybe<ResultsConnection>;
  /** Logical run UUID. */
  runId?: Maybe<Scalars['UUID']>;
  /** Optional URL to the sample file. */
  sampleFileUrl?: Maybe<Scalars['String']>;
  /** Season. */
  season: Season;
  soilSample?: Maybe<SoilSample>;
  /** Soil texture. */
  soilTexture: SimpleSoilTexture;
  /** SRF UUID. */
  srfUuid: Scalars['UUID'];
  /** Test type. */
  testType: PesTestType;
  tro?: Maybe<Tro>;
  /** TRO UUID. */
  troUuid: Scalars['UUID'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
  /** When this test's uploaded sample data was first successfully processed. */
  uploadProcessedAt?: Maybe<Scalars['DateTime']>;
  uploadRequest?: Maybe<UploadRequest>;
  /** UTC test time. */
  utcTestTime: Scalars['DateTime'];
};


/** A PES test. */
export type PesTestResultsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<ResultSortInput>>;
  where?: InputMaybe<ResultFilterInput>;
};

/** A cassette. */
export type PesTestCassetteRefFilterInput = {
  and?: InputMaybe<Array<PesTestCassetteRefFilterInput>>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<PesTestCassetteRefFilterInput>>;
};

/** An ERU device. */
export type PesTestEruRefFilterInput = {
  and?: InputMaybe<Array<PesTestEruRefFilterInput>>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<PesTestEruRefFilterInput>>;
};

/** A farm. */
export type PesTestFarmRefFilterInput = {
  and?: InputMaybe<Array<PesTestFarmRefFilterInput>>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<PesTestFarmRefFilterInput>>;
};

/** A farm. */
export type PesTestFarmSortInput = {
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
};

/** A cached extracted feature payload for a PES test. */
export type PesTestFeatureCache = {
  __typename?: 'PESTestFeatureCache';
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** When the feature payload was extracted. */
  extractedAt: Scalars['DateTime'];
  /** Number of extracted features in the payload. */
  featureCount: Scalars['Int'];
  featureMatches: Array<PesTestFeatureCacheFeature>;
  /** Feature-set version or cache namespace. */
  featureSetVersion: Scalars['String'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Extra JSON metadata for the cached payload. */
  metadataJson: Scalars['String'];
  /** Optional SHA-256 digest for the cached payload. */
  payloadSha256?: Maybe<Scalars['String']>;
  /** Optional reason recorded when the cache was purged. */
  purgeReason?: Maybe<Scalars['String']>;
  /** When this cache record was purged, if no longer active. */
  purgedAt?: Maybe<Scalars['DateTime']>;
  /** Stable sample identifier used by the extractor. */
  sampleId: Scalars['String'];
  /** Storage URI for the cached feature payload. */
  sourceUri: Scalars['String'];
  /** Google Cloud Storage bucket parsed from SourceUri, when applicable. */
  storageBucket?: Maybe<Scalars['String']>;
  /** Google Cloud Storage object name parsed from SourceUri, when applicable. */
  storageObjectName?: Maybe<Scalars['String']>;
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
  warningSummary: PesTestFeatureCacheWarningSummary;
};


/** A cached extracted feature payload for a PES test. */
export type PesTestFeatureCacheFeatureMatchesArgs = {
  limit: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
};

export type PesTestFeatureCacheFeature = {
  __typename?: 'PESTestFeatureCacheFeature';
  displayValue: Scalars['String'];
  hasValue: Scalars['Boolean'];
  name: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
};

export type PesTestFeatureCacheOverview = {
  __typename?: 'PESTestFeatureCacheOverview';
  activeCacheCount: Scalars['Int'];
  activeFeatureCount: Scalars['Long'];
  activeTestCount: Scalars['Int'];
  lastExtractedAt?: Maybe<Scalars['DateTime']>;
};

export type PesTestFeatureCachePurgeResult = {
  __typename?: 'PESTestFeatureCachePurgeResult';
  purgedCount: Scalars['Int'];
  sampleIds: Array<Scalars['String']>;
  testIds: Array<Scalars['UUID']>;
};

export type PesTestFeatureCacheWarningSummary = {
  __typename?: 'PESTestFeatureCacheWarningSummary';
  hasWarnings: Scalars['Boolean'];
  messages: Array<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** A field. */
export type PesTestFieldRefFilterInput = {
  and?: InputMaybe<Array<PesTestFieldRefFilterInput>>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<PesTestFieldRefFilterInput>>;
};

/** A field. */
export type PesTestFieldSortInput = {
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
};

/** A PES test. */
export type PesTestFilterInput = {
  and?: InputMaybe<Array<PesTestFilterInput>>;
  cassette?: InputMaybe<PesTestCassetteRefFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  eru?: InputMaybe<PesTestEruRefFilterInput>;
  /** Whether to exclude this test from ML. */
  excludeFromMl?: InputMaybe<BooleanOperationFilterInput>;
  /** Extra JSON metadata. */
  extraMetadata?: InputMaybe<StringOperationFilterInput>;
  /** Failure reasons. */
  failureReasons?: InputMaybe<ListStringOperationFilterInput>;
  farm?: InputMaybe<PesTestFarmRefFilterInput>;
  field?: InputMaybe<PesTestFieldRefFilterInput>;
  /** Firmware version. */
  firmwareVersion?: InputMaybe<StringOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Whether this test was run in debug mode. */
  isDebug?: InputMaybe<BooleanOperationFilterInput>;
  /** Whether this test failed. */
  isFailure?: InputMaybe<BooleanOperationFilterInput>;
  /** Whether this test is from a reference zone. */
  isReferenceZone?: InputMaybe<BooleanOperationFilterInput>;
  /** Moisture level. */
  moisture?: InputMaybe<MoistureLevelOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PesTestFilterInput>>;
  organisation?: InputMaybe<PesTestOrganisationRefFilterInput>;
  /** Original model name. */
  originalModelName?: InputMaybe<StringOperationFilterInput>;
  /** Logical run UUID. */
  runId?: InputMaybe<UuidOperationFilterInput>;
  /** Optional URL to the sample file. */
  sampleFileUrl?: InputMaybe<StringOperationFilterInput>;
  /** Season. */
  season?: InputMaybe<SeasonOperationFilterInput>;
  /** Soil texture. */
  soilTexture?: InputMaybe<SimpleSoilTextureOperationFilterInput>;
  /** SRF UUID. */
  srfUuid?: InputMaybe<UuidOperationFilterInput>;
  /** Test type. */
  testType?: InputMaybe<PesTestTypeOperationFilterInput>;
  /** TRO UUID. */
  troUuid?: InputMaybe<UuidOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** When this test's uploaded sample data was first successfully processed. */
  uploadProcessedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** UTC test time. */
  utcTestTime?: InputMaybe<DateTimeOperationFilterInput>;
};

/** An organisation. */
export type PesTestOrganisationRefFilterInput = {
  and?: InputMaybe<Array<PesTestOrganisationRefFilterInput>>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<PesTestOrganisationRefFilterInput>>;
};

/** A PES test. */
export type PesTestSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Whether to exclude this test from ML. */
  excludeFromMl?: InputMaybe<SortEnumType>;
  /** Extra JSON metadata. */
  extraMetadata?: InputMaybe<SortEnumType>;
  farm?: InputMaybe<PesTestFarmSortInput>;
  field?: InputMaybe<PesTestFieldSortInput>;
  /** Firmware version. */
  firmwareVersion?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Whether this test was run in debug mode. */
  isDebug?: InputMaybe<SortEnumType>;
  /** Whether this test failed. */
  isFailure?: InputMaybe<SortEnumType>;
  /** Whether this test is from a reference zone. */
  isReferenceZone?: InputMaybe<SortEnumType>;
  /** Moisture level. */
  moisture?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** Original model name. */
  originalModelName?: InputMaybe<SortEnumType>;
  /** Logical run UUID. */
  runId?: InputMaybe<SortEnumType>;
  /** Optional URL to the sample file. */
  sampleFileUrl?: InputMaybe<SortEnumType>;
  /** Season. */
  season?: InputMaybe<SortEnumType>;
  /** Soil texture. */
  soilTexture?: InputMaybe<SortEnumType>;
  /** SRF UUID. */
  srfUuid?: InputMaybe<SortEnumType>;
  /** Test type. */
  testType?: InputMaybe<SortEnumType>;
  /** TRO UUID. */
  troUuid?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
  /** When this test's uploaded sample data was first successfully processed. */
  uploadProcessedAt?: InputMaybe<SortEnumType>;
  /** UTC test time. */
  utcTestTime?: InputMaybe<SortEnumType>;
};

/** PESTest type. */
export enum PesTestType {
  SensorCheck = 'SENSOR_CHECK',
  SoilTest = 'SOIL_TEST'
}

export type PesTestTypeOperationFilterInput = {
  eq?: InputMaybe<PesTestType>;
  in?: InputMaybe<Array<PesTestType>>;
  neq?: InputMaybe<PesTestType>;
  nin?: InputMaybe<Array<PesTestType>>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PasswordAuthStatus = {
  __typename?: 'PasswordAuthStatus';
  hasPassword: Scalars['Boolean'];
};

/** A connection to a list of items. */
export type PesTestsConnection = {
  __typename?: 'PesTestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PesTestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PesTest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PesTestsEdge = {
  __typename?: 'PesTestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PesTest;
};

/** A connection to a list of items. */
export type PesTestsForMlConnection = {
  __typename?: 'PesTestsForMlConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PesTestsForMlEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PesTest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PesTestsForMlEdge = {
  __typename?: 'PesTestsForMlEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PesTest;
};

export type PredictionBacklogStatus = {
  __typename?: 'PredictionBacklogStatus';
  averagePredictionDurationSeconds?: Maybe<Scalars['Float']>;
  effectiveWorkerSlots: Scalars['Int'];
  estimatedWaitSeconds?: Maybe<Scalars['Float']>;
  queuedPredictionCount: Scalars['Int'];
  runningPredictionCount: Scalars['Int'];
};

/** Prediction pipeline to queue. */
export enum PredictionPipeline {
  Both = 'BOTH',
  New = 'NEW',
  Old = 'OLD'
}

export type ProcessingBackgroundJob = {
  __typename?: 'ProcessingBackgroundJob';
  averageDurationSeconds?: Maybe<Scalars['Float']>;
  displayName: Scalars['String'];
  elapsedSeconds: Scalars['Float'];
  etaSeconds?: Maybe<Scalars['Float']>;
  jobId: Scalars['String'];
  methodType: Scalars['String'];
  queue?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
};

/** A product type (unique by product type code). */
export type ProductType = {
  __typename?: 'ProductType';
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String'];
  /** Computed code (Location + Model + SubType). */
  code: Scalars['String'];
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Location code (1 character). */
  location: Scalars['String'];
  /** Model code (1 character). */
  model: Scalars['String'];
  /** Display name. */
  name: Scalars['String'];
  /** Sub-type code (1 character). */
  subType: Scalars['String'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** A product type (unique by product type code). */
export type ProductTypeFilterInput = {
  and?: InputMaybe<Array<ProductTypeFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** Computed code (Location + Model + SubType). */
  code?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Location code (1 character). */
  location?: InputMaybe<StringOperationFilterInput>;
  /** Model code (1 character). */
  model?: InputMaybe<StringOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductTypeFilterInput>>;
  /** Sub-type code (1 character). */
  subType?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A product type (unique by product type code). */
export type ProductTypeSortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** Computed code (Location + Model + SubType). */
  code?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Location code (1 character). */
  location?: InputMaybe<SortEnumType>;
  /** Model code (1 character). */
  model?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** Sub-type code (1 character). */
  subType?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProductTypesConnection = {
  __typename?: 'ProductTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductTypesEdge = {
  __typename?: 'ProductTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProductType;
};

/** A connection to a list of items. */
export type PublicOrganisationsConnection = {
  __typename?: 'PublicOrganisationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PublicOrganisationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Organisation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PublicOrganisationsEdge = {
  __typename?: 'PublicOrganisationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Organisation;
};

export type PurgePesTestFeatureCacheInput = {
  /** Optional feature-set version to purge. Defaults to every active cache for the test. */
  featureSetVersion?: InputMaybe<Scalars['String']>;
  /** Optional purge reason. */
  reason?: InputMaybe<Scalars['String']>;
  /** PESTest ID. */
  testId: Scalars['UUID'];
};

export type PurgePesTestFeatureCachesInput = {
  /** Optional feature-set version to purge. */
  featureSetVersion?: InputMaybe<Scalars['String']>;
  /** Whether to purge every active feature cache. */
  purgeAll?: Scalars['Boolean'];
  /** Optional purge reason. */
  reason?: InputMaybe<Scalars['String']>;
  /** Sample IDs to purge. */
  sampleIds?: InputMaybe<Array<Scalars['String']>>;
  /** PESTest IDs to purge. */
  testIds?: InputMaybe<Array<Scalars['UUID']>>;
};

export type Query = {
  __typename?: 'Query';
  accountDeletionPreview: AccountDeletionPreview;
  activeFirmware?: Maybe<ActiveFirmware>;
  assignableRoles: Array<Scalars['String']>;
  auditLogActionTypes: Array<Scalars['String']>;
  auditLogs?: Maybe<AuditLogsConnection>;
  backgroundJobStatus: BackgroundJobStatus;
  batch?: Maybe<Batch>;
  batches?: Maybe<BatchesConnection>;
  cassette?: Maybe<Cassette>;
  cassetteListSummary: CassetteListSummary;
  cassettes?: Maybe<CassettesConnection>;
  countTestsPerDayForDateRange: Array<TestCountByDay>;
  coverCropById?: Maybe<CoverCrop>;
  coverCrops?: Maybe<CoverCropsConnection>;
  cropById?: Maybe<Crop>;
  cropTypeById?: Maybe<CropType>;
  cropTypes?: Maybe<CropTypesConnection>;
  crops?: Maybe<CropsConnection>;
  cultivationById?: Maybe<Cultivation>;
  cultivations?: Maybe<CultivationsConnection>;
  customer?: Maybe<Customer>;
  customers?: Maybe<CustomersConnection>;
  dashboardStats: DashboardStats;
  duplicatedLabResultsCount: Scalars['Int'];
  eru?: Maybe<Eru>;
  eruByBleId?: Maybe<Eru>;
  erus?: Maybe<ErusConnection>;
  exampleById?: Maybe<Example>;
  examples?: Maybe<ExamplesConnection>;
  farm?: Maybe<Farm>;
  farms?: Maybe<FarmsConnection>;
  featureExtractionExportRun?: Maybe<FeatureExtractionExportRun>;
  featureExtractionExportRuns?: Maybe<FeatureExtractionExportRunsConnection>;
  field?: Maybe<Field>;
  fields?: Maybe<FieldsConnection>;
  firmwareInstallLogs?: Maybe<FirmwareInstallLogsConnection>;
  firmwareVersions?: Maybe<FirmwareVersionsConnection>;
  gpsLocationById?: Maybe<GpsLocation>;
  gpsLocations?: Maybe<GpsLocationsConnection>;
  impersonateUser: Scalars['String'];
  labIndicatorDefinition?: Maybe<LabIndicatorDefinition>;
  labIndicatorDefinitions?: Maybe<LabIndicatorDefinitionsConnection>;
  labResult?: Maybe<LabResult>;
  laboratories?: Maybe<LaboratoriesConnection>;
  laboratoryById?: Maybe<Laboratory>;
  localisationAdminOverview: LocalisationAdminOverview;
  localisationEditor: LocalisationEditorView;
  localisationFile?: Maybe<Scalars['Any']>;
  localisationLocales: Array<Scalars['String']>;
  localisationString: Scalars['String'];
  me: User;
  mlModelById?: Maybe<MlModel>;
  mlModels?: Maybe<MlModelsConnection>;
  openCassetteOverflowRequests?: Maybe<OpenCassetteOverflowRequestsConnection>;
  organisationById?: Maybe<Organisation>;
  organisationInviteRequest?: Maybe<OrganisationInviteRequest>;
  organisations?: Maybe<OrganisationsConnection>;
  passwordAuthStatus: PasswordAuthStatus;
  pesTest?: Maybe<PesTest>;
  pesTestFeatureCacheOverview: PesTestFeatureCacheOverview;
  pesTests?: Maybe<PesTestsConnection>;
  pesTestsForMl?: Maybe<PesTestsForMlConnection>;
  productTypeById?: Maybe<ProductType>;
  productTypes?: Maybe<ProductTypesConnection>;
  publicOrganisations?: Maybe<PublicOrganisationsConnection>;
  report?: Maybe<Report>;
  reports?: Maybe<ReportsConnection>;
  serialNumber?: Maybe<SerialNumber>;
  serialNumbers?: Maybe<SerialNumbersConnection>;
  serialRangeById?: Maybe<SerialRange>;
  serialRanges?: Maybe<SerialRangesConnection>;
  soilSample?: Maybe<SoilSample>;
  soilSamples?: Maybe<SoilSamplesConnection>;
  soilTypeById?: Maybe<SoilType>;
  soilTypes?: Maybe<SoilTypesConnection>;
  testsToDelete: Array<Scalars['UUID']>;
  troManagementOverview: TroManagementOverview;
  user?: Maybe<User>;
  users?: Maybe<UsersConnection>;
  what3WordsLocation?: Maybe<What3WordsLocation>;
  what3WordsLocationByLatLon?: Maybe<What3WordsLocation>;
  what3WordsLocationByWords?: Maybe<What3WordsLocation>;
  what3WordsLocations?: Maybe<What3WordsLocationsConnection>;
};


export type QueryAuditLogsArgs = {
  actionType?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  occurredFrom?: InputMaybe<Scalars['DateTime']>;
  occurredTo?: InputMaybe<Scalars['DateTime']>;
  order?: InputMaybe<Array<AuditLogSortInput>>;
  userName?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<AuditLogFilterInput>;
};


export type QueryBatchArgs = {
  id: Scalars['UUID'];
};


export type QueryBatchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<BatchSortInput>>;
  where?: InputMaybe<BatchFilterInput>;
};


export type QueryCassetteArgs = {
  id: Scalars['UUID'];
};


export type QueryCassettesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CassetteSortInput>>;
  where?: InputMaybe<CassetteFilterInput>;
};


export type QueryCountTestsPerDayForDateRangeArgs = {
  endDate: Scalars['DateTime'];
  organisationId: Scalars['UUID'];
  startDate: Scalars['DateTime'];
};


export type QueryCoverCropByIdArgs = {
  id: Scalars['UUID'];
};


export type QueryCoverCropsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CoverCropSortInput>>;
  where?: InputMaybe<CoverCropFilterInput>;
};


export type QueryCropByIdArgs = {
  id: Scalars['UUID'];
};


export type QueryCropTypeByIdArgs = {
  id: Scalars['UUID'];
};


export type QueryCropTypesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CropTypeSortInput>>;
  where?: InputMaybe<CropTypeFilterInput>;
};


export type QueryCropsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CropSortInput>>;
  where?: InputMaybe<CropFilterInput>;
};


export type QueryCultivationByIdArgs = {
  id: Scalars['UUID'];
};


export type QueryCultivationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CultivationSortInput>>;
  where?: InputMaybe<CultivationFilterInput>;
};


export type QueryCustomerArgs = {
  id: Scalars['UUID'];
};


export type QueryCustomersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CustomerSortInput>>;
  where?: InputMaybe<CustomerFilterInput>;
};


export type QueryDashboardStatsArgs = {
  endDate: Scalars['DateTime'];
  excludedOrganisationIds?: InputMaybe<Array<Scalars['UUID']>>;
  includedOrganisationIds?: InputMaybe<Array<Scalars['UUID']>>;
  previousEndDate: Scalars['DateTime'];
  previousStartDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};


export type QueryEruArgs = {
  id: Scalars['UUID'];
};


export type QueryEruByBleIdArgs = {
  bleId: Scalars['String'];
};


export type QueryErusArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<EruSortInput>>;
  where?: InputMaybe<EruFilterInput>;
};


export type QueryExampleByIdArgs = {
  id: Scalars['UUID'];
};


export type QueryExamplesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<ExampleSortInput>>;
  where?: InputMaybe<ExampleFilterInput>;
};


export type QueryFarmArgs = {
  id: Scalars['UUID'];
};


export type QueryFarmsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<FarmSortInput>>;
  where?: InputMaybe<FarmFilterInput>;
};


export type QueryFeatureExtractionExportRunArgs = {
  id: Scalars['UUID'];
};


export type QueryFeatureExtractionExportRunsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<FeatureExtractionExportRunSortInput>>;
  where?: InputMaybe<FeatureExtractionExportRunFilterInput>;
};


export type QueryFieldArgs = {
  id: Scalars['UUID'];
};


export type QueryFieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<FieldSortInput>>;
  where?: InputMaybe<FieldFilterInput>;
};


export type QueryFirmwareInstallLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<FirmwareInstallLogSortInput>>;
  where?: InputMaybe<FirmwareInstallLogFilterInput>;
};


export type QueryFirmwareVersionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<FirmwareVersionSortInput>>;
  where?: InputMaybe<FirmwareVersionFilterInput>;
};


export type QueryGpsLocationByIdArgs = {
  id: Scalars['UUID'];
};


export type QueryGpsLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<GpsLocationSortInput>>;
  where?: InputMaybe<GpsLocationFilterInput>;
};


export type QueryImpersonateUserArgs = {
  userId: Scalars['UUID'];
};


export type QueryLabIndicatorDefinitionArgs = {
  id: Scalars['UUID'];
};


export type QueryLabIndicatorDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<LabIndicatorDefinitionSortInput>>;
  where?: InputMaybe<LabIndicatorDefinitionFilterInput>;
};


export type QueryLabResultArgs = {
  id: Scalars['UUID'];
};


export type QueryLaboratoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<LaboratorySortInput>>;
  where?: InputMaybe<LaboratoryFilterInput>;
};


export type QueryLaboratoryByIdArgs = {
  id: Scalars['UUID'];
};


export type QueryLocalisationEditorArgs = {
  locale: Scalars['String'];
  name: Scalars['String'];
};


export type QueryLocalisationFileArgs = {
  locale: Scalars['String'];
  name: Scalars['String'];
};


export type QueryLocalisationLocalesArgs = {
  name: Scalars['String'];
};


export type QueryLocalisationStringArgs = {
  locale: Scalars['String'];
  name: Scalars['String'];
  string: Scalars['String'];
};


export type QueryMlModelByIdArgs = {
  id: Scalars['UUID'];
};


export type QueryMlModelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<MlModelSortInput>>;
  where?: InputMaybe<MlModelFilterInput>;
};


export type QueryOpenCassetteOverflowRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  excludingCassetteId?: InputMaybe<Scalars['UUID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CassetteOverflowRequestSortInput>>;
  where?: InputMaybe<CassetteOverflowRequestFilterInput>;
};


export type QueryOrganisationByIdArgs = {
  id: Scalars['UUID'];
};


export type QueryOrganisationInviteRequestArgs = {
  id: Scalars['UUID'];
};


export type QueryOrganisationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<OrganisationSortInput>>;
  where?: InputMaybe<OrganisationFilterInput>;
};


export type QueryPesTestArgs = {
  id: Scalars['UUID'];
};


export type QueryPesTestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<PesTestSortInput>>;
  where?: InputMaybe<PesTestFilterInput>;
};


export type QueryPesTestsForMlArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<PesTestSortInput>>;
  troId: Scalars['UUID'];
  where?: InputMaybe<PesTestFilterInput>;
};


export type QueryProductTypeByIdArgs = {
  id: Scalars['UUID'];
};


export type QueryProductTypesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<ProductTypeSortInput>>;
  where?: InputMaybe<ProductTypeFilterInput>;
};


export type QueryPublicOrganisationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<OrganisationSortInput>>;
  where?: InputMaybe<OrganisationFilterInput>;
};


export type QueryReportArgs = {
  id: Scalars['UUID'];
};


export type QueryReportsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<ReportSortInput>>;
  where?: InputMaybe<ReportFilterInput>;
};


export type QuerySerialNumberArgs = {
  id: Scalars['UUID'];
};


export type QuerySerialNumbersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<SerialNumberSortInput>>;
  where?: InputMaybe<SerialNumberFilterInput>;
};


export type QuerySerialRangeByIdArgs = {
  id: Scalars['UUID'];
};


export type QuerySerialRangesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<SerialRangeSortInput>>;
  where?: InputMaybe<SerialRangeFilterInput>;
};


export type QuerySoilSampleArgs = {
  id: Scalars['UUID'];
};


export type QuerySoilSamplesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<SoilSampleSortInput>>;
  search?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<SoilSampleFilterInput>;
};


export type QuerySoilTypeByIdArgs = {
  id: Scalars['UUID'];
};


export type QuerySoilTypesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<SoilTypeSortInput>>;
  where?: InputMaybe<SoilTypeFilterInput>;
};


export type QueryTestsToDeleteArgs = {
  ids: Array<Scalars['UUID']>;
};


export type QueryUserArgs = {
  id: Scalars['UUID'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<UserSortInput>>;
  organisationId?: InputMaybe<Scalars['UUID']>;
  role?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<UserFilterInput>;
};


export type QueryWhat3WordsLocationArgs = {
  id: Scalars['UUID'];
};


export type QueryWhat3WordsLocationByLatLonArgs = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};


export type QueryWhat3WordsLocationByWordsArgs = {
  words: Scalars['String'];
};


export type QueryWhat3WordsLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<What3WordsLocationSortInput>>;
  where?: InputMaybe<What3WordsLocationFilterInput>;
};

/** Input for queueing one AI-generated localisation translation. */
export type QueueLocalisationTranslationInput = {
  context?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  key: Scalars['String'];
  locale: Scalars['String'];
};

export type QueuePesTestPredictionInput = {
  /** Optional new-model name override. Defaults to ML_MODEL_NAME. The old pipeline always uses nn_attention_v2. */
  modelName?: InputMaybe<Scalars['String']>;
  /** Pipeline to run. Defaults to the new feature-extraction pipeline. */
  pipeline?: PredictionPipeline;
  /** Whether to recalculate cached features before prediction. */
  refreshCache?: InputMaybe<Scalars['Boolean']>;
  /** PESTest ID. */
  testId: Scalars['UUID'];
};

export type QueuePesTestTargetPredictionsInput = {
  /** Optional new-model name override. Defaults to ML_MODEL_NAME. The old pipeline always uses nn_attention_v2. */
  modelName?: InputMaybe<Scalars['String']>;
  /** Pipeline to run. Defaults to the new feature-extraction pipeline. */
  pipeline?: PredictionPipeline;
  /** Whether to recalculate cached features before prediction. */
  refreshCache?: InputMaybe<Scalars['Boolean']>;
  /** Prediction target names to create or update. */
  targetNames: Array<Scalars['String']>;
  /** PESTest IDs to queue. */
  testIds: Array<Scalars['UUID']>;
};

export type QueuedBackgroundJobType = {
  __typename?: 'QueuedBackgroundJobType';
  averageDurationSeconds?: Maybe<Scalars['Float']>;
  count: Scalars['Int'];
  displayName: Scalars['String'];
  estimatedTotalDurationSeconds?: Maybe<Scalars['Float']>;
  methodType: Scalars['String'];
  nextScheduledAt?: Maybe<Scalars['DateTime']>;
  queue: Scalars['String'];
};

export type RecordPesTestFeatureCacheInput = {
  /** When the feature payload was extracted. Defaults to now. */
  extractedAt?: InputMaybe<Scalars['DateTime']>;
  /** Number of extracted features in the payload. */
  featureCount: Scalars['Int'];
  /** Feature-set version or cache namespace. */
  featureSetVersion: Scalars['String'];
  /** Extra JSON metadata for the cached payload. */
  metadataJson?: InputMaybe<Scalars['String']>;
  /** Optional SHA-256 digest for the cached payload. */
  payloadSha256?: InputMaybe<Scalars['String']>;
  /** Stable sample identifier used by the extractor. */
  sampleId: Scalars['String'];
  /** Storage URI for the cached feature payload. */
  sourceUri: Scalars['String'];
  /** PESTest ID. */
  testId: Scalars['UUID'];
};

export type RedeemMagicLinkInput = {
  email: Scalars['String'];
  token: Scalars['String'];
};

export type RemoveOrganisationMemberInput = {
  organisationId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** A generated report. */
export type Report = {
  __typename?: 'Report';
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String'];
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  /** Report format. */
  format: ReportFormat;
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Whether the report has completed successfully. */
  isComplete: Scalars['Boolean'];
  /** Display name. */
  name: Scalars['String'];
  pesTests?: Maybe<PesTestsConnection>;
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};


/** A generated report. */
export type ReportPesTestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<PesTestSortInput>>;
  where?: InputMaybe<PesTestFilterInput>;
};

/** A generated report. */
export type ReportFilterInput = {
  and?: InputMaybe<Array<ReportFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Report format. */
  format?: InputMaybe<ReportFormatOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Whether the report has completed successfully. */
  isComplete?: InputMaybe<BooleanOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Report output format. */
export enum ReportFormat {
  Csv = 'CSV',
  Pdf = 'PDF'
}

export type ReportFormatOperationFilterInput = {
  eq?: InputMaybe<ReportFormat>;
  in?: InputMaybe<Array<ReportFormat>>;
  neq?: InputMaybe<ReportFormat>;
  nin?: InputMaybe<Array<ReportFormat>>;
};

/** A generated report. */
export type ReportSortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Report format. */
  format?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Whether the report has completed successfully. */
  isComplete?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ReportsConnection = {
  __typename?: 'ReportsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ReportsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Report>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ReportsEdge = {
  __typename?: 'ReportsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Report;
};

export type RequestMagicLinkInput = {
  email: Scalars['String'];
};

export type RequestOrganisationAccessInput = {
  organisationId: Scalars['UUID'];
};

export type RequestPasswordResetInput = {
  email: Scalars['String'];
};

export type ResetPasswordWithCodeInput = {
  code: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type ResolveLegacyCachedRunIdInput = {
  /** Cassette ID. */
  cassetteId: Scalars['UUID'];
  /** ERU ID. */
  eruId: Scalars['UUID'];
  /** Field ID (used to derive farm and organisation). */
  fieldId: Scalars['UUID'];
  /** Whether this test was run in debug mode. */
  isDebug?: Scalars['Boolean'];
  /** Display name. */
  name: Scalars['String'];
  /** SRF UUID. */
  srfUuid: Scalars['UUID'];
  /** Test type. */
  testType: PesTestType;
  /** UTC test time. */
  utcTestTime: Scalars['DateTime'];
};

export type RespondToOrganisationInviteRequestInput = {
  id: Scalars['UUID'];
};

/** A PES test result. */
export type Result = {
  __typename?: 'Result';
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  indicator?: Maybe<TrainedIndicator>;
  /** Indicator name. */
  name: Scalars['String'];
  pesTest?: Maybe<PesTest>;
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
  /** Result value. */
  value: Scalars['Float'];
};

/** A PES test result. */
export type ResultFilterInput = {
  and?: InputMaybe<Array<ResultFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Indicator name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ResultFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Result value. */
  value?: InputMaybe<FloatOperationFilterInput>;
};

/** A PES test result. */
export type ResultSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Indicator name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
  /** Result value. */
  value?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ResultsConnection = {
  __typename?: 'ResultsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ResultsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Result>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ResultsEdge = {
  __typename?: 'ResultsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Result;
};

export enum Season {
  Autumn = 'AUTUMN',
  Spring = 'SPRING',
  Summer = 'SUMMER',
  Winter = 'WINTER'
}

export type SeasonOperationFilterInput = {
  eq?: InputMaybe<Season>;
  in?: InputMaybe<Array<Season>>;
  neq?: InputMaybe<Season>;
  nin?: InputMaybe<Array<Season>>;
};

/** Input for sending a report. */
export type SendReportInput = {
  reportId: Scalars['UUID'];
};

/** A serial number assigned to a batch within a serial range. */
export type SerialNumber = {
  __typename?: 'SerialNumber';
  batch?: Maybe<Batch>;
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  formattedSerialNumber?: Maybe<Scalars['String']>;
  /** Unique identifier. */
  id: Scalars['UUID'];
  range?: Maybe<SerialRange>;
  /** Serial number (0-9999999). */
  serialNumber: Scalars['Int'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** A serial number assigned to a batch within a serial range. */
export type SerialNumberFilterInput = {
  and?: InputMaybe<Array<SerialNumberFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<SerialNumberFilterInput>>;
  /** Serial number (0-9999999). */
  serialNumber?: InputMaybe<IntOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A serial number assigned to a batch within a serial range. */
export type SerialNumberSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Serial number (0-9999999). */
  serialNumber?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SerialNumbersConnection = {
  __typename?: 'SerialNumbersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SerialNumbersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SerialNumber>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SerialNumbersEdge = {
  __typename?: 'SerialNumbersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SerialNumber;
};

/** A serial number allocation range for a product type. */
export type SerialRange = {
  __typename?: 'SerialRange';
  /** Build description. */
  buildDescription: Scalars['String'];
  /** Build end date. */
  buildEndDate?: Maybe<Scalars['DateTime']>;
  /** Build start date. */
  buildStartDate: Scalars['DateTime'];
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Inclusive end of the range. */
  endNumber: Scalars['Int'];
  /** Firmware version. */
  firmwareVersion?: Maybe<Scalars['String']>;
  /** Unique identifier. */
  id: Scalars['UUID'];
  nextAvailable: Scalars['Int'];
  /** Notes. */
  notes?: Maybe<Scalars['String']>;
  productType?: Maybe<ProductType>;
  /** Inclusive start of the range. */
  startNumber: Scalars['Int'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** A serial number allocation range for a product type. */
export type SerialRangeFilterInput = {
  and?: InputMaybe<Array<SerialRangeFilterInput>>;
  /** Build description. */
  buildDescription?: InputMaybe<StringOperationFilterInput>;
  /** Build end date. */
  buildEndDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Build start date. */
  buildStartDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Inclusive end of the range. */
  endNumber?: InputMaybe<IntOperationFilterInput>;
  /** Firmware version. */
  firmwareVersion?: InputMaybe<StringOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Notes. */
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SerialRangeFilterInput>>;
  /** Inclusive start of the range. */
  startNumber?: InputMaybe<IntOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A serial number allocation range for a product type. */
export type SerialRangeSortInput = {
  /** Build description. */
  buildDescription?: InputMaybe<SortEnumType>;
  /** Build end date. */
  buildEndDate?: InputMaybe<SortEnumType>;
  /** Build start date. */
  buildStartDate?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Inclusive end of the range. */
  endNumber?: InputMaybe<SortEnumType>;
  /** Firmware version. */
  firmwareVersion?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Notes. */
  notes?: InputMaybe<SortEnumType>;
  /** Inclusive start of the range. */
  startNumber?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SerialRangesConnection = {
  __typename?: 'SerialRangesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SerialRangesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SerialRange>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SerialRangesEdge = {
  __typename?: 'SerialRangesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SerialRange;
};

/** Input for enabling or disabling one target locale system wide. */
export type SetLocalisationLocaleEnabledInput = {
  isEnabled: Scalars['Boolean'];
  locale: Scalars['String'];
};

/** Result of enabling or disabling a target locale system wide. */
export type SetLocalisationLocaleEnabledResult = {
  __typename?: 'SetLocalisationLocaleEnabledResult';
  isEnabled: Scalars['Boolean'];
  locale: Scalars['String'];
};

export type SetOwnPasswordInput = {
  password: Scalars['String'];
};

export type SetUserRoleInput = {
  role: Scalars['String'];
  userId: Scalars['UUID'];
};

/** Simplified soil texture. */
export enum SimpleSoilTexture {
  Heavy = 'HEAVY',
  Light = 'LIGHT',
  Medium = 'MEDIUM'
}

export type SimpleSoilTextureOperationFilterInput = {
  eq?: InputMaybe<SimpleSoilTexture>;
  in?: InputMaybe<Array<SimpleSoilTexture>>;
  neq?: InputMaybe<SimpleSoilTexture>;
  nin?: InputMaybe<Array<SimpleSoilTexture>>;
};

/** A soil sample. */
export type SoilSample = {
  __typename?: 'SoilSample';
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String'];
  coverCrop?: Maybe<CoverCrop>;
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  cropType?: Maybe<CropType>;
  cultivation?: Maybe<Cultivation>;
  farm?: Maybe<Farm>;
  field?: Maybe<Field>;
  /** Whether farmyard manure (FYM) was applied. */
  fym: Scalars['Boolean'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Whether this sample is from a reference zone. */
  isReferenceZone: Scalars['Boolean'];
  labResults?: Maybe<LabResultsConnection>;
  lastYearCrop?: Maybe<Crop>;
  location?: Maybe<GpsLocation>;
  /** Moisture level. */
  moisture?: Maybe<MoistureLevel>;
  /** Display name. */
  name: Scalars['String'];
  /** Date the sample was collected. */
  sampleDate?: Maybe<Scalars['LocalDate']>;
  /** Season. */
  season?: Maybe<Season>;
  soilType?: Maybe<SoilType>;
  /** Whether straw was removed. */
  strawRemoved: Scalars['Boolean'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
  yearBeforeLastCrop?: Maybe<Crop>;
};


/** A soil sample. */
export type SoilSampleLabResultsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<LabResultSortInput>>;
  where?: InputMaybe<LabResultFilterInput>;
};

/** A soil sample. */
export type SoilSampleFilterInput = {
  and?: InputMaybe<Array<SoilSampleFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Whether farmyard manure (FYM) was applied. */
  fym?: InputMaybe<BooleanOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Whether this sample is from a reference zone. */
  isReferenceZone?: InputMaybe<BooleanOperationFilterInput>;
  /** Moisture level. */
  moisture?: InputMaybe<NullableOfMoistureLevelOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SoilSampleFilterInput>>;
  /** Date the sample was collected. */
  sampleDate?: InputMaybe<LocalDateOperationFilterInput>;
  /** Season. */
  season?: InputMaybe<NullableOfSeasonOperationFilterInput>;
  /** Whether straw was removed. */
  strawRemoved?: InputMaybe<BooleanOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A soil sample. */
export type SoilSampleSortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Whether farmyard manure (FYM) was applied. */
  fym?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Whether this sample is from a reference zone. */
  isReferenceZone?: InputMaybe<SortEnumType>;
  /** Moisture level. */
  moisture?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** Date the sample was collected. */
  sampleDate?: InputMaybe<SortEnumType>;
  /** Season. */
  season?: InputMaybe<SortEnumType>;
  /** Whether straw was removed. */
  strawRemoved?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SoilSamplesConnection = {
  __typename?: 'SoilSamplesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SoilSamplesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SoilSample>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SoilSamplesEdge = {
  __typename?: 'SoilSamplesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SoilSample;
};

/** A type of soil (unique by normalized name). */
export type SoilType = {
  __typename?: 'SoilType';
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String'];
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** A type of soil (unique by normalized name). */
export type SoilTypeFilterInput = {
  and?: InputMaybe<Array<SoilTypeFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SoilTypeFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A type of soil (unique by normalized name). */
export type SoilTypeSortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SoilTypesConnection = {
  __typename?: 'SoilTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SoilTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SoilType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SoilTypesEdge = {
  __typename?: 'SoilTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SoilType;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StartFeatureExtractionExportInput = {
  /** Optional maximum number of valid tests to include, selected by name then UUID. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Whether to reuse valid current-version caches or re-extract every eligible test. */
  mode: FeatureExtractionExportMode;
  /** TRO UUID whose eligible PES tests should be exported. */
  troUuid: Scalars['UUID'];
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ncontains?: InputMaybe<Scalars['String']>;
  nendsWith?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nstartsWith?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

/** Cassette TRH type. */
export enum TrhType {
  Old = 'OLD',
  Spring_2025 = 'SPRING_2025'
}

export type TrhTypeOperationFilterInput = {
  eq?: InputMaybe<TrhType>;
  in?: InputMaybe<Array<TrhType>>;
  neq?: InputMaybe<TrhType>;
  nin?: InputMaybe<Array<TrhType>>;
};

/** Test run order metadata. */
export type Tro = {
  __typename?: 'TRO';
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
  /** Whether issue notifications should be sent for tests using this TRO. */
  showTestAlerts: Scalars['Boolean'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
  /** TRO UUID used by PES tests. */
  uuid: Scalars['UUID'];
};

export type TroManagementOverview = {
  __typename?: 'TROManagementOverview';
  tros: Array<TroSummary>;
  unknownTros: Array<UnknownTroSummary>;
};

export type TroSummary = {
  __typename?: 'TROSummary';
  id: Scalars['UUID'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  showTestAlerts: Scalars['Boolean'];
  totalTestCount: Scalars['Int'];
  uuid: Scalars['UUID'];
};

/** Number of PES tests on a given date. */
export type TestCountByDay = {
  __typename?: 'TestCountByDay';
  count: Scalars['Int'];
  date: Scalars['DateTime'];
};

/** A connection to a list of items. */
export type TestsConnection = {
  __typename?: 'TestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PesTest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TestsEdge = {
  __typename?: 'TestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PesTest;
};

/** A trained indicator for a machine learning model. */
export type TrainedIndicator = {
  __typename?: 'TrainedIndicator';
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  indicatorDefinition?: Maybe<LabIndicatorDefinition>;
  /** Optional sparse attention inference API model name for this indicator. */
  inferenceModelName?: Maybe<Scalars['String']>;
  /** Maximum value. */
  maxValue: Scalars['Float'];
  /** Minimum value. */
  minValue: Scalars['Float'];
  model?: Maybe<MlModel>;
  /** Computed name from the indicator definition. */
  name: Scalars['String'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** A trained indicator for a machine learning model. */
export type TrainedIndicatorFilterInput = {
  and?: InputMaybe<Array<TrainedIndicatorFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Optional sparse attention inference API model name for this indicator. */
  inferenceModelName?: InputMaybe<StringOperationFilterInput>;
  /** Maximum value. */
  maxValue?: InputMaybe<FloatOperationFilterInput>;
  /** Minimum value. */
  minValue?: InputMaybe<FloatOperationFilterInput>;
  or?: InputMaybe<Array<TrainedIndicatorFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A trained indicator for a machine learning model. */
export type TrainedIndicatorSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Optional sparse attention inference API model name for this indicator. */
  inferenceModelName?: InputMaybe<SortEnumType>;
  /** Maximum value. */
  maxValue?: InputMaybe<SortEnumType>;
  /** Minimum value. */
  minValue?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type TrainedIndicatorsConnection = {
  __typename?: 'TrainedIndicatorsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TrainedIndicatorsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TrainedIndicator>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TrainedIndicatorsEdge = {
  __typename?: 'TrainedIndicatorsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainedIndicator;
};

export type TransferPesTestInput = {
  /** Existing target farm ID. */
  existingFarmId?: InputMaybe<Scalars['UUID']>;
  /** Existing target field ID. */
  existingFieldId?: InputMaybe<Scalars['UUID']>;
  /** New target farm name. */
  newFarmName?: InputMaybe<Scalars['String']>;
  /** New target field name. */
  newFieldName?: InputMaybe<Scalars['String']>;
  /** Target organisation ID. */
  targetOrganisationId: Scalars['UUID'];
  /** Target user ID. */
  targetUserId: Scalars['UUID'];
  /** PESTest ID. */
  testId: Scalars['UUID'];
};

export type UnknownTroSummary = {
  __typename?: 'UnknownTROSummary';
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  totalTestCount: Scalars['Int'];
  uuid: Scalars['UUID'];
};

/** Input for updating a Batch. */
export type UpdateBatchInput = {
  batchNumber: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
};

/** Input for updating a Cassette. */
export type UpdateCassetteInput = {
  expiryDate: Scalars['DateTime'];
  extraMetadata: Scalars['String'];
  id: Scalars['UUID'];
  manufactureDate: Scalars['DateTime'];
  maxIndexTimeSeconds: Scalars['Float'];
  numSensors: Scalars['Int'];
  sensorCheckUuid: Scalars['UUID'];
  serialNumberId?: InputMaybe<Scalars['UUID']>;
  soilTestUuid: Scalars['UUID'];
  trhType: TrhType;
};

export type UpdateCoverCropInput = {
  /** CoverCrop ID. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
};

export type UpdateCropInput = {
  /** Crop ID. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
};

export type UpdateCropTypeInput = {
  /** CropType ID. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
};

export type UpdateCultivationInput = {
  /** Cultivation ID. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
};

export type UpdateCustomerInput = {
  /** Lab indicator definition IDs the customer's users may see (null = unchanged, [] = clear). Must be non-empty while limitIndicators is true. */
  allowedIndicatorDefinitionIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Cassette IDs to attach (null = unchanged, [] = clear). */
  cassetteIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Primary contact email address. */
  contactEmail?: InputMaybe<Scalars['String']>;
  /** Primary contact name. */
  contactName?: InputMaybe<Scalars['String']>;
  /** Primary contact phone number. */
  contactPhone?: InputMaybe<Scalars['String']>;
  /** When the customer relationship began. */
  customerSince: Scalars['DateTime'];
  /** Description. */
  description?: InputMaybe<Scalars['String']>;
  /** ERU IDs to attach (null = unchanged, [] = clear). */
  eruIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Customer ID. */
  id: Scalars['UUID'];
  /** Whether to limit visible results to the allowed indicator definitions (null = unchanged). */
  limitIndicators?: InputMaybe<Scalars['Boolean']>;
  /** Display name. */
  name: Scalars['String'];
  /** Internal notes. */
  notes?: InputMaybe<Scalars['String']>;
  /** Organisation IDs to attach (null = unchanged, [] = clear). */
  organisationIds?: InputMaybe<Array<Scalars['UUID']>>;
};

export type UpdateEruInput = {
  /** BLE identifier (unique when present). */
  bleId?: InputMaybe<Scalars['String']>;
  /** BLE MAC address (unique when present). */
  bleMac?: InputMaybe<Scalars['String']>;
  /** ERU ID. */
  id: Scalars['UUID'];
  /** Internal UUID for the ERU. */
  internalId: Scalars['UUID'];
  /** Display name. */
  name?: InputMaybe<Scalars['String']>;
};

/** Input for updating an Example. */
export type UpdateExampleInput = {
  id: Scalars['UUID'];
  name: Scalars['String'];
};

export type UpdateFarmInput = {
  /** Farm ID. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
  /** Owner name. */
  ownerName?: InputMaybe<Scalars['String']>;
  /** Postcode. */
  postcode?: InputMaybe<Scalars['String']>;
};

export type UpdateFieldInput = {
  /** Field ID. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
};

export type UpdateFirmwareInstallLogInput = {
  errorMessage?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  status: FirmwareInstallLogStatus;
  technicalLog?: InputMaybe<Scalars['String']>;
  updateToken: Scalars['String'];
};

export type UpdateLabIndicatorDefinitionInput = {
  /** Whether to always show this indicator. */
  alwaysShow: Scalars['Boolean'];
  /** Indicator description. */
  description?: InputMaybe<Scalars['String']>;
  /** Number of decimal places to display. */
  displayDecimalPlaces: Scalars['Int'];
  /** Optional display name override. */
  displayName?: InputMaybe<Scalars['String']>;
  /** Lab indicator definition ID. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
  /** Unit label. */
  unit: Scalars['String'];
  /** Value type. */
  valueType: LabIndicatorValueType;
};

export type UpdateLabResultInput = {
  /** LabResult ID. */
  id: Scalars['UUID'];
  /** Laboratory ID. */
  laboratoryId: Scalars['UUID'];
  /** Lab result value. */
  value: Scalars['String'];
};

export type UpdateLaboratoryInput = {
  /** Laboratory ID. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
};

/** Input for updating a localisation file from a newer base JSON upload or file-level translation context change. */
export type UpdateLocalisationFileInput = {
  jsonContent?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  translationContext?: InputMaybe<Scalars['String']>;
};

/** Input for updating one translated string. */
export type UpdateLocalisationTranslationInput = {
  fileName: Scalars['String'];
  isApproved: Scalars['Boolean'];
  key: Scalars['String'];
  locale: Scalars['String'];
  value: Scalars['String'];
};

export type UpdateMlModelInput = {
  /** MLModel ID. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
};

export type UpdateOrganisationInput = {
  contactEmail: Scalars['String'];
  contactNumber?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  isAutocreated: Scalars['Boolean'];
  logoUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  public: Scalars['Boolean'];
};

export type UpdatePesTestInput = {
  /** CropType ID. */
  cropTypeId: Scalars['UUID'];
  /** Whether to exclude from ML. */
  excludeFromMl: Scalars['Boolean'];
  /** Extra JSON metadata. */
  extraMetadata?: InputMaybe<Scalars['String']>;
  /** Failure reasons. */
  failureReasons?: InputMaybe<Array<Scalars['String']>>;
  /** Firmware version. */
  firmwareVersion: Scalars['String'];
  /** GPS accuracy in meters. */
  gpsAccuracy?: InputMaybe<Scalars['Float']>;
  /** GPS latitude. */
  gpsLatitude: Scalars['Float'];
  /** GPS longitude. */
  gpsLongitude: Scalars['Float'];
  /** PESTest ID. */
  id: Scalars['UUID'];
  /** Whether this test was run in debug mode. */
  isDebug: Scalars['Boolean'];
  /** Whether this test failed. */
  isFailure: Scalars['Boolean'];
  /** Whether this test is from a reference zone. */
  isReferenceZone: Scalars['Boolean'];
  /** Moisture level. */
  moisture: MoistureLevel;
  /** Display name. */
  name: Scalars['String'];
  /** Original model name. */
  originalModelName: Scalars['String'];
  /** Logical run UUID. */
  runId?: InputMaybe<Scalars['UUID']>;
  /** Season. */
  season: Season;
  /** Optional SoilSample ID. */
  soilSampleId?: InputMaybe<Scalars['UUID']>;
  /** Soil texture. */
  soilTexture: SimpleSoilTexture;
  /** SRF UUID. */
  srfUuid: Scalars['UUID'];
  /** Test type. */
  testType: PesTestType;
  /** TRO UUID. */
  troUuid: Scalars['UUID'];
  /** UTC test time. */
  utcTestTime: Scalars['DateTime'];
};

export type UpdatePesTestCharacteristicsInput = {
  /** CropType ID. */
  cropTypeId: Scalars['UUID'];
  /** Whether this test is from a reference zone. */
  isReferenceZone: Scalars['Boolean'];
  /** Moisture level. */
  moisture: MoistureLevel;
  /** Season. */
  season: Season;
  /** Soil texture. */
  soilTexture: SimpleSoilTexture;
  /** PESTest ID. */
  testId: Scalars['UUID'];
};

export type UpdatePesTestLocationInput = {
  /** GPS latitude. */
  latitude: Scalars['Float'];
  /** GPS longitude. */
  longitude: Scalars['Float'];
  /** PESTest ID. */
  testId: Scalars['UUID'];
};

export type UpdatePesTestNameInput = {
  /** Display name. */
  name: Scalars['String'];
  /** PESTest ID. */
  testId: Scalars['UUID'];
};

/** Input for updating a ProductType. */
export type UpdateProductTypeInput = {
  id: Scalars['UUID'];
  location: Scalars['String'];
  model: Scalars['String'];
  name: Scalars['String'];
  subType: Scalars['String'];
};

/** Input for updating a result. */
export type UpdateResultInput = {
  /** Result ID. */
  id: Scalars['UUID'];
  /** Result value. */
  value: Scalars['Float'];
};

export type UpdateSerialNumberInput = {
  /** Serial number ID. */
  id: Scalars['UUID'];
  /** Serial number (0-9999999). */
  serialNumber: Scalars['Int'];
};

export type UpdateSerialRangeInput = {
  /** Build description. */
  buildDescription: Scalars['String'];
  /** Build end date. */
  buildEndDate?: InputMaybe<Scalars['DateTime']>;
  /** Build start date. */
  buildStartDate: Scalars['DateTime'];
  /** Inclusive end of the range. */
  endNumber: Scalars['Int'];
  /** Firmware version. */
  firmwareVersion?: InputMaybe<Scalars['String']>;
  /** Serial range ID. */
  id: Scalars['UUID'];
  /** Notes. */
  notes?: InputMaybe<Scalars['String']>;
  /** Product type ID. */
  productTypeId: Scalars['UUID'];
  /** Inclusive start of the range. */
  startNumber: Scalars['Int'];
};

export type UpdateSoilSampleInput = {
  /** CoverCrop ID. */
  coverCropId?: InputMaybe<Scalars['UUID']>;
  /** CropType ID. */
  cropTypeId?: InputMaybe<Scalars['UUID']>;
  /** Cultivation ID. */
  cultivationId?: InputMaybe<Scalars['UUID']>;
  /** Farm ID. */
  farmId?: InputMaybe<Scalars['UUID']>;
  /** Field ID. */
  fieldId?: InputMaybe<Scalars['UUID']>;
  /** Whether farmyard manure (FYM) was applied. */
  fym: Scalars['Boolean'];
  /** GPS latitude. Provide both latitude and longitude to set a location. */
  gpsLatitude?: InputMaybe<Scalars['Float']>;
  /** GPS longitude. Provide both latitude and longitude to set a location. */
  gpsLongitude?: InputMaybe<Scalars['Float']>;
  /** SoilSample ID. */
  id: Scalars['UUID'];
  /** Whether this sample is from a reference zone. */
  isReferenceZone: Scalars['Boolean'];
  /** Last year's crop ID. */
  lastYearCropId?: InputMaybe<Scalars['UUID']>;
  /** Moisture level. */
  moisture?: InputMaybe<MoistureLevel>;
  /** Display name. */
  name: Scalars['String'];
  /** Date the sample was collected. */
  sampleDate?: InputMaybe<Scalars['LocalDate']>;
  /** Season. */
  season?: InputMaybe<Season>;
  /** SoilType ID. */
  soilTypeId?: InputMaybe<Scalars['UUID']>;
  /** Whether straw was removed. */
  strawRemoved: Scalars['Boolean'];
  /** Year before last crop ID. */
  yearBeforeLastCropId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateSoilTypeInput = {
  /** SoilType ID. */
  id: Scalars['UUID'];
  /** Display name. */
  name: Scalars['String'];
};

export type UpdateTroInput = {
  /** TRO database ID. */
  id: Scalars['UUID'];
  /** Optional replacement display name. */
  name?: InputMaybe<Scalars['String']>;
  /** Optional replacement alert setting. */
  showTestAlerts?: InputMaybe<Scalars['Boolean']>;
};

/** Input for updating a trained indicator. */
export type UpdateTrainedIndicatorInput = {
  /** Trained indicator ID. */
  id: Scalars['UUID'];
  /** Optional sparse attention inference API model name for this indicator. */
  inferenceModelName?: InputMaybe<Scalars['String']>;
  /** Maximum value. */
  maxValue: Scalars['Float'];
  /** Minimum value. */
  minValue: Scalars['Float'];
};

/** Input for updating a What3Words location. */
export type UpdateWhat3WordsLocationInput = {
  gpsLatitudeCenter: Scalars['Float'];
  gpsLatitudeNe: Scalars['Float'];
  gpsLatitudeSw: Scalars['Float'];
  gpsLongitudeCenter: Scalars['Float'];
  gpsLongitudeNe: Scalars['Float'];
  gpsLongitudeSw: Scalars['Float'];
  id: Scalars['UUID'];
  words: Scalars['String'];
};

/** A chunk of uploaded test data. */
export type UploadChunk = {
  __typename?: 'UploadChunk';
  /** Zero-based index of this chunk. */
  chunkIndex: Scalars['Int'];
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** JSON data for this chunk. */
  data: Scalars['String'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
  uploadRequest?: Maybe<UploadRequest>;
};

/** A chunk of uploaded test data. */
export type UploadChunkFilterInput = {
  and?: InputMaybe<Array<UploadChunkFilterInput>>;
  /** Zero-based index of this chunk. */
  chunkIndex?: InputMaybe<IntOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** JSON data for this chunk. */
  data?: InputMaybe<StringOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<UploadChunkFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A chunk of uploaded test data. */
export type UploadChunkSortInput = {
  /** Zero-based index of this chunk. */
  chunkIndex?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** JSON data for this chunk. */
  data?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

export type UploadFirmwareInput = {
  activate: Scalars['Boolean'];
  base64Data: Scalars['String'];
  fileName: Scalars['String'];
  version: Scalars['String'];
};

/** A request to upload test data in chunks. */
export type UploadRequest = {
  __typename?: 'UploadRequest';
  chunks?: Maybe<ChunksConnection>;
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  isComplete: Scalars['Boolean'];
  pesTest?: Maybe<PesTest>;
  /** When a worker last claimed this request for processing. */
  processingStartedAt?: Maybe<Scalars['DateTime']>;
  /** Current status of the upload request. */
  status: UploadRequestStatus;
  /** Total number of chunks expected. */
  totalChunks: Scalars['Int'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
};


/** A request to upload test data in chunks. */
export type UploadRequestChunksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<UploadChunkSortInput>>;
  where?: InputMaybe<UploadChunkFilterInput>;
};

export enum UploadRequestStatus {
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING'
}

export type User = {
  __typename?: 'User';
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  organisationInviteRequests?: Maybe<OrganisationInviteRequestsConnection>;
  organisationMemberships: Array<Organisation>;
  organisations?: Maybe<OrganisationsConnection>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  roles: Array<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type UserOrganisationInviteRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<OrganisationInviteRequestSortInput>>;
  where?: InputMaybe<OrganisationInviteRequestFilterInput>;
};


export type UserOrganisationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<OrganisationSortInput>>;
  where?: InputMaybe<OrganisationFilterInput>;
};

export type UserFilterInput = {
  accessFailedCount?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<UserFilterInput>>;
  concurrencyStamp?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  deletedAt?: InputMaybe<DateTimeOperationFilterInput>;
  deletionFailedAttempts?: InputMaybe<IntOperationFilterInput>;
  deletionLockedUntil?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  emailConfirmed?: InputMaybe<BooleanOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lockoutEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lockoutEnd?: InputMaybe<DateTimeOperationFilterInput>;
  magicLinkRedeemCount?: InputMaybe<IntOperationFilterInput>;
  normalizedEmail?: InputMaybe<StringOperationFilterInput>;
  normalizedUserName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserFilterInput>>;
  passwordHash?: InputMaybe<StringOperationFilterInput>;
  passwordResetCodeExpiresAt?: InputMaybe<DateTimeOperationFilterInput>;
  passwordResetCodeHash?: InputMaybe<StringOperationFilterInput>;
  passwordResetFailedAttempts?: InputMaybe<IntOperationFilterInput>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  phoneNumberConfirmed?: InputMaybe<BooleanOperationFilterInput>;
  profilePictureUrl?: InputMaybe<StringOperationFilterInput>;
  securityStamp?: InputMaybe<StringOperationFilterInput>;
  twoFactorEnabled?: InputMaybe<BooleanOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
};

export type UserSortInput = {
  accessFailedCount?: InputMaybe<SortEnumType>;
  concurrencyStamp?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  deletedAt?: InputMaybe<SortEnumType>;
  deletionFailedAttempts?: InputMaybe<SortEnumType>;
  deletionLockedUntil?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  emailConfirmed?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lockoutEnabled?: InputMaybe<SortEnumType>;
  lockoutEnd?: InputMaybe<SortEnumType>;
  magicLinkRedeemCount?: InputMaybe<SortEnumType>;
  normalizedEmail?: InputMaybe<SortEnumType>;
  normalizedUserName?: InputMaybe<SortEnumType>;
  passwordHash?: InputMaybe<SortEnumType>;
  passwordResetCodeExpiresAt?: InputMaybe<SortEnumType>;
  passwordResetCodeHash?: InputMaybe<SortEnumType>;
  passwordResetFailedAttempts?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<SortEnumType>;
  phoneNumberConfirmed?: InputMaybe<SortEnumType>;
  profilePictureUrl?: InputMaybe<SortEnumType>;
  securityStamp?: InputMaybe<SortEnumType>;
  twoFactorEnabled?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: User;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']>;
  gt?: InputMaybe<Scalars['UUID']>;
  gte?: InputMaybe<Scalars['UUID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  lt?: InputMaybe<Scalars['UUID']>;
  lte?: InputMaybe<Scalars['UUID']>;
  neq?: InputMaybe<Scalars['UUID']>;
  ngt?: InputMaybe<Scalars['UUID']>;
  ngte?: InputMaybe<Scalars['UUID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  nlt?: InputMaybe<Scalars['UUID']>;
  nlte?: InputMaybe<Scalars['UUID']>;
};

/** A What3Words location with center point and bounding box. */
export type What3WordsLocation = {
  __typename?: 'What3WordsLocation';
  /** When this record was created. */
  createdAt: Scalars['DateTime'];
  /** Center latitude. */
  gpsLatitudeCenter: Scalars['Float'];
  /** North-east latitude corner. */
  gpsLatitudeNe: Scalars['Float'];
  /** South-west latitude corner. */
  gpsLatitudeSw: Scalars['Float'];
  /** Center longitude. */
  gpsLongitudeCenter: Scalars['Float'];
  /** North-east longitude corner. */
  gpsLongitudeNe: Scalars['Float'];
  /** South-west longitude corner. */
  gpsLongitudeSw: Scalars['Float'];
  /** Unique identifier. */
  id: Scalars['UUID'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime'];
  /** What3Words triple (trimmed, exactly two dots). */
  words: Scalars['String'];
};

/** A What3Words location with center point and bounding box. */
export type What3WordsLocationFilterInput = {
  and?: InputMaybe<Array<What3WordsLocationFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Center latitude. */
  gpsLatitudeCenter?: InputMaybe<FloatOperationFilterInput>;
  /** North-east latitude corner. */
  gpsLatitudeNe?: InputMaybe<FloatOperationFilterInput>;
  /** South-west latitude corner. */
  gpsLatitudeSw?: InputMaybe<FloatOperationFilterInput>;
  /** Center longitude. */
  gpsLongitudeCenter?: InputMaybe<FloatOperationFilterInput>;
  /** North-east longitude corner. */
  gpsLongitudeNe?: InputMaybe<FloatOperationFilterInput>;
  /** South-west longitude corner. */
  gpsLongitudeSw?: InputMaybe<FloatOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<What3WordsLocationFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** What3Words triple (trimmed, exactly two dots). */
  words?: InputMaybe<StringOperationFilterInput>;
};

/** A What3Words location with center point and bounding box. */
export type What3WordsLocationSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Center latitude. */
  gpsLatitudeCenter?: InputMaybe<SortEnumType>;
  /** North-east latitude corner. */
  gpsLatitudeNe?: InputMaybe<SortEnumType>;
  /** South-west latitude corner. */
  gpsLatitudeSw?: InputMaybe<SortEnumType>;
  /** Center longitude. */
  gpsLongitudeCenter?: InputMaybe<SortEnumType>;
  /** North-east longitude corner. */
  gpsLongitudeNe?: InputMaybe<SortEnumType>;
  /** South-west longitude corner. */
  gpsLongitudeSw?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
  /** What3Words triple (trimmed, exactly two dots). */
  words?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type What3WordsLocationsConnection = {
  __typename?: 'What3WordsLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<What3WordsLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<What3WordsLocation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type What3WordsLocationsEdge = {
  __typename?: 'What3WordsLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: What3WordsLocation;
};

export type AuditLogsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  actionType?: InputMaybe<Scalars['String']>;
  occurredFrom?: InputMaybe<Scalars['DateTime']>;
  occurredTo?: InputMaybe<Scalars['DateTime']>;
  userName?: InputMaybe<Scalars['String']>;
}>;


export type AuditLogsQuery = { __typename?: 'Query', auditLogs?: { __typename?: 'AuditLogsConnection', nodes?: Array<{ __typename?: 'AuditLog', id: string, actionType: string, targetEntityType?: string | null, reason?: string | null, notes?: string | null, createdAt: string, actingUser?: { __typename?: 'User', id: string, fullName?: string | null, email?: string | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type AuditLogActionTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type AuditLogActionTypesQuery = { __typename?: 'Query', auditLogActionTypes: Array<string> };

export type RequestMagicLinkMutationVariables = Exact<{
  input: RequestMagicLinkInput;
}>;


export type RequestMagicLinkMutation = { __typename?: 'Mutation', requestMagicLink: boolean };

export type RedeemMagicLinkMutationVariables = Exact<{
  input: RedeemMagicLinkInput;
}>;


export type RedeemMagicLinkMutation = { __typename?: 'Mutation', redeemMagicLink?: string | null };

export type LoginWithPasswordMutationVariables = Exact<{
  input: LoginWithPasswordInput;
}>;


export type LoginWithPasswordMutation = { __typename?: 'Mutation', loginWithPassword?: string | null };

export type RequestPasswordResetMutationVariables = Exact<{
  input: RequestPasswordResetInput;
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset: boolean };

export type ResetPasswordWithCodeMutationVariables = Exact<{
  input: ResetPasswordWithCodeInput;
}>;


export type ResetPasswordWithCodeMutation = { __typename?: 'Mutation', resetPasswordWithCode?: string | null };

export type SetOwnPasswordMutationVariables = Exact<{
  input: SetOwnPasswordInput;
}>;


export type SetOwnPasswordMutation = { __typename?: 'Mutation', setOwnPassword: boolean };

export type ChangeOwnPasswordMutationVariables = Exact<{
  input: ChangeOwnPasswordInput;
}>;


export type ChangeOwnPasswordMutation = { __typename?: 'Mutation', changeOwnPassword: boolean };

export type PasswordAuthStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type PasswordAuthStatusQuery = { __typename?: 'Query', passwordAuthStatus: { __typename?: 'PasswordAuthStatus', hasPassword: boolean } };

export type MeQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, createdAt: string, email?: string | null, fullName?: string | null, profilePictureUrl?: string | null, organisations?: { __typename?: 'OrganisationsConnection', nodes?: Array<{ __typename?: 'Organisation', id: string, name: string, logoUrl?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } };

export type BackgroundJobStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type BackgroundJobStatusQuery = { __typename?: 'Query', backgroundJobStatus: { __typename?: 'BackgroundJobStatus', processingCount: number, queuedCount: number, scheduledCount: number, processingJobs: Array<{ __typename?: 'ProcessingBackgroundJob', jobId: string, displayName: string, methodType: string, queue?: string | null, startedAt?: string | null, elapsedSeconds: number, averageDurationSeconds?: number | null, etaSeconds?: number | null }>, queuedByType: Array<{ __typename?: 'QueuedBackgroundJobType', displayName: string, methodType: string, queue: string, count: number, nextScheduledAt?: string | null, averageDurationSeconds?: number | null, estimatedTotalDurationSeconds?: number | null }>, predictionBacklog: { __typename?: 'PredictionBacklogStatus', queuedPredictionCount: number, runningPredictionCount: number, effectiveWorkerSlots: number, averagePredictionDurationSeconds?: number | null, estimatedWaitSeconds?: number | null } } };

export type QueueBackgroundJobDelayTestMutationVariables = Exact<{ [key: string]: never; }>;


export type QueueBackgroundJobDelayTestMutation = { __typename?: 'Mutation', queueBackgroundJobDelayTest: string };

export type QueueBackgroundJobPredictionDelayTestMutationVariables = Exact<{ [key: string]: never; }>;


export type QueueBackgroundJobPredictionDelayTestMutation = { __typename?: 'Mutation', queueBackgroundJobPredictionDelayTest: string };

export type BatchesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type BatchesQuery = { __typename?: 'Query', batches?: { __typename?: 'BatchesConnection', nodes?: Array<{ __typename?: 'Batch', id: string, createdAt: string, name: string, batchNumber: string, description?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CreateBatchMutationVariables = Exact<{
  input: CreateBatchInput;
}>;


export type CreateBatchMutation = { __typename?: 'Mutation', createBatch: { __typename?: 'Batch', id: string, createdAt: string, name: string, batchNumber: string, description?: string | null } };

export type UpdateBatchMutationVariables = Exact<{
  input: UpdateBatchInput;
}>;


export type UpdateBatchMutation = { __typename?: 'Mutation', updateBatch?: { __typename?: 'Batch', id: string, createdAt: string, name: string, batchNumber: string, description?: string | null } | null };

export type CassettesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type CassettesQuery = { __typename?: 'Query', cassetteListSummary: { __typename?: 'CassetteListSummary', provisionedCount: number, allocatedCustomerTests: number, remainingCustomerTests: number, openOverflowWarningCount: number }, cassettes?: { __typename?: 'CassettesConnection', nodes?: Array<{ __typename?: 'Cassette', id: string, numSensors: number, manufactureDate: string, expiryDate: string, goodSensorCount: number, badSensorCount: number, allocatedCustomerTests: number, usedCustomerTests: number, remainingCustomerTests: number, physicalSensorsUsed: number, remainingPhysicalSensors: number, openOverflowRequestedTests: number, hasOpenOverflowWarning: boolean, lastUsedBy?: { __typename?: 'CassetteLastUsedInfo', fullName?: string | null, email?: string | null, usedAt: string } | null, serialNumber?: { __typename?: 'SerialNumber', serialNumber: number, range?: { __typename?: 'SerialRange', productType?: { __typename?: 'ProductType', code: string } | null } | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CassetteDetailQueryVariables = Exact<{
  id: Scalars['UUID'];
  afterEntitlementAdjustments?: InputMaybe<Scalars['String']>;
  firstEntitlementAdjustments: Scalars['Int'];
  afterOverflowRequests?: InputMaybe<Scalars['String']>;
  firstOverflowRequests: Scalars['Int'];
}>;


export type CassetteDetailQuery = { __typename?: 'Query', cassette?: { __typename?: 'Cassette', id: string, createdAt: string, updatedAt: string, numSensors: number, manufactureDate: string, expiryDate: string, maxIndexTimeSeconds: number, sensorCheckUuid: string, soilTestUuid: string, goodSensorCount: number, badSensorCount: number, baseCustomerTests: number, manualCustomerTestAdjustments: number, allocatedCustomerTests: number, usedCustomerTests: number, remainingCustomerTests: number, physicalSensorsUsed: number, remainingPhysicalSensors: number, currentCassetteExtraAllocatableTests: number, openOverflowRequestedTests: number, hasOpenOverflowWarning: boolean, serialNumber?: { __typename?: 'SerialNumber', serialNumber: number, range?: { __typename?: 'SerialRange', productType?: { __typename?: 'ProductType', code: string } | null } | null } | null, entitlementAdjustments?: { __typename?: 'EntitlementAdjustmentsConnection', nodes?: Array<{ __typename?: 'CassetteEntitlementAdjustment', id: string, customerTestDelta: number, reasonCode: string, notes?: string | null, createdAt: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null, overflowRequests?: { __typename?: 'OverflowRequestsConnection', nodes?: Array<{ __typename?: 'CassetteOverflowRequest', id: string, requestedTests: number, outstandingTests: number, reasonCode: string, notes?: string | null, status: string, resolvedAt?: string | null, createdAt: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type OpenCassetteOverflowRequestsQueryVariables = Exact<{
  excludingCassetteId?: InputMaybe<Scalars['UUID']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type OpenCassetteOverflowRequestsQuery = { __typename?: 'Query', openCassetteOverflowRequests?: { __typename?: 'OpenCassetteOverflowRequestsConnection', nodes?: Array<{ __typename?: 'CassetteOverflowRequest', id: string, requestedTests: number, outstandingTests: number, reasonCode: string, notes?: string | null, status: string, resolvedAt?: string | null, createdAt: string, cassette?: { __typename?: 'Cassette', id: string, serialNumber?: { __typename?: 'SerialNumber', serialNumber: number, range?: { __typename?: 'SerialRange', productType?: { __typename?: 'ProductType', code: string } | null } | null } | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type AddCassetteEntitlementAdjustmentMutationVariables = Exact<{
  input: AddCassetteEntitlementAdjustmentInput;
}>;


export type AddCassetteEntitlementAdjustmentMutation = { __typename?: 'Mutation', addCassetteEntitlementAdjustment: { __typename?: 'CassetteEntitlementAdjustment', id: string, customerTestDelta: number, reasonCode: string, notes?: string | null, createdAt: string } };

export type CreateCassetteOverflowRequestMutationVariables = Exact<{
  input: CreateCassetteOverflowRequestInput;
}>;


export type CreateCassetteOverflowRequestMutation = { __typename?: 'Mutation', createCassetteOverflowRequest: { __typename?: 'CassetteOverflowRequest', id: string, requestedTests: number, outstandingTests: number, reasonCode: string, notes?: string | null, status: string, createdAt: string } };

export type FulfilCassetteOverflowRequestMutationVariables = Exact<{
  input: FulfilCassetteOverflowRequestInput;
}>;


export type FulfilCassetteOverflowRequestMutation = { __typename?: 'Mutation', fulfilCassetteOverflowRequest: { __typename?: 'CassetteOverflowRequest', id: string, requestedTests: number, outstandingTests: number, reasonCode: string, notes?: string | null, status: string, resolvedAt?: string | null, createdAt: string } };

export type CoverCropsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type CoverCropsQuery = { __typename?: 'Query', coverCrops?: { __typename?: 'CoverCropsConnection', nodes?: Array<{ __typename?: 'CoverCrop', id: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CreateCoverCropMutationVariables = Exact<{
  input: CreateCoverCropInput;
}>;


export type CreateCoverCropMutation = { __typename?: 'Mutation', createCoverCrop: { __typename?: 'CoverCrop', id: string, name: string } };

export type CropsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type CropsQuery = { __typename?: 'Query', crops?: { __typename?: 'CropsConnection', nodes?: Array<{ __typename?: 'Crop', id: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CreateCropMutationVariables = Exact<{
  input: CreateCropInput;
}>;


export type CreateCropMutation = { __typename?: 'Mutation', createCrop: { __typename?: 'Crop', id: string, name: string } };

export type CropTypesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type CropTypesQuery = { __typename?: 'Query', cropTypes?: { __typename?: 'CropTypesConnection', nodes?: Array<{ __typename?: 'CropType', id: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CreateCropTypeMutationVariables = Exact<{
  input: CreateCropTypeInput;
}>;


export type CreateCropTypeMutation = { __typename?: 'Mutation', createCropType: { __typename?: 'CropType', id: string, name: string } };

export type CultivationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type CultivationsQuery = { __typename?: 'Query', cultivations?: { __typename?: 'CultivationsConnection', nodes?: Array<{ __typename?: 'Cultivation', id: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CreateCultivationMutationVariables = Exact<{
  input: CreateCultivationInput;
}>;


export type CreateCultivationMutation = { __typename?: 'Mutation', createCultivation: { __typename?: 'Cultivation', id: string, name: string } };

export type CustomersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type CustomersQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersConnection', nodes?: Array<{ __typename?: 'Customer', id: string, name: string, description?: string | null, contactName?: string | null, contactEmail?: string | null, contactPhone?: string | null, customerSince: string, notes?: string | null, createdAt: string, updatedAt: string, limitIndicators: boolean, allowedIndicatorDefinitions: Array<{ __typename?: 'LabIndicatorDefinition', id: string, name: string, displayName?: string | null }>, organisations?: { __typename?: 'OrganisationsConnection', nodes?: Array<{ __typename?: 'Organisation', id: string, name: string, logoUrl?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null, erus?: { __typename?: 'ErusConnection', nodes?: Array<{ __typename?: 'ERU', id: string, name?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null, cassettes?: { __typename?: 'CassettesConnection', nodes?: Array<{ __typename?: 'Cassette', id: string, remainingCustomerTests: number, remainingPhysicalSensors: number, hasOpenOverflowWarning: boolean, serialNumber?: { __typename?: 'SerialNumber', serialNumber: number, range?: { __typename?: 'SerialRange', productType?: { __typename?: 'ProductType', code: string } | null } | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type GetCustomerOrganisationsQueryVariables = Exact<{
  id: Scalars['UUID'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetCustomerOrganisationsQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: string, organisations?: { __typename?: 'OrganisationsConnection', nodes?: Array<{ __typename?: 'Organisation', id: string, name: string, logoUrl?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type GetCustomerErusQueryVariables = Exact<{
  id: Scalars['UUID'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetCustomerErusQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: string, erus?: { __typename?: 'ErusConnection', nodes?: Array<{ __typename?: 'ERU', id: string, name?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type GetCustomerCassettesQueryVariables = Exact<{
  id: Scalars['UUID'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetCustomerCassettesQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: string, cassettes?: { __typename?: 'CassettesConnection', nodes?: Array<{ __typename?: 'Cassette', id: string, remainingCustomerTests: number, remainingPhysicalSensors: number, hasOpenOverflowWarning: boolean, serialNumber?: { __typename?: 'SerialNumber', serialNumber: number, range?: { __typename?: 'SerialRange', productType?: { __typename?: 'ProductType', code: string } | null } | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type GetCustomerByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetCustomerByIdQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: string, name: string, description?: string | null, contactName?: string | null, contactEmail?: string | null, contactPhone?: string | null, customerSince: string, notes?: string | null, createdAt: string, updatedAt: string, limitIndicators: boolean, allowedIndicatorDefinitions: Array<{ __typename?: 'LabIndicatorDefinition', id: string, name: string, displayName?: string | null }>, organisations?: { __typename?: 'OrganisationsConnection', nodes?: Array<{ __typename?: 'Organisation', id: string, name: string, logoUrl?: string | null }> | null } | null, erus?: { __typename?: 'ErusConnection', nodes?: Array<{ __typename?: 'ERU', id: string, name?: string | null }> | null } | null, cassettes?: { __typename?: 'CassettesConnection', nodes?: Array<{ __typename?: 'Cassette', id: string, remainingCustomerTests: number, remainingPhysicalSensors: number, hasOpenOverflowWarning: boolean, serialNumber?: { __typename?: 'SerialNumber', serialNumber: number, range?: { __typename?: 'SerialRange', productType?: { __typename?: 'ProductType', code: string } | null } | null } | null }> | null } | null } | null };

export type DashboardCustomersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type DashboardCustomersQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersConnection', nodes?: Array<{ __typename?: 'Customer', id: string, name: string, organisations?: { __typename?: 'OrganisationsConnection', nodes?: Array<{ __typename?: 'Organisation', id: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CreateCustomerMutationVariables = Exact<{
  input: CreateCustomerInput;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer: { __typename?: 'Customer', id: string, name: string, description?: string | null, contactName?: string | null, contactEmail?: string | null, contactPhone?: string | null, customerSince: string, notes?: string | null, createdAt: string } };

export type UpdateCustomerMutationVariables = Exact<{
  input: UpdateCustomerInput;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer?: { __typename?: 'Customer', id: string, name: string, description?: string | null, contactName?: string | null, contactEmail?: string | null, contactPhone?: string | null, notes?: string | null, limitIndicators: boolean, allowedIndicatorDefinitions: Array<{ __typename?: 'LabIndicatorDefinition', id: string, name: string, displayName?: string | null }> } | null };

export type DeleteCustomerMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteCustomerMutation = { __typename?: 'Mutation', deleteCustomer: boolean };

export type DashboardStatsQueryVariables = Exact<{
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  previousStartDate: Scalars['DateTime'];
  previousEndDate: Scalars['DateTime'];
  includedOrganisationIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  excludedOrganisationIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type DashboardStatsQuery = { __typename?: 'Query', dashboardStats: { __typename?: 'DashboardStats', currentPeriod: Array<{ __typename?: 'DailyTestMetrics', date: string, totalCount: number, soilTests: number, successfulSensorChecks: number, failedSensorChecks: number }>, previousPeriod: Array<{ __typename?: 'DailyTestMetrics', date: string, totalCount: number, soilTests: number, successfulSensorChecks: number, failedSensorChecks: number }>, organisationStats: Array<{ __typename?: 'OrganisationTestStats', organisationId: string, organisationName: string, soilTests: number, successfulSensorChecks: number, failedSensorChecks: number }>, mapPoints: Array<{ __typename?: 'MapPoint', testId: string, latitude: number, longitude: number, what3Words?: string | null, testName?: string | null, organisationName?: string | null }> } };

export type DuplicatedLabResultsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type DuplicatedLabResultsCountQuery = { __typename?: 'Query', duplicatedLabResultsCount: number };

export type DedupeLabResultsMutationVariables = Exact<{ [key: string]: never; }>;


export type DedupeLabResultsMutation = { __typename?: 'Mutation', dedupeLabResults: number };

export type ErUsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type ErUsQuery = { __typename?: 'Query', erus?: { __typename?: 'ErusConnection', nodes?: Array<{ __typename?: 'ERU', id: string, name?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type FarmsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type FarmsQuery = { __typename?: 'Query', farms?: { __typename?: 'FarmsConnection', nodes?: Array<{ __typename?: 'Farm', id: string, name: string, organisation?: { __typename?: 'Organisation', id: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type FeatureExtractionExportRunsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type FeatureExtractionExportRunsQuery = { __typename?: 'Query', featureExtractionExportRuns?: { __typename?: 'FeatureExtractionExportRunsConnection', nodes?: Array<{ __typename?: 'FeatureExtractionExportRun', id: string, troUuid: string, featureSetVersion: string, mode: FeatureExtractionExportMode, testLimit?: number | null, status: FeatureExtractionExportStatus, requestedByEmail?: string | null, totalTestCount: number, excludedTestCount: number, reusedCacheCount: number, queuedExtractionCount: number, completedExtractionCount: number, failedExtractionCount: number, labResultWarningCount: number, startedAt?: string | null, completedAt?: string | null, errorSummary?: string | null, csvSizeBytes?: any | null, csvRowCount?: number | null, csvColumnCount?: number | null, downloadState: FeatureExtractionExportDownloadState, createdAt: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type FeatureExtractionExportRunQueryVariables = Exact<{
  id: Scalars['UUID'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type FeatureExtractionExportRunQuery = { __typename?: 'Query', featureExtractionExportRun?: { __typename?: 'FeatureExtractionExportRun', id: string, troUuid: string, featureSetVersion: string, mode: FeatureExtractionExportMode, testLimit?: number | null, status: FeatureExtractionExportStatus, requestedByEmail?: string | null, totalTestCount: number, excludedTestCount: number, reusedCacheCount: number, queuedExtractionCount: number, completedExtractionCount: number, failedExtractionCount: number, labResultWarningCount: number, startedAt?: string | null, completedAt?: string | null, errorSummary?: string | null, csvSizeBytes?: any | null, csvRowCount?: number | null, csvColumnCount?: number | null, downloadState: FeatureExtractionExportDownloadState, createdAt: string, failedItems?: { __typename?: 'FailedItemsConnection', nodes?: Array<{ __typename?: 'FeatureExtractionExportItem', id: string, testId: string, testName: string, attemptCount: number, error?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type StartFeatureExtractionExportMutationVariables = Exact<{
  input: StartFeatureExtractionExportInput;
}>;


export type StartFeatureExtractionExportMutation = { __typename?: 'Mutation', startFeatureExtractionExport: { __typename?: 'FeatureExtractionExportRun', id: string, troUuid: string, featureSetVersion: string, mode: FeatureExtractionExportMode, testLimit?: number | null, status: FeatureExtractionExportStatus, createdAt: string } };

export type FeatureExtractionExportDownloadUrlMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type FeatureExtractionExportDownloadUrlMutation = { __typename?: 'Mutation', featureExtractionExportDownloadUrl?: { __typename?: 'FeatureExtractionExportDownload', url: string, expiresAt: string, fileName: string } | null };

export type FieldsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type FieldsQuery = { __typename?: 'Query', fields?: { __typename?: 'FieldsConnection', nodes?: Array<{ __typename?: 'Field', name: string, id: string, farm?: { __typename?: 'Farm', id: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type FieldsForFarmQueryVariables = Exact<{
  farmId: Scalars['UUID'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type FieldsForFarmQuery = { __typename?: 'Query', farm?: { __typename?: 'Farm', id: string, fields?: { __typename?: 'FieldsConnection', nodes?: Array<{ __typename?: 'Field', id: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type FirmwareVersionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type FirmwareVersionsQuery = { __typename?: 'Query', firmwareVersions?: { __typename?: 'FirmwareVersionsConnection', nodes?: Array<{ __typename?: 'FirmwareVersion', id: string, createdAt: string, version: string, fileName: string, byteLength: any, sha256: string, isActive: boolean, installCount: number, uploadedByUser?: { __typename?: 'User', id: string, fullName?: string | null, email?: string | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type FirmwareInstallLogsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type FirmwareInstallLogsQuery = { __typename?: 'Query', firmwareInstallLogs?: { __typename?: 'FirmwareInstallLogsConnection', nodes?: Array<{ __typename?: 'FirmwareInstallLog', id: string, createdAt: string, updatedAt: string, status: FirmwareInstallLogStatus, eruName?: string | null, runtimePortName?: string | null, runtimeSerialNumber?: string | null, runtimeProductId?: string | null, dfuSerialNumber?: string | null, dfuProductId?: string | null, fromVersion?: string | null, toVersion: string, completedAt?: string | null, errorMessage?: string | null, technicalLog?: string | null, firmwareVersion?: { __typename?: 'FirmwareVersion', id: string, version: string } | null, eru?: { __typename?: 'ERU', id: string, name?: string | null, bleId?: string | null, bleMac?: string | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type UploadFirmwareMutationVariables = Exact<{
  input: UploadFirmwareInput;
}>;


export type UploadFirmwareMutation = { __typename?: 'Mutation', uploadFirmware: { __typename?: 'FirmwareVersion', id: string, version: string, isActive: boolean } };

export type SetActiveFirmwareVersionMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type SetActiveFirmwareVersionMutation = { __typename?: 'Mutation', setActiveFirmwareVersion?: { __typename?: 'FirmwareVersion', id: string, version: string, isActive: boolean } | null };

export type LabIndicatorDefinitionQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type LabIndicatorDefinitionQuery = { __typename?: 'Query', labIndicatorDefinition?: { __typename?: 'LabIndicatorDefinition', id: string, valueType: LabIndicatorValueType, unit: string, name: string, displayName?: string | null, updatedAt: string, createdAt: string, alwaysShow: boolean } | null };

export type LabIndicatorDefinitionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type LabIndicatorDefinitionsQuery = { __typename?: 'Query', labIndicatorDefinitions?: { __typename?: 'LabIndicatorDefinitionsConnection', nodes?: Array<{ __typename?: 'LabIndicatorDefinition', id: string, valueType: LabIndicatorValueType, unit: string, name: string, displayName?: string | null, updatedAt: string, createdAt: string, alwaysShow: boolean }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CreateLabIndicatorDefinitionMutationVariables = Exact<{
  input: CreateLabIndicatorDefinitionInput;
}>;


export type CreateLabIndicatorDefinitionMutation = { __typename?: 'Mutation', createLabIndicatorDefinition: { __typename?: 'LabIndicatorDefinition', id: string, valueType: LabIndicatorValueType, unit: string, name: string, updatedAt: string, createdAt: string, alwaysShow: boolean } };

export type LabResultQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type LabResultQuery = { __typename?: 'Query', labResult?: { __typename?: 'LabResult', id: string, createdAt: string, updatedAt: string, value: string, laboratory?: { __typename?: 'Laboratory', id: string, name: string } | null, indicator?: { __typename?: 'LabIndicatorDefinition', id: string, name: string } | null, soilSample?: { __typename?: 'SoilSample', id: string } | null } | null };

export type CreateLabResultMutationVariables = Exact<{
  input: CreateLabResultInput;
}>;


export type CreateLabResultMutation = { __typename?: 'Mutation', createLabResult: { __typename?: 'LabResult', id: string, createdAt: string, updatedAt: string, value: string, laboratory?: { __typename?: 'Laboratory', id: string, name: string } | null, indicator?: { __typename?: 'LabIndicatorDefinition', id: string, name: string } | null, soilSample?: { __typename?: 'SoilSample', id: string } | null } };

export type UpdateLabResultMutationVariables = Exact<{
  input: UpdateLabResultInput;
}>;


export type UpdateLabResultMutation = { __typename?: 'Mutation', updateLabResult?: { __typename?: 'LabResult', id: string, createdAt: string, updatedAt: string, value: string, laboratory?: { __typename?: 'Laboratory', id: string, name: string } | null, indicator?: { __typename?: 'LabIndicatorDefinition', id: string, name: string } | null, soilSample?: { __typename?: 'SoilSample', id: string } | null } | null };

export type LaboratoriesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type LaboratoriesQuery = { __typename?: 'Query', laboratories?: { __typename?: 'LaboratoriesConnection', nodes?: Array<{ __typename?: 'Laboratory', id: string, name: string, updatedAt: string, createdAt: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CreateLaboratoryMutationVariables = Exact<{
  input: CreateLaboratoryInput;
}>;


export type CreateLaboratoryMutation = { __typename?: 'Mutation', createLaboratory: { __typename?: 'Laboratory', id: string, name: string, updatedAt: string, createdAt: string } };

export type LocalisationAdminOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type LocalisationAdminOverviewQuery = { __typename?: 'Query', localisationAdminOverview: { __typename?: 'LocalisationAdminOverview', enabledLocales: Array<string>, enabledLocaleSummaries: Array<{ __typename?: 'LocalisationEnabledLocaleSummary', locale: string, setupStatus?: string | null, setupFailureMessage?: string | null, setupUpdatedAt?: string | null }>, files: Array<{ __typename?: 'LocalisationFileSummary', name: string, baseEntryCount: number, targetLocaleCount: number, targetLocales: Array<string>, translationContext?: string | null, updatedAt: string, setupStatus?: string | null, setupFailureMessage?: string | null, setupUpdatedAt?: string | null }> } };

export type LocalisationEditorQueryVariables = Exact<{
  name: Scalars['String'];
  locale: Scalars['String'];
}>;


export type LocalisationEditorQuery = { __typename?: 'Query', localisationEditor: { __typename?: 'LocalisationEditorView', fileName: string, locale: string, rows: Array<{ __typename?: 'LocalisationEditorRow', key: string, baseValue: string, targetValue?: string | null, effectiveValue: string, isFallback: boolean, isApproved: boolean, isTranslating: boolean }> } };

export type CreateLocalisationFileMutationVariables = Exact<{
  input: CreateLocalisationFileInput;
}>;


export type CreateLocalisationFileMutation = { __typename?: 'Mutation', createLocalisationFile: { __typename?: 'LocalisationFileSummary', name: string, baseEntryCount: number, targetLocaleCount: number, targetLocales: Array<string>, translationContext?: string | null, updatedAt: string } };

export type UpdateLocalisationFileMutationVariables = Exact<{
  input: UpdateLocalisationFileInput;
}>;


export type UpdateLocalisationFileMutation = { __typename?: 'Mutation', updateLocalisationFile: { __typename?: 'LocalisationFileSummary', name: string, baseEntryCount: number, targetLocaleCount: number, targetLocales: Array<string>, translationContext?: string | null, updatedAt: string } };

export type AddLocalisationTargetLocaleMutationVariables = Exact<{
  input: AddLocalisationTargetLocaleInput;
}>;


export type AddLocalisationTargetLocaleMutation = { __typename?: 'Mutation', addLocalisationTargetLocale: { __typename?: 'LocalisationFileSummary', name: string, baseEntryCount: number, targetLocaleCount: number, targetLocales: Array<string>, translationContext?: string | null, updatedAt: string } };

export type UpdateLocalisationTranslationMutationVariables = Exact<{
  input: UpdateLocalisationTranslationInput;
}>;


export type UpdateLocalisationTranslationMutation = { __typename?: 'Mutation', updateLocalisationTranslation: boolean };

export type QueueLocalisationTranslationMutationVariables = Exact<{
  input: QueueLocalisationTranslationInput;
}>;


export type QueueLocalisationTranslationMutation = { __typename?: 'Mutation', queueLocalisationTranslation: string };

export type SetLocalisationLocaleEnabledMutationVariables = Exact<{
  input: SetLocalisationLocaleEnabledInput;
}>;


export type SetLocalisationLocaleEnabledMutation = { __typename?: 'Mutation', setLocalisationLocaleEnabled: { __typename?: 'SetLocalisationLocaleEnabledResult', locale: string, isEnabled: boolean } };

export type MlModelsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type MlModelsQuery = { __typename?: 'Query', mlModels?: { __typename?: 'MlModelsConnection', nodes?: Array<{ __typename?: 'MLModel', id: string, name: string, createdAt: string, trainedIndicators?: { __typename?: 'TrainedIndicatorsConnection', nodes?: Array<{ __typename?: 'TrainedIndicator', id: string, name: string, inferenceModelName?: string | null, maxValue: number, minValue: number }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type OrganisationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type OrganisationsQuery = { __typename?: 'Query', organisations?: { __typename?: 'OrganisationsConnection', nodes?: Array<{ __typename?: 'Organisation', name: string, id: string, logoUrl?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type PesTestQueryVariables = Exact<{
  id: Scalars['UUID'];
  resultsAfter?: InputMaybe<Scalars['String']>;
}>;


export type PesTestQuery = { __typename?: 'Query', pesTest?: { __typename?: 'PESTest', id: string, createdAt: string, utcTestTime: string, runId?: string | null, name: string, displayCropTypeName?: string | null, hasResults: boolean, isReferenceZone: boolean, testType: PesTestType, isFailure: boolean, failureReasons: Array<string>, excludeFromMl: boolean, sampleFileUrl?: string | null, originalModelName: string, troUuid: string, moisture: MoistureLevel, soilTexture: SimpleSoilTexture, season: Season, tro?: { __typename?: 'TRO', id: string, name: string } | null, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, createdBy?: { __typename?: 'User', id: string, fullName?: string | null, email?: string | null, organisationMemberships: Array<{ __typename?: 'Organisation', id: string, name: string }> } | null, cropType?: { __typename?: 'CropType', id: string, name: string } | null, farm?: { __typename?: 'Farm', id: string, name: string } | null, field?: { __typename?: 'Field', id: string, name: string } | null, location?: { __typename?: 'GPSLocation', id: string, latitude: number, longitude: number, what3Words?: { __typename?: 'What3WordsLocation', words: string } | null } | null, cassette?: { __typename?: 'Cassette', id: string, serialNumber?: { __typename?: 'SerialNumber', id: string, serialNumber: number, range?: { __typename?: 'SerialRange', id: string, productType?: { __typename?: 'ProductType', id: string, code: string } | null } | null } | null } | null, eru?: { __typename?: 'ERU', id: string, name?: string | null } | null, featureCaches: Array<{ __typename?: 'PESTestFeatureCache', id: string, sampleId: string, featureSetVersion: string, featureCount: number, extractedAt: string, sourceUri: string, payloadSha256?: string | null, createdAt: string, updatedAt: string, warningSummary: { __typename?: 'PESTestFeatureCacheWarningSummary', hasWarnings: boolean, status?: string | null, messages: Array<string> } }>, soilSample?: { __typename?: 'SoilSample', id: string, name: string, location?: { __typename?: 'GPSLocation', id: string, latitude: number, longitude: number, what3Words?: { __typename?: 'What3WordsLocation', words: string } | null } | null } | null, results?: { __typename?: 'ResultsConnection', nodes?: Array<{ __typename?: 'Result', id: string, value: number, createdAt: string, updatedAt: string, indicator?: { __typename?: 'TrainedIndicator', id: string, minValue: number, maxValue: number, model?: { __typename?: 'MLModel', id: string, name: string } | null, indicatorDefinition?: { __typename?: 'LabIndicatorDefinition', id: string, name: string, unit: string, description?: string | null, displayName?: string | null } | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type PesTestFeatureCacheFeaturesQueryVariables = Exact<{
  id: Scalars['UUID'];
  search: Scalars['String'];
  limit: Scalars['Int'];
}>;


export type PesTestFeatureCacheFeaturesQuery = { __typename?: 'Query', pesTest?: { __typename?: 'PESTest', id: string, featureCaches: Array<{ __typename?: 'PESTestFeatureCache', id: string, featureMatches: Array<{ __typename?: 'PESTestFeatureCacheFeature', name: string, value?: number | null, displayValue: string, hasValue: boolean }> }> } | null };

export type UserPesTestQueryVariables = Exact<{
  id: Scalars['UUID'];
  resultsAfter?: InputMaybe<Scalars['String']>;
}>;


export type UserPesTestQuery = { __typename?: 'Query', pesTest?: { __typename?: 'PESTest', id: string, createdAt: string, name: string, hasResults: boolean, displayCropTypeName?: string | null, isReferenceZone: boolean, moisture: MoistureLevel, soilTexture: SimpleSoilTexture, season: Season, cropType?: { __typename?: 'CropType', id: string, name: string } | null, farm?: { __typename?: 'Farm', id: string, name: string } | null, field?: { __typename?: 'Field', id: string, name: string } | null, location?: { __typename?: 'GPSLocation', id: string, latitude: number, longitude: number, what3Words?: { __typename?: 'What3WordsLocation', words: string } | null } | null, results?: { __typename?: 'ResultsConnection', nodes?: Array<{ __typename?: 'Result', id: string, value: number, createdAt: string, indicator?: { __typename?: 'TrainedIndicator', id: string, minValue: number, maxValue: number, model?: { __typename?: 'MLModel', id: string, name: string } | null, indicatorDefinition?: { __typename?: 'LabIndicatorDefinition', id: string, name: string, unit: string, description?: string | null, displayName?: string | null, displayDecimalPlaces: number } | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type PesTestsQueryVariables = Exact<{
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<PesTestFilterInput>;
  order?: InputMaybe<Array<PesTestSortInput> | PesTestSortInput>;
}>;


export type PesTestsQuery = { __typename?: 'Query', pesTests?: { __typename?: 'PesTestsConnection', nodes?: Array<{ __typename?: 'PESTest', id: string, name: string, sampleFileUrl?: string | null, createdAt: string, utcTestTime: string, testType: PesTestType, isFailure: boolean, excludeFromMl: boolean, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, createdBy?: { __typename?: 'User', id: string, fullName?: string | null, email?: string | null } | null, location?: { __typename?: 'GPSLocation', id: string, latitude: number, longitude: number, what3Words?: { __typename?: 'What3WordsLocation', words: string } | null } | null, soilSample?: { __typename?: 'SoilSample', id: string, name: string } | null, farm?: { __typename?: 'Farm', id: string, name: string } | null, field?: { __typename?: 'Field', id: string, name: string } | null, cassette?: { __typename?: 'Cassette', id: string, serialNumber?: { __typename?: 'SerialNumber', id: string, serialNumber: number, range?: { __typename?: 'SerialRange', id: string, productType?: { __typename?: 'ProductType', id: string, code: string } | null } | null } | null } | null, eru?: { __typename?: 'ERU', id: string, name?: string | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type SearchPesTestsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<PesTestFilterInput>;
  order?: InputMaybe<Array<PesTestSortInput> | PesTestSortInput>;
}>;


export type SearchPesTestsQuery = { __typename?: 'Query', pesTests?: { __typename?: 'PesTestsConnection', nodes?: Array<{ __typename?: 'PESTest', id: string, createdAt: string, utcTestTime: string, name: string, testType: PesTestType, isReferenceZone: boolean, location?: { __typename?: 'GPSLocation', id: string, latitude: number, longitude: number, what3Words?: { __typename?: 'What3WordsLocation', words: string } | null } | null, farm?: { __typename?: 'Farm', id: string, name: string } | null, field?: { __typename?: 'Field', id: string, name: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type UpdateExcludeFromMlMutationVariables = Exact<{
  testId: Scalars['UUID'];
  exclude: Scalars['Boolean'];
}>;


export type UpdateExcludeFromMlMutation = { __typename?: 'Mutation', updateExcludeFromMl?: { __typename?: 'PESTest', id: string, excludeFromMl: boolean } | null };

export type RenamePesTestMutationVariables = Exact<{
  input: UpdatePesTestNameInput;
}>;


export type RenamePesTestMutation = { __typename?: 'Mutation', renamePesTest?: { __typename?: 'PESTest', id: string, name: string } | null };

export type UpdatePesTestLocationMutationVariables = Exact<{
  input: UpdatePesTestLocationInput;
}>;


export type UpdatePesTestLocationMutation = { __typename?: 'Mutation', updatePesTestLocation?: { __typename?: 'PESTest', id: string } | null };

export type UpdatePesTestCharacteristicsMutationVariables = Exact<{
  input: UpdatePesTestCharacteristicsInput;
}>;


export type UpdatePesTestCharacteristicsMutation = { __typename?: 'Mutation', updatePesTestCharacteristics?: { __typename?: 'PESTest', id: string } | null };

export type MarkTestFailedMutationVariables = Exact<{
  input: MarkTestFailedInput;
}>;


export type MarkTestFailedMutation = { __typename?: 'Mutation', markTestFailed?: { __typename?: 'PESTest', id: string, isFailure: boolean, failureReasons: Array<string> } | null };

export type TransferPesTestMutationVariables = Exact<{
  input: TransferPesTestInput;
}>;


export type TransferPesTestMutation = { __typename?: 'Mutation', transferPesTest: { __typename?: 'PESTest', id: string, createdBy?: { __typename?: 'User', id: string, fullName?: string | null, email?: string | null, organisationMemberships: Array<{ __typename?: 'Organisation', id: string, name: string }> } | null, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, farm?: { __typename?: 'Farm', id: string, name: string } | null, field?: { __typename?: 'Field', id: string, name: string } | null } };

export type DeletePesTestMutationVariables = Exact<{
  input: DeletePesTestInput;
}>;


export type DeletePesTestMutation = { __typename?: 'Mutation', deletePESTest: boolean };

export type QueuePesTestPredictionMutationVariables = Exact<{
  input: QueuePesTestPredictionInput;
}>;


export type QueuePesTestPredictionMutation = { __typename?: 'Mutation', queuePesTestPrediction?: { __typename?: 'PESTest', id: string } | null };

export type RecoverPesTestFeatureCacheMutationVariables = Exact<{
  testId: Scalars['UUID'];
}>;


export type RecoverPesTestFeatureCacheMutation = { __typename?: 'Mutation', recoverPesTestFeatureCache?: { __typename?: 'PESTestFeatureCache', id: string } | null };

export type PurgePesTestFeatureCacheMutationVariables = Exact<{
  input: PurgePesTestFeatureCacheInput;
}>;


export type PurgePesTestFeatureCacheMutation = { __typename?: 'Mutation', purgePesTestFeatureCache: { __typename?: 'PESTestFeatureCachePurgeResult', purgedCount: number, testIds: Array<string>, sampleIds: Array<string> } };

export type PurgePesTestFeatureCachesMutationVariables = Exact<{
  input: PurgePesTestFeatureCachesInput;
}>;


export type PurgePesTestFeatureCachesMutation = { __typename?: 'Mutation', purgePesTestFeatureCaches: { __typename?: 'PESTestFeatureCachePurgeResult', purgedCount: number, testIds: Array<string>, sampleIds: Array<string> } };

export type PesTestFeatureCacheOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type PesTestFeatureCacheOverviewQuery = { __typename?: 'Query', pesTestFeatureCacheOverview: { __typename?: 'PESTestFeatureCacheOverview', activeCacheCount: number, activeTestCount: number, activeFeatureCount: any, lastExtractedAt?: string | null } };

export type PesTestResultsQueryVariables = Exact<{
  testId: Scalars['UUID'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type PesTestResultsQuery = { __typename?: 'Query', pesTest?: { __typename?: 'PESTest', id: string, results?: { __typename?: 'ResultsConnection', nodes?: Array<{ __typename?: 'Result', id: string, value: number, createdAt: string, indicator?: { __typename?: 'TrainedIndicator', id: string, name: string, minValue: number, maxValue: number, model?: { __typename?: 'MLModel', id: string, name: string } | null, indicatorDefinition?: { __typename?: 'LabIndicatorDefinition', id: string, name: string, displayName?: string | null, description?: string | null, unit: string, displayDecimalPlaces: number } | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type AdjacentPesTestQueryVariables = Exact<{
  where?: InputMaybe<PesTestFilterInput>;
  order?: InputMaybe<Array<PesTestSortInput> | PesTestSortInput>;
}>;


export type AdjacentPesTestQuery = { __typename?: 'Query', pesTests?: { __typename?: 'PesTestsConnection', nodes?: Array<{ __typename?: 'PESTest', id: string }> | null } | null };

export type TransferOrganisationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type TransferOrganisationsQuery = { __typename?: 'Query', organisations?: { __typename?: 'OrganisationsConnection', nodes?: Array<{ __typename?: 'Organisation', id: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type TransferFarmsQueryVariables = Exact<{
  organisationId: Scalars['UUID'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type TransferFarmsQuery = { __typename?: 'Query', organisationById?: { __typename?: 'Organisation', farms?: { __typename?: 'FarmsConnection', nodes?: Array<{ __typename?: 'Farm', id: string, name: string, organisation?: { __typename?: 'Organisation', id: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type TransferFieldsQueryVariables = Exact<{
  farmId: Scalars['UUID'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type TransferFieldsQuery = { __typename?: 'Query', farm?: { __typename?: 'Farm', id: string, fields?: { __typename?: 'FieldsConnection', nodes?: Array<{ __typename?: 'Field', id: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type PesTestIndicatorLimitQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type PesTestIndicatorLimitQuery = { __typename?: 'Query', pesTest?: { __typename?: 'PESTest', id: string, allowedIndicatorDefinitions?: Array<{ __typename?: 'LabIndicatorDefinition', id: string, name: string, displayName?: string | null }> | null } | null };

export type ProductTypesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type ProductTypesQuery = { __typename?: 'Query', productTypes?: { __typename?: 'ProductTypesConnection', nodes?: Array<{ __typename?: 'ProductType', id: string, createdAt: string, name: string, code: string, location: string, model: string, subType: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type ReportQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ReportQuery = { __typename?: 'Query', reports?: { __typename?: 'ReportsConnection', nodes?: Array<{ __typename?: 'Report', id: string, name: string, createdBy?: { __typename?: 'User', id: string, fullName?: string | null, email?: string | null } | null }> | null } | null };

export type ReportPesTestsQueryVariables = Exact<{
  id: Scalars['UUID'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type ReportPesTestsQuery = { __typename?: 'Query', reports?: { __typename?: 'ReportsConnection', nodes?: Array<{ __typename?: 'Report', pesTests?: { __typename?: 'PesTestsConnection', nodes?: Array<{ __typename?: 'PESTest', id: string, originalModelName: string, isFailure: boolean, createdAt: string, name: string, allowedIndicatorDefinitions?: Array<{ __typename?: 'LabIndicatorDefinition', id: string, name: string, displayName?: string | null }> | null, location?: { __typename?: 'GPSLocation', id: string, latitude: number, longitude: number, what3Words?: { __typename?: 'What3WordsLocation', words: string } | null } | null, farm?: { __typename?: 'Farm', id: string, name: string } | null, field?: { __typename?: 'Field', id: string, name: string } | null, results?: { __typename?: 'ResultsConnection', nodes?: Array<{ __typename?: 'Result', id: string, createdAt: string, value: number, indicator?: { __typename?: 'TrainedIndicator', id: string, name: string, minValue: number, maxValue: number, model?: { __typename?: 'MLModel', id: string, name: string } | null, indicatorDefinition?: { __typename?: 'LabIndicatorDefinition', id: string, name: string, displayName?: string | null, description?: string | null, unit: string, displayDecimalPlaces: number } | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null }> | null } | null };

export type CreateReportMutationVariables = Exact<{
  input: CreateReportInput;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport: { __typename?: 'Report', id: string } };

export type SerialRangesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type SerialRangesQuery = { __typename?: 'Query', serialRanges?: { __typename?: 'SerialRangesConnection', nodes?: Array<{ __typename?: 'SerialRange', id: string, createdAt: string, startNumber: number, endNumber: number, nextAvailable: number, buildStartDate: string, buildEndDate?: string | null, buildDescription: string, firmwareVersion?: string | null, notes?: string | null, productType?: { __typename?: 'ProductType', id: string, createdAt: string, name: string, code: string, location: string, model: string, subType: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CreateSerialRangeMutationVariables = Exact<{
  input: CreateSerialRangeInput;
}>;


export type CreateSerialRangeMutation = { __typename?: 'Mutation', createSerialRange: { __typename?: 'SerialRange', id: string } };

export type UpdateSerialRangeMutationVariables = Exact<{
  input: UpdateSerialRangeInput;
}>;


export type UpdateSerialRangeMutation = { __typename?: 'Mutation', updateSerialRange?: { __typename?: 'SerialRange', id: string } | null };

export type SoilSampleQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type SoilSampleQuery = { __typename?: 'Query', soilSample?: { __typename?: 'SoilSample', id: string, createdAt: string, updatedAt: string, name: string, isReferenceZone: boolean, moisture?: MoistureLevel | null, season?: Season | null, sampleDate?: any | null, strawRemoved: boolean, fym: boolean, coverCrop?: { __typename?: 'CoverCrop', id: string, name: string } | null, cropType?: { __typename?: 'CropType', id: string, name: string } | null, lastYearCrop?: { __typename?: 'Crop', id: string, name: string } | null, yearBeforeLastCrop?: { __typename?: 'Crop', id: string, name: string } | null, soilType?: { __typename?: 'SoilType', id: string, name: string } | null, cultivation?: { __typename?: 'Cultivation', id: string, name: string } | null, labResults?: { __typename?: 'LabResultsConnection', nodes?: Array<{ __typename?: 'LabResult', id: string, value: string, laboratory?: { __typename?: 'Laboratory', id: string, name: string } | null, indicator?: { __typename?: 'LabIndicatorDefinition', id: string, name: string, unit: string, valueType: LabIndicatorValueType } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type SoilSamplesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<SoilSampleFilterInput>;
  order?: InputMaybe<Array<SoilSampleSortInput> | SoilSampleSortInput>;
}>;


export type SoilSamplesQuery = { __typename?: 'Query', soilSamples?: { __typename?: 'SoilSamplesConnection', nodes?: Array<{ __typename?: 'SoilSample', id: string, name: string, createdAt: string, updatedAt: string, labResults?: { __typename?: 'LabResultsConnection', nodes?: Array<{ __typename?: 'LabResult', id: string, value: string, laboratory?: { __typename?: 'Laboratory', id: string, name: string } | null, indicator?: { __typename?: 'LabIndicatorDefinition', id: string, name: string, unit: string, valueType: LabIndicatorValueType } | null }> | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type UpdateSoilSampleMutationVariables = Exact<{
  input: UpdateSoilSampleInput;
}>;


export type UpdateSoilSampleMutation = { __typename?: 'Mutation', updateSoilSample?: { __typename?: 'SoilSample', id: string, createdAt: string, updatedAt: string, name: string, isReferenceZone: boolean, moisture?: MoistureLevel | null, season?: Season | null, sampleDate?: any | null, strawRemoved: boolean, fym: boolean, coverCrop?: { __typename?: 'CoverCrop', id: string, name: string } | null, cropType?: { __typename?: 'CropType', id: string, name: string } | null, lastYearCrop?: { __typename?: 'Crop', id: string, name: string } | null, yearBeforeLastCrop?: { __typename?: 'Crop', id: string, name: string } | null, soilType?: { __typename?: 'SoilType', id: string, name: string } | null, cultivation?: { __typename?: 'Cultivation', id: string, name: string } | null, labResults?: { __typename?: 'LabResultsConnection', nodes?: Array<{ __typename?: 'LabResult', id: string, value: string, laboratory?: { __typename?: 'Laboratory', id: string, name: string } | null, indicator?: { __typename?: 'LabIndicatorDefinition', id: string, name: string, unit: string, valueType: LabIndicatorValueType } | null }> | null } | null } | null };

export type CreateSoilSampleMutationVariables = Exact<{
  input: CreateSoilSampleInput;
}>;


export type CreateSoilSampleMutation = { __typename?: 'Mutation', createSoilSample: { __typename?: 'SoilSample', id: string, createdAt: string, updatedAt: string, name: string, isReferenceZone: boolean, moisture?: MoistureLevel | null, season?: Season | null, sampleDate?: any | null, strawRemoved: boolean, fym: boolean, coverCrop?: { __typename?: 'CoverCrop', id: string, name: string } | null, cropType?: { __typename?: 'CropType', id: string, name: string } | null, lastYearCrop?: { __typename?: 'Crop', id: string, name: string } | null, yearBeforeLastCrop?: { __typename?: 'Crop', id: string, name: string } | null, soilType?: { __typename?: 'SoilType', id: string, name: string } | null, cultivation?: { __typename?: 'Cultivation', id: string, name: string } | null, labResults?: { __typename?: 'LabResultsConnection', nodes?: Array<{ __typename?: 'LabResult', id: string, value: string, laboratory?: { __typename?: 'Laboratory', id: string, name: string } | null, indicator?: { __typename?: 'LabIndicatorDefinition', id: string, name: string, unit: string, valueType: LabIndicatorValueType } | null }> | null } | null } };

export type SoilTypesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type SoilTypesQuery = { __typename?: 'Query', soilTypes?: { __typename?: 'SoilTypesConnection', nodes?: Array<{ __typename?: 'SoilType', id: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CreateSoilTypeMutationVariables = Exact<{
  input: CreateSoilTypeInput;
}>;


export type CreateSoilTypeMutation = { __typename?: 'Mutation', createSoilType: { __typename?: 'SoilType', id: string, name: string } };

export type TroManagementOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type TroManagementOverviewQuery = { __typename?: 'Query', troManagementOverview: { __typename?: 'TROManagementOverview', tros: Array<{ __typename?: 'TROSummary', id: string, uuid: string, name: string, showTestAlerts: boolean, totalTestCount: number, lastUsedAt?: string | null }>, unknownTros: Array<{ __typename?: 'UnknownTROSummary', uuid: string, totalTestCount: number, lastUsedAt?: string | null }> } };

export type UpdateTroMutationVariables = Exact<{
  input: UpdateTroInput;
}>;


export type UpdateTroMutation = { __typename?: 'Mutation', updateTRO?: { __typename?: 'TRO', id: string, uuid: string, name: string, showTestAlerts: boolean } | null };

export type CreateTroFromUnknownMutationVariables = Exact<{
  input: CreateTroFromUnknownInput;
}>;


export type CreateTroFromUnknownMutation = { __typename?: 'Mutation', createTROFromUnknown: { __typename?: 'TRO', id: string, uuid: string, name: string, showTestAlerts: boolean } };

export type UpdateTrainedIndicatorMutationVariables = Exact<{
  input: UpdateTrainedIndicatorInput;
}>;


export type UpdateTrainedIndicatorMutation = { __typename?: 'Mutation', updateTrainedIndicator?: { __typename?: 'TrainedIndicator', id: string, minValue: number, maxValue: number, inferenceModelName?: string | null } | null };

export type CopyTrainedIndicatorMutationVariables = Exact<{
  input: CopyTrainedIndicatorInput;
}>;


export type CopyTrainedIndicatorMutation = { __typename?: 'Mutation', copyTrainedIndicator?: { __typename?: 'TrainedIndicator', id: string, name: string, inferenceModelName?: string | null, minValue: number, maxValue: number } | null };

export type DeleteTrainedIndicatorMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteTrainedIndicatorMutation = { __typename?: 'Mutation', deleteTrainedIndicator: boolean };

export type CreateTrainedIndicatorMutationVariables = Exact<{
  input: CreateTrainedIndicatorInput;
}>;


export type CreateTrainedIndicatorMutation = { __typename?: 'Mutation', createTrainedIndicator: { __typename?: 'TrainedIndicator', id: string, name: string, inferenceModelName?: string | null, maxValue: number, minValue: number, model?: { __typename?: 'MLModel', id: string } | null } };

export type GetUsersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<UserFilterInput>;
  order?: InputMaybe<Array<UserSortInput> | UserSortInput>;
  role?: InputMaybe<Scalars['String']>;
  organisationId?: InputMaybe<Scalars['UUID']>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', nodes?: Array<{ __typename?: 'User', id: string, email?: string | null, fullName?: string | null, createdAt: string, roles: Array<string>, organisationMemberships: Array<{ __typename?: 'Organisation', id: string, name: string }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type ImpersonateUserQueryVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type ImpersonateUserQuery = { __typename?: 'Query', impersonateUser: string };

export type AdminSetUserPasswordMutationVariables = Exact<{
  input: AdminSetUserPasswordInput;
}>;


export type AdminSetUserPasswordMutation = { __typename?: 'Mutation', adminSetUserPassword: boolean };

export type AssignableRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type AssignableRolesQuery = { __typename?: 'Query', assignableRoles: Array<string> };

export type SetUserRoleMutationVariables = Exact<{
  input: SetUserRoleInput;
}>;


export type SetUserRoleMutation = { __typename?: 'Mutation', setUserRole?: { __typename?: 'User', id: string, roles: Array<string> } | null };


export const AuditLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuditLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"occurredFrom"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"occurredTo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auditLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"actionType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionType"}}},{"kind":"Argument","name":{"kind":"Name","value":"occurredFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"occurredFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"occurredTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"occurredTo"}}},{"kind":"Argument","name":{"kind":"Name","value":"userName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"targetEntityType"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"actingUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<AuditLogsQuery, AuditLogsQueryVariables>;
export const AuditLogActionTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuditLogActionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auditLogActionTypes"}}]}}]} as unknown as DocumentNode<AuditLogActionTypesQuery, AuditLogActionTypesQueryVariables>;
export const RequestMagicLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestMagicLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestMagicLinkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestMagicLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<RequestMagicLinkMutation, RequestMagicLinkMutationVariables>;
export const RedeemMagicLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RedeemMagicLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RedeemMagicLinkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redeemMagicLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<RedeemMagicLinkMutation, RedeemMagicLinkMutationVariables>;
export const LoginWithPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginWithPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginWithPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginWithPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<LoginWithPasswordMutation, LoginWithPasswordMutationVariables>;
export const RequestPasswordResetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestPasswordReset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestPasswordResetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestPasswordReset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const ResetPasswordWithCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetPasswordWithCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResetPasswordWithCodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPasswordWithCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ResetPasswordWithCodeMutation, ResetPasswordWithCodeMutationVariables>;
export const SetOwnPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetOwnPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetOwnPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setOwnPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SetOwnPasswordMutation, SetOwnPasswordMutationVariables>;
export const ChangeOwnPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeOwnPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeOwnPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeOwnPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ChangeOwnPasswordMutation, ChangeOwnPasswordMutationVariables>;
export const PasswordAuthStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PasswordAuthStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"passwordAuthStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}}]}}]}}]} as unknown as DocumentNode<PasswordAuthStatusQuery, PasswordAuthStatusQueryVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Me"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"organisations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const BackgroundJobStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BackgroundJobStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backgroundJobStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processingCount"}},{"kind":"Field","name":{"kind":"Name","value":"queuedCount"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledCount"}},{"kind":"Field","name":{"kind":"Name","value":"processingJobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"methodType"}},{"kind":"Field","name":{"kind":"Name","value":"queue"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"elapsedSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"averageDurationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"etaSeconds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"queuedByType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"methodType"}},{"kind":"Field","name":{"kind":"Name","value":"queue"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"nextScheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"averageDurationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedTotalDurationSeconds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"predictionBacklog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queuedPredictionCount"}},{"kind":"Field","name":{"kind":"Name","value":"runningPredictionCount"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveWorkerSlots"}},{"kind":"Field","name":{"kind":"Name","value":"averagePredictionDurationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedWaitSeconds"}}]}}]}}]}}]} as unknown as DocumentNode<BackgroundJobStatusQuery, BackgroundJobStatusQueryVariables>;
export const QueueBackgroundJobDelayTestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"QueueBackgroundJobDelayTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queueBackgroundJobDelayTest"}}]}}]} as unknown as DocumentNode<QueueBackgroundJobDelayTestMutation, QueueBackgroundJobDelayTestMutationVariables>;
export const QueueBackgroundJobPredictionDelayTestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"QueueBackgroundJobPredictionDelayTest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queueBackgroundJobPredictionDelayTest"}}]}}]} as unknown as DocumentNode<QueueBackgroundJobPredictionDelayTestMutation, QueueBackgroundJobPredictionDelayTestMutationVariables>;
export const BatchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Batches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"batchNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<BatchesQuery, BatchesQueryVariables>;
export const CreateBatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBatchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBatch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"batchNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<CreateBatchMutation, CreateBatchMutationVariables>;
export const UpdateBatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBatchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBatch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"batchNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<UpdateBatchMutation, UpdateBatchMutationVariables>;
export const CassettesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Cassettes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cassetteListSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provisionedCount"}},{"kind":"Field","name":{"kind":"Name","value":"allocatedCustomerTests"}},{"kind":"Field","name":{"kind":"Name","value":"remainingCustomerTests"}},{"kind":"Field","name":{"kind":"Name","value":"openOverflowWarningCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cassettes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"numSensors"}},{"kind":"Field","name":{"kind":"Name","value":"manufactureDate"}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"goodSensorCount"}},{"kind":"Field","name":{"kind":"Name","value":"badSensorCount"}},{"kind":"Field","name":{"kind":"Name","value":"allocatedCustomerTests"}},{"kind":"Field","name":{"kind":"Name","value":"usedCustomerTests"}},{"kind":"Field","name":{"kind":"Name","value":"remainingCustomerTests"}},{"kind":"Field","name":{"kind":"Name","value":"physicalSensorsUsed"}},{"kind":"Field","name":{"kind":"Name","value":"remainingPhysicalSensors"}},{"kind":"Field","name":{"kind":"Name","value":"openOverflowRequestedTests"}},{"kind":"Field","name":{"kind":"Name","value":"hasOpenOverflowWarning"}},{"kind":"Field","name":{"kind":"Name","value":"lastUsedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"usedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"range"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<CassettesQuery, CassettesQueryVariables>;
export const CassetteDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CassetteDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"afterEntitlementAdjustments"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstEntitlementAdjustments"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"afterOverflowRequests"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstOverflowRequests"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cassette"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"numSensors"}},{"kind":"Field","name":{"kind":"Name","value":"manufactureDate"}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"maxIndexTimeSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"sensorCheckUuid"}},{"kind":"Field","name":{"kind":"Name","value":"soilTestUuid"}},{"kind":"Field","name":{"kind":"Name","value":"goodSensorCount"}},{"kind":"Field","name":{"kind":"Name","value":"badSensorCount"}},{"kind":"Field","name":{"kind":"Name","value":"baseCustomerTests"}},{"kind":"Field","name":{"kind":"Name","value":"manualCustomerTestAdjustments"}},{"kind":"Field","name":{"kind":"Name","value":"allocatedCustomerTests"}},{"kind":"Field","name":{"kind":"Name","value":"usedCustomerTests"}},{"kind":"Field","name":{"kind":"Name","value":"remainingCustomerTests"}},{"kind":"Field","name":{"kind":"Name","value":"physicalSensorsUsed"}},{"kind":"Field","name":{"kind":"Name","value":"remainingPhysicalSensors"}},{"kind":"Field","name":{"kind":"Name","value":"currentCassetteExtraAllocatableTests"}},{"kind":"Field","name":{"kind":"Name","value":"openOverflowRequestedTests"}},{"kind":"Field","name":{"kind":"Name","value":"hasOpenOverflowWarning"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"range"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entitlementAdjustments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstEntitlementAdjustments"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"afterEntitlementAdjustments"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customerTestDelta"}},{"kind":"Field","name":{"kind":"Name","value":"reasonCode"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"overflowRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstOverflowRequests"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"afterOverflowRequests"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"requestedTests"}},{"kind":"Field","name":{"kind":"Name","value":"outstandingTests"}},{"kind":"Field","name":{"kind":"Name","value":"reasonCode"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CassetteDetailQuery, CassetteDetailQueryVariables>;
export const OpenCassetteOverflowRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OpenCassetteOverflowRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludingCassetteId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openCassetteOverflowRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"excludingCassetteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludingCassetteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"requestedTests"}},{"kind":"Field","name":{"kind":"Name","value":"outstandingTests"}},{"kind":"Field","name":{"kind":"Name","value":"reasonCode"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"cassette"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"range"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<OpenCassetteOverflowRequestsQuery, OpenCassetteOverflowRequestsQueryVariables>;
export const AddCassetteEntitlementAdjustmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddCassetteEntitlementAdjustment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddCassetteEntitlementAdjustmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addCassetteEntitlementAdjustment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customerTestDelta"}},{"kind":"Field","name":{"kind":"Name","value":"reasonCode"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<AddCassetteEntitlementAdjustmentMutation, AddCassetteEntitlementAdjustmentMutationVariables>;
export const CreateCassetteOverflowRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCassetteOverflowRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCassetteOverflowRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCassetteOverflowRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"requestedTests"}},{"kind":"Field","name":{"kind":"Name","value":"outstandingTests"}},{"kind":"Field","name":{"kind":"Name","value":"reasonCode"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<CreateCassetteOverflowRequestMutation, CreateCassetteOverflowRequestMutationVariables>;
export const FulfilCassetteOverflowRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FulfilCassetteOverflowRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FulfilCassetteOverflowRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fulfilCassetteOverflowRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"requestedTests"}},{"kind":"Field","name":{"kind":"Name","value":"outstandingTests"}},{"kind":"Field","name":{"kind":"Name","value":"reasonCode"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<FulfilCassetteOverflowRequestMutation, FulfilCassetteOverflowRequestMutationVariables>;
export const CoverCropsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CoverCrops"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coverCrops"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<CoverCropsQuery, CoverCropsQueryVariables>;
export const CreateCoverCropDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCoverCrop"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCoverCropInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCoverCrop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateCoverCropMutation, CreateCoverCropMutationVariables>;
export const CropsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Crops"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crops"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<CropsQuery, CropsQueryVariables>;
export const CreateCropDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCrop"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCropInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCrop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateCropMutation, CreateCropMutationVariables>;
export const CropTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CropTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cropTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<CropTypesQuery, CropTypesQueryVariables>;
export const CreateCropTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCropType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCropTypeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCropType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateCropTypeMutation, CreateCropTypeMutationVariables>;
export const CultivationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Cultivations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cultivations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<CultivationsQuery, CultivationsQueryVariables>;
export const CreateCultivationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCultivation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCultivationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCultivation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateCultivationMutation, CreateCultivationMutationVariables>;
export const CustomersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Customers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"contactPhone"}},{"kind":"Field","name":{"kind":"Name","value":"customerSince"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"limitIndicators"}},{"kind":"Field","name":{"kind":"Name","value":"allowedIndicatorDefinitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"erus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cassettes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"remainingCustomerTests"}},{"kind":"Field","name":{"kind":"Name","value":"remainingPhysicalSensors"}},{"kind":"Field","name":{"kind":"Name","value":"hasOpenOverflowWarning"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"range"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<CustomersQuery, CustomersQueryVariables>;
export const GetCustomerOrganisationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCustomerOrganisations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCustomerOrganisationsQuery, GetCustomerOrganisationsQueryVariables>;
export const GetCustomerErusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCustomerErus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"erus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCustomerErusQuery, GetCustomerErusQueryVariables>;
export const GetCustomerCassettesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCustomerCassettes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cassettes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"remainingCustomerTests"}},{"kind":"Field","name":{"kind":"Name","value":"remainingPhysicalSensors"}},{"kind":"Field","name":{"kind":"Name","value":"hasOpenOverflowWarning"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"range"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCustomerCassettesQuery, GetCustomerCassettesQueryVariables>;
export const GetCustomerByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCustomerById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"contactPhone"}},{"kind":"Field","name":{"kind":"Name","value":"customerSince"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"limitIndicators"}},{"kind":"Field","name":{"kind":"Name","value":"allowedIndicatorDefinitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"erus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cassettes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"remainingCustomerTests"}},{"kind":"Field","name":{"kind":"Name","value":"remainingPhysicalSensors"}},{"kind":"Field","name":{"kind":"Name","value":"hasOpenOverflowWarning"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"range"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>;
export const DashboardCustomersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardCustomers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organisations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<DashboardCustomersQuery, DashboardCustomersQueryVariables>;
export const CreateCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCustomerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"contactPhone"}},{"kind":"Field","name":{"kind":"Name","value":"customerSince"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const UpdateCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCustomerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"contactPhone"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"limitIndicators"}},{"kind":"Field","name":{"kind":"Name","value":"allowedIndicatorDefinitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const DeleteCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteCustomerMutation, DeleteCustomerMutationVariables>;
export const DashboardStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"previousStartDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"previousEndDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includedOrganisationIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludedOrganisationIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardStats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"previousStartDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"previousStartDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"previousEndDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"previousEndDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"includedOrganisationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includedOrganisationIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"excludedOrganisationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludedOrganisationIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"soilTests"}},{"kind":"Field","name":{"kind":"Name","value":"successfulSensorChecks"}},{"kind":"Field","name":{"kind":"Name","value":"failedSensorChecks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previousPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"soilTests"}},{"kind":"Field","name":{"kind":"Name","value":"successfulSensorChecks"}},{"kind":"Field","name":{"kind":"Name","value":"failedSensorChecks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisationId"}},{"kind":"Field","name":{"kind":"Name","value":"organisationName"}},{"kind":"Field","name":{"kind":"Name","value":"soilTests"}},{"kind":"Field","name":{"kind":"Name","value":"successfulSensorChecks"}},{"kind":"Field","name":{"kind":"Name","value":"failedSensorChecks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mapPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testId"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"what3Words"}},{"kind":"Field","name":{"kind":"Name","value":"testName"}},{"kind":"Field","name":{"kind":"Name","value":"organisationName"}}]}}]}}]}}]} as unknown as DocumentNode<DashboardStatsQuery, DashboardStatsQueryVariables>;
export const DuplicatedLabResultsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DuplicatedLabResultsCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duplicatedLabResultsCount"}}]}}]} as unknown as DocumentNode<DuplicatedLabResultsCountQuery, DuplicatedLabResultsCountQueryVariables>;
export const DedupeLabResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DedupeLabResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dedupeLabResults"}}]}}]} as unknown as DocumentNode<DedupeLabResultsMutation, DedupeLabResultsMutationVariables>;
export const ErUsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ERUs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"erus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<ErUsQuery, ErUsQueryVariables>;
export const FarmsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"farms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"farms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<FarmsQuery, FarmsQueryVariables>;
export const FeatureExtractionExportRunsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FeatureExtractionExportRuns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureExtractionExportRuns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"troUuid"}},{"kind":"Field","name":{"kind":"Name","value":"featureSetVersion"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"testLimit"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"requestedByEmail"}},{"kind":"Field","name":{"kind":"Name","value":"totalTestCount"}},{"kind":"Field","name":{"kind":"Name","value":"excludedTestCount"}},{"kind":"Field","name":{"kind":"Name","value":"reusedCacheCount"}},{"kind":"Field","name":{"kind":"Name","value":"queuedExtractionCount"}},{"kind":"Field","name":{"kind":"Name","value":"completedExtractionCount"}},{"kind":"Field","name":{"kind":"Name","value":"failedExtractionCount"}},{"kind":"Field","name":{"kind":"Name","value":"labResultWarningCount"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"errorSummary"}},{"kind":"Field","name":{"kind":"Name","value":"csvSizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"csvRowCount"}},{"kind":"Field","name":{"kind":"Name","value":"csvColumnCount"}},{"kind":"Field","name":{"kind":"Name","value":"downloadState"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<FeatureExtractionExportRunsQuery, FeatureExtractionExportRunsQueryVariables>;
export const FeatureExtractionExportRunDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FeatureExtractionExportRun"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureExtractionExportRun"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"troUuid"}},{"kind":"Field","name":{"kind":"Name","value":"featureSetVersion"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"testLimit"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"requestedByEmail"}},{"kind":"Field","name":{"kind":"Name","value":"totalTestCount"}},{"kind":"Field","name":{"kind":"Name","value":"excludedTestCount"}},{"kind":"Field","name":{"kind":"Name","value":"reusedCacheCount"}},{"kind":"Field","name":{"kind":"Name","value":"queuedExtractionCount"}},{"kind":"Field","name":{"kind":"Name","value":"completedExtractionCount"}},{"kind":"Field","name":{"kind":"Name","value":"failedExtractionCount"}},{"kind":"Field","name":{"kind":"Name","value":"labResultWarningCount"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"errorSummary"}},{"kind":"Field","name":{"kind":"Name","value":"csvSizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"csvRowCount"}},{"kind":"Field","name":{"kind":"Name","value":"csvColumnCount"}},{"kind":"Field","name":{"kind":"Name","value":"downloadState"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"failedItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"testId"}},{"kind":"Field","name":{"kind":"Name","value":"testName"}},{"kind":"Field","name":{"kind":"Name","value":"attemptCount"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FeatureExtractionExportRunQuery, FeatureExtractionExportRunQueryVariables>;
export const StartFeatureExtractionExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartFeatureExtractionExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StartFeatureExtractionExportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startFeatureExtractionExport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"troUuid"}},{"kind":"Field","name":{"kind":"Name","value":"featureSetVersion"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"testLimit"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<StartFeatureExtractionExportMutation, StartFeatureExtractionExportMutationVariables>;
export const FeatureExtractionExportDownloadUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FeatureExtractionExportDownloadUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureExtractionExportDownloadUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}}]}}]} as unknown as DocumentNode<FeatureExtractionExportDownloadUrlMutation, FeatureExtractionExportDownloadUrlMutationVariables>;
export const FieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"farm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<FieldsQuery, FieldsQueryVariables>;
export const FieldsForFarmDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fieldsForFarm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"farmId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"farm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"farmId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FieldsForFarmQuery, FieldsForFarmQueryVariables>;
export const FirmwareVersionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FirmwareVersions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firmwareVersions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"byteLength"}},{"kind":"Field","name":{"kind":"Name","value":"sha256"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"installCount"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<FirmwareVersionsQuery, FirmwareVersionsQueryVariables>;
export const FirmwareInstallLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FirmwareInstallLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firmwareInstallLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"eruName"}},{"kind":"Field","name":{"kind":"Name","value":"runtimePortName"}},{"kind":"Field","name":{"kind":"Name","value":"runtimeSerialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"runtimeProductId"}},{"kind":"Field","name":{"kind":"Name","value":"dfuSerialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"dfuProductId"}},{"kind":"Field","name":{"kind":"Name","value":"fromVersion"}},{"kind":"Field","name":{"kind":"Name","value":"toVersion"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"technicalLog"}},{"kind":"Field","name":{"kind":"Name","value":"firmwareVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eru"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bleId"}},{"kind":"Field","name":{"kind":"Name","value":"bleMac"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<FirmwareInstallLogsQuery, FirmwareInstallLogsQueryVariables>;
export const UploadFirmwareDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadFirmware"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadFirmwareInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadFirmware"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]} as unknown as DocumentNode<UploadFirmwareMutation, UploadFirmwareMutationVariables>;
export const SetActiveFirmwareVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetActiveFirmwareVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setActiveFirmwareVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]} as unknown as DocumentNode<SetActiveFirmwareVersionMutation, SetActiveFirmwareVersionMutationVariables>;
export const LabIndicatorDefinitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LabIndicatorDefinition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labIndicatorDefinition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"alwaysShow"}}]}}]}}]} as unknown as DocumentNode<LabIndicatorDefinitionQuery, LabIndicatorDefinitionQueryVariables>;
export const LabIndicatorDefinitionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LabIndicatorDefinitions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labIndicatorDefinitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"alwaysShow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<LabIndicatorDefinitionsQuery, LabIndicatorDefinitionsQueryVariables>;
export const CreateLabIndicatorDefinitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLabIndicatorDefinition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateLabIndicatorDefinitionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLabIndicatorDefinition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"alwaysShow"}}]}}]}}]} as unknown as DocumentNode<CreateLabIndicatorDefinitionMutation, CreateLabIndicatorDefinitionMutationVariables>;
export const LabResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LabResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"laboratory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"indicator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"soilSample"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<LabResultQuery, LabResultQueryVariables>;
export const CreateLabResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLabResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateLabResultInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLabResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"laboratory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"indicator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"soilSample"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<CreateLabResultMutation, CreateLabResultMutationVariables>;
export const UpdateLabResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLabResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLabResultInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLabResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"laboratory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"indicator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"soilSample"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<UpdateLabResultMutation, UpdateLabResultMutationVariables>;
export const LaboratoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Laboratories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"laboratories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<LaboratoriesQuery, LaboratoriesQueryVariables>;
export const CreateLaboratoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLaboratory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateLaboratoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLaboratory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<CreateLaboratoryMutation, CreateLaboratoryMutationVariables>;
export const LocalisationAdminOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocalisationAdminOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"localisationAdminOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabledLocales"}},{"kind":"Field","name":{"kind":"Name","value":"enabledLocaleSummaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"setupStatus"}},{"kind":"Field","name":{"kind":"Name","value":"setupFailureMessage"}},{"kind":"Field","name":{"kind":"Name","value":"setupUpdatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseEntryCount"}},{"kind":"Field","name":{"kind":"Name","value":"targetLocaleCount"}},{"kind":"Field","name":{"kind":"Name","value":"targetLocales"}},{"kind":"Field","name":{"kind":"Name","value":"translationContext"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"setupStatus"}},{"kind":"Field","name":{"kind":"Name","value":"setupFailureMessage"}},{"kind":"Field","name":{"kind":"Name","value":"setupUpdatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<LocalisationAdminOverviewQuery, LocalisationAdminOverviewQueryVariables>;
export const LocalisationEditorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocalisationEditor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"localisationEditor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"rows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"baseValue"}},{"kind":"Field","name":{"kind":"Name","value":"targetValue"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveValue"}},{"kind":"Field","name":{"kind":"Name","value":"isFallback"}},{"kind":"Field","name":{"kind":"Name","value":"isApproved"}},{"kind":"Field","name":{"kind":"Name","value":"isTranslating"}}]}}]}}]}}]} as unknown as DocumentNode<LocalisationEditorQuery, LocalisationEditorQueryVariables>;
export const CreateLocalisationFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLocalisationFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateLocalisationFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLocalisationFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseEntryCount"}},{"kind":"Field","name":{"kind":"Name","value":"targetLocaleCount"}},{"kind":"Field","name":{"kind":"Name","value":"targetLocales"}},{"kind":"Field","name":{"kind":"Name","value":"translationContext"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<CreateLocalisationFileMutation, CreateLocalisationFileMutationVariables>;
export const UpdateLocalisationFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLocalisationFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLocalisationFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLocalisationFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseEntryCount"}},{"kind":"Field","name":{"kind":"Name","value":"targetLocaleCount"}},{"kind":"Field","name":{"kind":"Name","value":"targetLocales"}},{"kind":"Field","name":{"kind":"Name","value":"translationContext"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpdateLocalisationFileMutation, UpdateLocalisationFileMutationVariables>;
export const AddLocalisationTargetLocaleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddLocalisationTargetLocale"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddLocalisationTargetLocaleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addLocalisationTargetLocale"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseEntryCount"}},{"kind":"Field","name":{"kind":"Name","value":"targetLocaleCount"}},{"kind":"Field","name":{"kind":"Name","value":"targetLocales"}},{"kind":"Field","name":{"kind":"Name","value":"translationContext"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<AddLocalisationTargetLocaleMutation, AddLocalisationTargetLocaleMutationVariables>;
export const UpdateLocalisationTranslationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLocalisationTranslation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLocalisationTranslationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLocalisationTranslation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateLocalisationTranslationMutation, UpdateLocalisationTranslationMutationVariables>;
export const QueueLocalisationTranslationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"QueueLocalisationTranslation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueueLocalisationTranslationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queueLocalisationTranslation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<QueueLocalisationTranslationMutation, QueueLocalisationTranslationMutationVariables>;
export const SetLocalisationLocaleEnabledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetLocalisationLocaleEnabled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetLocalisationLocaleEnabledInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setLocalisationLocaleEnabled"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}}]} as unknown as DocumentNode<SetLocalisationLocaleEnabledMutation, SetLocalisationLocaleEnabledMutationVariables>;
export const MlModelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MlModels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mlModels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"trainedIndicators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"inferenceModelName"}},{"kind":"Field","name":{"kind":"Name","value":"maxValue"}},{"kind":"Field","name":{"kind":"Name","value":"minValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<MlModelsQuery, MlModelsQueryVariables>;
export const OrganisationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Organisations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<OrganisationsQuery, OrganisationsQueryVariables>;
export const PesTestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PesTest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resultsAfter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pesTest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"utcTestTime"}},{"kind":"Field","name":{"kind":"Name","value":"runId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayCropTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"hasResults"}},{"kind":"Field","name":{"kind":"Name","value":"isReferenceZone"}},{"kind":"Field","name":{"kind":"Name","value":"testType"}},{"kind":"Field","name":{"kind":"Name","value":"isFailure"}},{"kind":"Field","name":{"kind":"Name","value":"failureReasons"}},{"kind":"Field","name":{"kind":"Name","value":"excludeFromMl"}},{"kind":"Field","name":{"kind":"Name","value":"sampleFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"originalModelName"}},{"kind":"Field","name":{"kind":"Name","value":"troUuid"}},{"kind":"Field","name":{"kind":"Name","value":"tro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"organisationMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cropType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"farm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"field"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"what3Words"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"words"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"moisture"}},{"kind":"Field","name":{"kind":"Name","value":"soilTexture"}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"cassette"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"range"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eru"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureCaches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sampleId"}},{"kind":"Field","name":{"kind":"Name","value":"featureSetVersion"}},{"kind":"Field","name":{"kind":"Name","value":"featureCount"}},{"kind":"Field","name":{"kind":"Name","value":"extractedAt"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUri"}},{"kind":"Field","name":{"kind":"Name","value":"payloadSha256"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"warningSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasWarnings"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"messages"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"soilSample"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"what3Words"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"words"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"results"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resultsAfter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"indicator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"minValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxValue"}},{"kind":"Field","name":{"kind":"Name","value":"model"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"indicatorDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PesTestQuery, PesTestQueryVariables>;
export const PesTestFeatureCacheFeaturesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PesTestFeatureCacheFeatures"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pesTest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"featureCaches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"featureMatches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"hasValue"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PesTestFeatureCacheFeaturesQuery, PesTestFeatureCacheFeaturesQueryVariables>;
export const UserPesTestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserPesTest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resultsAfter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pesTest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hasResults"}},{"kind":"Field","name":{"kind":"Name","value":"displayCropTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"isReferenceZone"}},{"kind":"Field","name":{"kind":"Name","value":"cropType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"farm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"field"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"what3Words"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"words"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"moisture"}},{"kind":"Field","name":{"kind":"Name","value":"soilTexture"}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resultsAfter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"indicator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"minValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxValue"}},{"kind":"Field","name":{"kind":"Name","value":"model"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"indicatorDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"displayDecimalPlaces"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserPesTestQuery, UserPesTestQueryVariables>;
export const PesTestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PESTests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PESTestFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PESTestSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pesTests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sampleFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"utcTestTime"}},{"kind":"Field","name":{"kind":"Name","value":"testType"}},{"kind":"Field","name":{"kind":"Name","value":"isFailure"}},{"kind":"Field","name":{"kind":"Name","value":"excludeFromMl"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"what3Words"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"words"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"soilSample"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"farm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"field"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cassette"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"range"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eru"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<PesTestsQuery, PesTestsQueryVariables>;
export const SearchPesTestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchPESTests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PESTestFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PESTestSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pesTests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"utcTestTime"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"testType"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"what3Words"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"words"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isReferenceZone"}},{"kind":"Field","name":{"kind":"Name","value":"farm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"field"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<SearchPesTestsQuery, SearchPesTestsQueryVariables>;
export const UpdateExcludeFromMlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateExcludeFromMl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"testId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"exclude"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateExcludeFromMl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"testId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"testId"}}},{"kind":"Argument","name":{"kind":"Name","value":"exclude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exclude"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"excludeFromMl"}}]}}]}}]} as unknown as DocumentNode<UpdateExcludeFromMlMutation, UpdateExcludeFromMlMutationVariables>;
export const RenamePesTestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RenamePesTest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePesTestNameInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renamePesTest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<RenamePesTestMutation, RenamePesTestMutationVariables>;
export const UpdatePesTestLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePesTestLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePesTestLocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePesTestLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdatePesTestLocationMutation, UpdatePesTestLocationMutationVariables>;
export const UpdatePesTestCharacteristicsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePesTestCharacteristics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePesTestCharacteristicsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePesTestCharacteristics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdatePesTestCharacteristicsMutation, UpdatePesTestCharacteristicsMutationVariables>;
export const MarkTestFailedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkTestFailed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkTestFailedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markTestFailed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isFailure"}},{"kind":"Field","name":{"kind":"Name","value":"failureReasons"}}]}}]}}]} as unknown as DocumentNode<MarkTestFailedMutation, MarkTestFailedMutationVariables>;
export const TransferPesTestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransferPesTest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransferPesTestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transferPesTest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"organisationMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"farm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"field"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<TransferPesTestMutation, TransferPesTestMutationVariables>;
export const DeletePesTestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePesTest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeletePesTestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePESTest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<DeletePesTestMutation, DeletePesTestMutationVariables>;
export const QueuePesTestPredictionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"QueuePesTestPrediction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueuePesTestPredictionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queuePesTestPrediction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<QueuePesTestPredictionMutation, QueuePesTestPredictionMutationVariables>;
export const RecoverPesTestFeatureCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecoverPesTestFeatureCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"testId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recoverPesTestFeatureCache"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"testId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"testId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RecoverPesTestFeatureCacheMutation, RecoverPesTestFeatureCacheMutationVariables>;
export const PurgePesTestFeatureCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PurgePesTestFeatureCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PurgePesTestFeatureCacheInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purgePesTestFeatureCache"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purgedCount"}},{"kind":"Field","name":{"kind":"Name","value":"testIds"}},{"kind":"Field","name":{"kind":"Name","value":"sampleIds"}}]}}]}}]} as unknown as DocumentNode<PurgePesTestFeatureCacheMutation, PurgePesTestFeatureCacheMutationVariables>;
export const PurgePesTestFeatureCachesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PurgePesTestFeatureCaches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PurgePesTestFeatureCachesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purgePesTestFeatureCaches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purgedCount"}},{"kind":"Field","name":{"kind":"Name","value":"testIds"}},{"kind":"Field","name":{"kind":"Name","value":"sampleIds"}}]}}]}}]} as unknown as DocumentNode<PurgePesTestFeatureCachesMutation, PurgePesTestFeatureCachesMutationVariables>;
export const PesTestFeatureCacheOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PesTestFeatureCacheOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pesTestFeatureCacheOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeCacheCount"}},{"kind":"Field","name":{"kind":"Name","value":"activeTestCount"}},{"kind":"Field","name":{"kind":"Name","value":"activeFeatureCount"}},{"kind":"Field","name":{"kind":"Name","value":"lastExtractedAt"}}]}}]}}]} as unknown as DocumentNode<PesTestFeatureCacheOverviewQuery, PesTestFeatureCacheOverviewQueryVariables>;
export const PesTestResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PesTestResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"testId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pesTest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"testId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"indicator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"model"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"indicatorDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"displayDecimalPlaces"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxValue"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PesTestResultsQuery, PesTestResultsQueryVariables>;
export const AdjacentPesTestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdjacentPesTest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PESTestFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PESTestSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pesTests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AdjacentPesTestQuery, AdjacentPesTestQueryVariables>;
export const TransferOrganisationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TransferOrganisations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<TransferOrganisationsQuery, TransferOrganisationsQueryVariables>;
export const TransferFarmsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TransferFarms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisationById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"farms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TransferFarmsQuery, TransferFarmsQueryVariables>;
export const TransferFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TransferFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"farmId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"farm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"farmId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TransferFieldsQuery, TransferFieldsQueryVariables>;
export const PesTestIndicatorLimitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PesTestIndicatorLimit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pesTest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allowedIndicatorDefinitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]} as unknown as DocumentNode<PesTestIndicatorLimitQuery, PesTestIndicatorLimitQueryVariables>;
export const ProductTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"subType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<ProductTypesQuery, ProductTypesQueryVariables>;
export const ReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Report"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReportQuery, ReportQueryVariables>;
export const ReportPesTestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReportPesTests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pesTests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"originalModelName"}},{"kind":"Field","name":{"kind":"Name","value":"isFailure"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"allowedIndicatorDefinitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"what3Words"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"words"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"farm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"field"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"results"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"indicator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"model"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"indicatorDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"displayDecimalPlaces"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReportPesTestsQuery, ReportPesTestsQueryVariables>;
export const CreateReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateReportMutation, CreateReportMutationVariables>;
export const SerialRangesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SerialRanges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serialRanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"startNumber"}},{"kind":"Field","name":{"kind":"Name","value":"endNumber"}},{"kind":"Field","name":{"kind":"Name","value":"nextAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"buildStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"buildEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"buildDescription"}},{"kind":"Field","name":{"kind":"Name","value":"firmwareVersion"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"subType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<SerialRangesQuery, SerialRangesQueryVariables>;
export const CreateSerialRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSerialRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSerialRangeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSerialRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateSerialRangeMutation, CreateSerialRangeMutationVariables>;
export const UpdateSerialRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSerialRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSerialRangeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSerialRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateSerialRangeMutation, UpdateSerialRangeMutationVariables>;
export const SoilSampleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SoilSample"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"soilSample"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isReferenceZone"}},{"kind":"Field","name":{"kind":"Name","value":"moisture"}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"sampleDate"}},{"kind":"Field","name":{"kind":"Name","value":"strawRemoved"}},{"kind":"Field","name":{"kind":"Name","value":"fym"}},{"kind":"Field","name":{"kind":"Name","value":"coverCrop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cropType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastYearCrop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"yearBeforeLastCrop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"soilType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cultivation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"laboratory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"indicator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SoilSampleQuery, SoilSampleQueryVariables>;
export const SoilSamplesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SoilSamples"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SoilSampleFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SoilSampleSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"soilSamples"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"labResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"laboratory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"indicator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<SoilSamplesQuery, SoilSamplesQueryVariables>;
export const UpdateSoilSampleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSoilSample"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSoilSampleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSoilSample"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isReferenceZone"}},{"kind":"Field","name":{"kind":"Name","value":"moisture"}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"sampleDate"}},{"kind":"Field","name":{"kind":"Name","value":"strawRemoved"}},{"kind":"Field","name":{"kind":"Name","value":"fym"}},{"kind":"Field","name":{"kind":"Name","value":"coverCrop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cropType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastYearCrop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"yearBeforeLastCrop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"soilType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cultivation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"laboratory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"indicator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSoilSampleMutation, UpdateSoilSampleMutationVariables>;
export const CreateSoilSampleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSoilSample"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSoilSampleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSoilSample"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isReferenceZone"}},{"kind":"Field","name":{"kind":"Name","value":"moisture"}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"sampleDate"}},{"kind":"Field","name":{"kind":"Name","value":"strawRemoved"}},{"kind":"Field","name":{"kind":"Name","value":"fym"}},{"kind":"Field","name":{"kind":"Name","value":"coverCrop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cropType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastYearCrop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"yearBeforeLastCrop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"soilType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cultivation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"laboratory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"indicator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateSoilSampleMutation, CreateSoilSampleMutationVariables>;
export const SoilTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SoilTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"soilTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<SoilTypesQuery, SoilTypesQueryVariables>;
export const CreateSoilTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSoilType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSoilTypeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSoilType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateSoilTypeMutation, CreateSoilTypeMutationVariables>;
export const TroManagementOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TroManagementOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"troManagementOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tros"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"showTestAlerts"}},{"kind":"Field","name":{"kind":"Name","value":"totalTestCount"}},{"kind":"Field","name":{"kind":"Name","value":"lastUsedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unknownTros"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"totalTestCount"}},{"kind":"Field","name":{"kind":"Name","value":"lastUsedAt"}}]}}]}}]}}]} as unknown as DocumentNode<TroManagementOverviewQuery, TroManagementOverviewQueryVariables>;
export const UpdateTroDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTro"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTROInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTRO"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"showTestAlerts"}}]}}]}}]} as unknown as DocumentNode<UpdateTroMutation, UpdateTroMutationVariables>;
export const CreateTroFromUnknownDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTroFromUnknown"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTROFromUnknownInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTROFromUnknown"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"showTestAlerts"}}]}}]}}]} as unknown as DocumentNode<CreateTroFromUnknownMutation, CreateTroFromUnknownMutationVariables>;
export const UpdateTrainedIndicatorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTrainedIndicator"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTrainedIndicatorInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTrainedIndicator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"minValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxValue"}},{"kind":"Field","name":{"kind":"Name","value":"inferenceModelName"}}]}}]}}]} as unknown as DocumentNode<UpdateTrainedIndicatorMutation, UpdateTrainedIndicatorMutationVariables>;
export const CopyTrainedIndicatorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CopyTrainedIndicator"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CopyTrainedIndicatorInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyTrainedIndicator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"inferenceModelName"}},{"kind":"Field","name":{"kind":"Name","value":"minValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxValue"}}]}}]}}]} as unknown as DocumentNode<CopyTrainedIndicatorMutation, CopyTrainedIndicatorMutationVariables>;
export const DeleteTrainedIndicatorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTrainedIndicator"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTrainedIndicator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteTrainedIndicatorMutation, DeleteTrainedIndicatorMutationVariables>;
export const CreateTrainedIndicatorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTrainedIndicator"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTrainedIndicatorInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTrainedIndicator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"inferenceModelName"}},{"kind":"Field","name":{"kind":"Name","value":"maxValue"}},{"kind":"Field","name":{"kind":"Name","value":"minValue"}},{"kind":"Field","name":{"kind":"Name","value":"model"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTrainedIndicatorMutation, CreateTrainedIndicatorMutationVariables>;
export const GetUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}},{"kind":"Argument","name":{"kind":"Name","value":"organisationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"organisationMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>;
export const ImpersonateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ImpersonateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impersonateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}]}}]} as unknown as DocumentNode<ImpersonateUserQuery, ImpersonateUserQueryVariables>;
export const AdminSetUserPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminSetUserPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminSetUserPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminSetUserPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<AdminSetUserPasswordMutation, AdminSetUserPasswordMutationVariables>;
export const AssignableRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssignableRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignableRoles"}}]}}]} as unknown as DocumentNode<AssignableRolesQuery, AssignableRolesQueryVariables>;
export const SetUserRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetUserRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetUserRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setUserRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}}]}}]}}]} as unknown as DocumentNode<SetUserRoleMutation, SetUserRoleMutationVariables>;